export const reviewEntries = [
  {
    "slug": "whats-in-your-pocket"
  },
  {
    "slug": "what-if-you-could-sniff-like-a-shark"
  },
  {
    "slug": "banana-fox-and-the-secret-sour-society"
  },
  {
    "slug": "everything-awesome-about-sharks"
  },
  {
    "slug": "allergic"
  },
  {
    "slug": "one-small-hop"
  },
  {
    "slug": "finding-home"
  },
  {
    "slug": "lalas-words"
  },
  {
    "slug": "llama-glamarama-and-free-to-be-elephant-me"
  },
  {
    "slug": "ten-animals-in-antarctica"
  },
  {
    "slug": "summertime-sleepers-animals-that-estivate"
  },
  {
    "slug": "we-are-still-here"
  },
  {
    "slug": "we-laugh-alike-juntos-nos-reimos"
  },
  {
    "slug": "the-little-butterfly-that-could"
  },
  {
    "slug": "bracelets-for-binas-brothers"
  },
  {
    "slug": "oh-so-kind"
  },
  {
    "slug": "seaside-stroll"
  },
  {
    "slug": "you-are-enough-a-book-about-inclusion"
  },
  {
    "slug": "elizabeth-queen-of-the-seas"
  },
  {
    "slug": "a-prayer-for-world-peace"
  },
  {
    "slug": "fry-bread"
  },
  {
    "slug": "all-because-you-matter"
  },
  {
    "slug": "poopendous"
  },
  {
    "slug": "hello-my-name-is-ruby"
  },
  {
    "slug": "weird-wild-amazing-exploring-the-incredible-world-of-animals"
  },
  {
    "slug": "whats-the-matter-marlo"
  },
  {
    "slug": "already-a-butterfly-a-meditation-story"
  },
  {
    "slug": "llama-unleashes-the-alpacalypse"
  },
  {
    "slug": "the-unicorn-came-to-dinner"
  },
  {
    "slug": "how-to-speak-dog"
  },
  {
    "slug": "one-little-bag-an-amazing-journey"
  },
  {
    "slug": "aliens-among-us-extraordinary-portraits-of-ordinary-bugs"
  },
  {
    "slug": "white-bird-a-wonder-story"
  },
  {
    "slug": "the-truth-about-hawks"
  },
  {
    "slug": "listen"
  },
  {
    "slug": "if-elephants-disappeared"
  },
  {
    "slug": "between-us-and-abuela"
  },
  {
    "slug": "the-great-big-hug"
  },
  {
    "slug": "plastic-sucks-by-dougie-poynter"
  },
  {
    "slug": "the-help-yourself-cookbook-for-kids-by-ruby-roth"
  },
  {
    "slug": "future-engineer"
  },
  {
    "slug": "now-you-know-what-you-eat"
  },
  {
    "slug": "nic-bishop-big-cats"
  },
  {
    "slug": "tree-of-dreams-by-laura-resau"
  },
  {
    "slug": "out-of-my-shell-by-jenny-goebel"
  },
  {
    "slug": "the-pepper-party-picks-the-perfect-pet"
  },
  {
    "slug": "a-beautiful-day-in-the-neighborhood"
  },
  {
    "slug": "lola-goes-to-school"
  },
  {
    "slug": "plant-powered-protein-cookbook"
  },
  {
    "slug": "even-more-lesser-spotted-animals"
  },
  {
    "slug": "future-astronaut"
  },
  {
    "slug": "the-pout-pout-fish-cleans-up-the-ocean"
  },
  {
    "slug": "the-biggest-little-farm-saving-emma-the-pig"
  },
  {
    "slug": "mountain-chef"
  },
  {
    "slug": "the-happiest-tree-a-story-of-growing-up"
  },
  {
    "slug": "reading-picture-books-with-children"
  },
  {
    "slug": "seashells-more-than-a-home"
  },
  {
    "slug": "bambino-and-mr-twain"
  },
  {
    "slug": "beyond-words-what-elephants-and-whales-think-and-feel"
  },
  {
    "slug": "do-princesses-and-super-heroes-hit-the-trails"
  },
  {
    "slug": "percy-jackson-and-the-olympians-series"
  },
  {
    "slug": "the-kids-outdoor-adventure-book-from-falcon-guides"
  },
  {
    "slug": "how-do-fairies-have-fun-in-the-sun"
  },
  {
    "slug": "the-plantiful-plate-from-the-yommme-kitchen"
  },
  {
    "slug": "where-birdie-lives"
  },
  {
    "slug": "books-for-dog-lovers-of-all-ages"
  },
  {
    "slug": "goodnight-seahorse"
  },
  {
    "slug": "mrs-frisby-and-the-rats-of-nimh"
  },
  {
    "slug": "stef-soto-taco-queen"
  },
  {
    "slug": "not-a-purse"
  },
  {
    "slug": "baby-loves-green-energy"
  },
  {
    "slug": "stretch-to-the-sun-from-a-tiny-sprout-to-the-tallest-tree-in-the-world"
  },
  {
    "slug": "the-truth-about-elephants"
  },
  {
    "slug": "when-you-grow-up-to-vote"
  },
  {
    "slug": "little-otter-learns-to-swim"
  },
  {
    "slug": "wild-orca-the-oldest-wisest-whale-in-the-world"
  },
  {
    "slug": "an-american-tail-1986"
  },
  {
    "slug": "how-many-hugs-and-if-animals-said-i-love-you"
  },
  {
    "slug": "the-creepy-case-files-of-margo-maloo-the-monster-mall"
  },
  {
    "slug": "plant-eat-cook-a-childrens-cookbook"
  },
  {
    "slug": "behold-the-beautiful-dung-beetle"
  },
  {
    "slug": "a-place-to-start-a-family-poems-about-creatures-that-build"
  },
  {
    "slug": "sharks-natures-perfect-hunter"
  },
  {
    "slug": "dr-dolittle-1998-and-dr-dolittle-2-2001"
  },
  {
    "slug": "little-sid-the-tiny-prince-who-became-buddha"
  },
  {
    "slug": "vet-volunteers-book-series"
  },
  {
    "slug": "one-day-a-dot"
  },
  {
    "slug": "star-wars-the-last-jedi-2017"
  },
  {
    "slug": "jane-2017"
  },
  {
    "slug": "bee-movie-2007"
  },
  {
    "slug": "dolphin-tale-2011"
  },
  {
    "slug": "mighty-jack-and-the-goblin-king"
  },
  {
    "slug": "wonder-woman-2017"
  },
  {
    "slug": "dolphin-tale-the-junior-tale"
  },
  {
    "slug": "real-friends"
  },
  {
    "slug": "the-muppet-movie-1979"
  },
  {
    "slug": "artemis-wild-goddess-of-the-hunt"
  },
  {
    "slug": "bats-learning-to-fly"
  },
  {
    "slug": "whats-an-apple-and-whats-a-banana"
  },
  {
    "slug": "dory"
  },
  {
    "slug": "yertle-the-turtle"
  },
  {
    "slug": "the-creepy-case-files-of-margo-maloo"
  },
  {
    "slug": "trolls-2016"
  },
  {
    "slug": "the-wonderful-wizard-of-oz"
  },
  {
    "slug": "santas-first-vegan-christmas"
  },
  {
    "slug": "the-secret-life-of-pets-2016"
  },
  {
    "slug": "mighty-jack"
  },
  {
    "slug": "the-bfg"
  },
  {
    "slug": "the-bfg-2016"
  },
  {
    "slug": "mercy-the-incredible-story-of-henry-bergh-founder-of-the-aspca-and-friend-to-animals"
  },
  {
    "slug": "open-season-2006"
  },
  {
    "slug": "octopuss-garden"
  },
  {
    "slug": "bee-me-an-animotion-experience"
  },
  {
    "slug": "mr-okra-sells-fresh-fruits-and-vegetables"
  },
  {
    "slug": "owen-mzee-the-true-story-of-a-remarkable-friendship"
  },
  {
    "slug": "free-willy-2004"
  },
  {
    "slug": "achoo-why-pollen-counts"
  },
  {
    "slug": "you-read-to-me-ill-read-to-you-very-short-stories-to-read-together"
  },
  {
    "slug": "zootopia-2016"
  },
  {
    "slug": "elephant-journey"
  },
  {
    "slug": "over-on-a-mountain"
  },
  {
    "slug": "herd-your-horses"
  },
  {
    "slug": "here-comes-valentine-cat"
  },
  {
    "slug": "chicken-run-2000"
  },
  {
    "slug": "noisy-bird-sing-along"
  },
  {
    "slug": "the-boy-the-book-a-wordless-story"
  },
  {
    "slug": "high-tide-for-horseshoe-crabs"
  },
  {
    "slug": "the-extraordinary-education-of-nicholas-benedict"
  },
  {
    "slug": "butterfly-counting"
  },
  {
    "slug": "101-dalmatians-1996"
  },
  {
    "slug": "turkey-trouble"
  },
  {
    "slug": "not-a-nugget"
  },
  {
    "slug": "i-am-yoga"
  },
  {
    "slug": "i-am-abraham-lincoln-ordinary-people-change-the-world"
  },
  {
    "slug": "books-vegan-vegetarian-kids-age-6"
  },
  {
    "slug": "human-body-theater"
  },
  {
    "slug": "bunnicula-a-rabbit-tale-of-mystery"
  },
  {
    "slug": "dirty-rats"
  },
  {
    "slug": "alice-in-wonderland-down-the-rabbit-hole"
  },
  {
    "slug": "little-robot"
  },
  {
    "slug": "fable-comics"
  },
  {
    "slug": "zoras-zucchini"
  },
  {
    "slug": "gryphons-arent-so-great"
  },
  {
    "slug": "butterfly-battle-the-magic-school-bus-chapter-book-16-and-food-chain-frenzy-the-magic-school-bus-chapter-book-17"
  },
  {
    "slug": "rhymoceros"
  },
  {
    "slug": "i-love-you-blankie"
  },
  {
    "slug": "lullaby-kisses-sweet-poems-to-love-with-your-baby"
  },
  {
    "slug": "wangari-maathai"
  },
  {
    "slug": "cinderella-2015"
  },
  {
    "slug": "a-penguin-named-patience-a-hurricane-katrina-rescue-story"
  },
  {
    "slug": "martin-mahalia-his-words-her-song"
  },
  {
    "slug": "vegetables-in-underwear"
  },
  {
    "slug": "beautiful-moon-a-childs-prayer"
  },
  {
    "slug": "three-beavers"
  },
  {
    "slug": "apples-bean-dip-and-carrot-cake"
  },
  {
    "slug": "harry-and-the-hendersons-1987"
  },
  {
    "slug": "wild-whale-watch"
  },
  {
    "slug": "planet-kindergarten"
  },
  {
    "slug": "turkey-claus"
  },
  {
    "slug": "gordy-and-the-magic-diet"
  },
  {
    "slug": "book-of-life-2014"
  },
  {
    "slug": "tracks-count"
  },
  {
    "slug": "forest-fire-mystery"
  },
  {
    "slug": "goldy-luck-and-the-three-pandas"
  },
  {
    "slug": "best-books-for-5-year-old-vegan-vegetarian-kids"
  },
  {
    "slug": "just-being-audrey"
  },
  {
    "slug": "mini-myths-play-nice-hercules-be-patient-pandora"
  },
  {
    "slug": "counta-block"
  },
  {
    "slug": "what-is-the-dog-doing"
  },
  {
    "slug": "letters-of-the-west-an-abc-book-of-the-many-plants-animals-and-other-curious-features-of-the-west"
  },
  {
    "slug": "monsters-dont-eat-broccoli"
  },
  {
    "slug": "the-prairie-that-nature-built"
  },
  {
    "slug": "the-dandelion-seeds-big-dream"
  },
  {
    "slug": "lena-of-vegitopia-and-the-mystery-of-the-missing-animals"
  },
  {
    "slug": "hobbes-goes-home"
  },
  {
    "slug": "harry-potter-and-the-sorcerers-stone"
  },
  {
    "slug": "rob-laidlaw-double-feature"
  },
  {
    "slug": "snuggle-the-baby"
  },
  {
    "slug": "a-boy-and-his-jaguar"
  },
  {
    "slug": "montessori-map-work"
  },
  {
    "slug": "julia"
  },
  {
    "slug": "i-am-so-brave"
  },
  {
    "slug": "the-zoo-box"
  },
  {
    "slug": "the-girl-and-the-bicycle"
  },
  {
    "slug": "goldieblox-and-the-spinning-machine"
  },
  {
    "slug": "behold-the-beatiful-dung-beetle"
  },
  {
    "slug": "this-little-piggy"
  },
  {
    "slug": "littons-weekend-adventure"
  },
  {
    "slug": "wild-about-bears"
  },
  {
    "slug": "peep-and-the-big-wide-world"
  },
  {
    "slug": "prickly-rose"
  },
  {
    "slug": "frankenweenie-2012"
  },
  {
    "slug": "the-red-dragon-a-3d-picture-book-with-press-out-disguises"
  },
  {
    "slug": "on-kikis-reef"
  },
  {
    "slug": "little-turtles-big-adventure"
  },
  {
    "slug": "feathers-not-just-for-flying"
  },
  {
    "slug": "posie-pixie-and-the-torn-tunic"
  },
  {
    "slug": "the-mouse-and-the-meadow"
  },
  {
    "slug": "the-swamp-where-gator-hides"
  },
  {
    "slug": "plop-splat-find-an-answer"
  },
  {
    "slug": "i-love-you-just-enough"
  },
  {
    "slug": "sleep-tight-anna-banana"
  },
  {
    "slug": "catching-the-wild-waiyuuzee"
  },
  {
    "slug": "of-course-they-do-boys-and-girls-can-do-anything"
  },
  {
    "slug": "my-first-book-of-baby-animals-and-my-first-book-of-wild-animals"
  },
  {
    "slug": "cloudy-with-a-chance-of-meatballs-2-2013"
  },
  {
    "slug": "isa-does-it"
  },
  {
    "slug": "philip-reid-saves-the-statue-of-freedom"
  },
  {
    "slug": "the-lego-movie-2014"
  },
  {
    "slug": "under-the-freedom-tree"
  },
  {
    "slug": "the-runaway-hug"
  },
  {
    "slug": "in-a-heartbeat"
  },
  {
    "slug": "how-to-be-a-cat"
  },
  {
    "slug": "brown-bear-friends"
  },
  {
    "slug": "little-house-in-the-big-woods"
  },
  {
    "slug": "pattys-secret"
  },
  {
    "slug": "view"
  },
  {
    "slug": "the-dirty-socks-come-clean"
  },
  {
    "slug": "jane-and-the-dragon"
  },
  {
    "slug": "no-animals"
  },
  {
    "slug": "brother-bear"
  },
  {
    "slug": "almost-an-animal-alphabet"
  },
  {
    "slug": "v-is-for-vegan"
  },
  {
    "slug": "dave-loves-chickens"
  },
  {
    "slug": "explorer-the-lost-islands"
  },
  {
    "slug": "you-read-to-me-ill-read-to-you-very-short-fables-to-read-together"
  },
  {
    "slug": "charlottes-web-2006"
  },
  {
    "slug": "charlottes-web"
  },
  {
    "slug": "will"
  },
  {
    "slug": "rock-a-bye-room"
  },
  {
    "slug": "animals-matter"
  },
  {
    "slug": "if-you-decide-to-go-to-the-moon"
  },
  {
    "slug": "feeding-the-young-athlete"
  },
  {
    "slug": "fifty-cents-and-a-dream"
  },
  {
    "slug": "jo-macdonald-hiked-in-the-woods"
  },
  {
    "slug": "buffalo-bird-girl"
  },
  {
    "slug": "love-is-the-color-of-a-rainbow"
  },
  {
    "slug": "mama-donis-jewish-holiday-party"
  },
  {
    "slug": "free-birds"
  },
  {
    "slug": "our-school-garden"
  },
  {
    "slug": "the-prisoner-of-carrot-castle"
  },
  {
    "slug": "our-top-picks-for-4-year-olds"
  },
  {
    "slug": "bronto-friend-of-ceratops"
  },
  {
    "slug": "horse-sanctuary"
  },
  {
    "slug": "balloon-toons-the-super-duper-dog-park"
  },
  {
    "slug": "desert-island-disc"
  },
  {
    "slug": "the-cart-that-carried-martin"
  },
  {
    "slug": "violet"
  },
  {
    "slug": "green-smoothie-magic"
  },
  {
    "slug": "i-know-a-lot"
  },
  {
    "slug": "no-monkeys-no-chocolate"
  },
  {
    "slug": "animals-have-feelings-too"
  },
  {
    "slug": "monster-on-the-hill"
  },
  {
    "slug": "the-five-lives-of-our-cat-zook"
  },
  {
    "slug": "blink"
  },
  {
    "slug": "someones-sleepy"
  },
  {
    "slug": "moon-bear"
  },
  {
    "slug": "hes-been-a-monster-all-day"
  },
  {
    "slug": "paper"
  },
  {
    "slug": "memoirs-of-a-goldfish-and-memoirs-of-a-hamster"
  },
  {
    "slug": "jimmy-the-joey"
  },
  {
    "slug": "steam-train-dream-train"
  },
  {
    "slug": "where-to-sleep"
  },
  {
    "slug": "the-dark"
  },
  {
    "slug": "say-daddy"
  },
  {
    "slug": "kidlicious-fun-healthy-recipes-that-kids-love"
  },
  {
    "slug": "roly-poly-pangolin"
  },
  {
    "slug": "mind-of-my-own"
  },
  {
    "slug": "each-living-thing"
  },
  {
    "slug": "noisy-bug"
  },
  {
    "slug": "the-cats-of-tanglewood-forest"
  },
  {
    "slug": "lobsters-on-the-loose"
  },
  {
    "slug": "sylvias-spinach"
  },
  {
    "slug": "once-upon-a-midnight"
  },
  {
    "slug": "jadhu-ram-and-the-thirsty-forest"
  },
  {
    "slug": "whats-in-the-garden"
  },
  {
    "slug": "a-year-with-friends"
  },
  {
    "slug": "little-acorn-grows-up"
  },
  {
    "slug": "the-adventures-of-penny-the-rhode-island-red"
  },
  {
    "slug": "the-abcs-of-nutrition"
  },
  {
    "slug": "hilda-and-the-bird-parade"
  },
  {
    "slug": "awesome-dawson"
  },
  {
    "slug": "temple"
  },
  {
    "slug": "the-monsters-monster"
  },
  {
    "slug": "a-long-way-away-a-two-way-story"
  },
  {
    "slug": "nighttime-ninja"
  },
  {
    "slug": "penny-and-her-song-and-other-books-in-the-series"
  },
  {
    "slug": "here-come-the-humpbacks"
  },
  {
    "slug": "a-house-in-the-woods"
  },
  {
    "slug": "animal-playground-playful-tracks-from-around-the-world"
  },
  {
    "slug": "finnegan-and-fox-the-ten-foot-cop"
  },
  {
    "slug": "moose-n-me"
  },
  {
    "slug": "one-gorilla"
  },
  {
    "slug": "jaspers-story-saving-moon-bears"
  },
  {
    "slug": "i-love-vegetarian-food"
  },
  {
    "slug": "war-dogs"
  },
  {
    "slug": "otter-and-odder"
  },
  {
    "slug": "i-love-our-earth-amo-nuestra-tierra"
  },
  {
    "slug": "snow-school"
  },
  {
    "slug": "uncle-willie-and-the-soup-kitchen"
  },
  {
    "slug": "look-another-book"
  },
  {
    "slug": "tina-and-the-penguin"
  },
  {
    "slug": "the-boy-who-loved-all-living-things"
  },
  {
    "slug": "martin-de-porres-the-rose-in-the-desert"
  },
  {
    "slug": "elizas-journal"
  },
  {
    "slug": "michael-recycle-saves-christmas"
  },
  {
    "slug": "when-santa-turned-green"
  },
  {
    "slug": "santas-littlest-helper"
  },
  {
    "slug": "hanukkah-oh-hanukkah"
  },
  {
    "slug": "feet-say-yes"
  },
  {
    "slug": "delhi-safari"
  },
  {
    "slug": "treasury-for-all-seasons"
  },
  {
    "slug": "henry-helps-plant-a-garden"
  },
  {
    "slug": "vegan-for-the-holidays"
  },
  {
    "slug": "peaceable-forest-indias-tale-of-kindness-to-animals"
  },
  {
    "slug": "baby-shower-gifts-for-veg-moms"
  },
  {
    "slug": "steven-the-vegan"
  },
  {
    "slug": "tua-and-the-elephant"
  },
  {
    "slug": "i-say-you-say-animal-sounds-and-i-say-you-say-opposites"
  },
  {
    "slug": "three-year-olds"
  },
  {
    "slug": "the-peace-book"
  },
  {
    "slug": "all-the-asleep-animals"
  },
  {
    "slug": "minnys-dream"
  },
  {
    "slug": "the-thankful-book"
  },
  {
    "slug": "love-you-when"
  },
  {
    "slug": "rickie-and-henri"
  },
  {
    "slug": "natures-patchwork-quilt"
  },
  {
    "slug": "apple"
  },
  {
    "slug": "were-sailing-to-galapagos"
  },
  {
    "slug": "pigmares-porcine-poems-of-the-silver-screen"
  },
  {
    "slug": "wholesome-baby-food-guide"
  },
  {
    "slug": "board-book-giveaway-i-say-you-say"
  },
  {
    "slug": "the-secret-world-of-arrietty"
  },
  {
    "slug": "kids-animals"
  },
  {
    "slug": "grannys-clan"
  },
  {
    "slug": "belly-up"
  },
  {
    "slug": "going-home-the-mystery-of-animal-migration"
  },
  {
    "slug": "the-hoboken-chicken-emergency"
  },
  {
    "slug": "presidential-pets"
  },
  {
    "slug": "the-wiener-dog-magnet"
  },
  {
    "slug": "over-in-the-jungle-a-rainforest-rhyme"
  },
  {
    "slug": "christian-the-hugging-lion"
  },
  {
    "slug": "seashells-by-the-seashore"
  },
  {
    "slug": "the-one-and-only-ivan"
  },
  {
    "slug": "city-chickens"
  },
  {
    "slug": "bronto-the-pterodactyl-eggs"
  },
  {
    "slug": "invisible-alligators"
  },
  {
    "slug": "hippopposites"
  },
  {
    "slug": "one-cool-friend"
  },
  {
    "slug": "harmony-on-the-farm"
  },
  {
    "slug": "freda-stops-a-bully-happy-healthy-ajay"
  },
  {
    "slug": "cody-greene-and-the-rainbow-mystery"
  },
  {
    "slug": "a-meal-of-the-stars"
  },
  {
    "slug": "pizza-kittens"
  },
  {
    "slug": "scaredy-squirrel"
  },
  {
    "slug": "ladybug-girl-and-bingo"
  },
  {
    "slug": "the-lorax-2"
  },
  {
    "slug": "click-clack-abc"
  },
  {
    "slug": "the-house-that-baba-built"
  },
  {
    "slug": "one-boy-and-his-dog"
  },
  {
    "slug": "more-more-more-said-the-baby"
  },
  {
    "slug": "if-you-hopped-like-a-frog"
  },
  {
    "slug": "anju"
  },
  {
    "slug": "one-night-in-the-everglades"
  },
  {
    "slug": "stink-city"
  },
  {
    "slug": "the-watcher-jane-goodalls-life-with-the-chimps"
  },
  {
    "slug": "red-knit-cap-girl"
  },
  {
    "slug": "animals-at-play-rules-of-the-game"
  },
  {
    "slug": "every-day-dress-up"
  },
  {
    "slug": "gem"
  },
  {
    "slug": "fandango-stew"
  },
  {
    "slug": "i-wear-my-tutu-everywhere"
  },
  {
    "slug": "turtle-the-incredible-journey"
  },
  {
    "slug": "compost-it"
  },
  {
    "slug": "nancy-clancy-super-sleuth"
  },
  {
    "slug": "tugg-and-teeny"
  },
  {
    "slug": "do-super-heroes-have-teddy-bears"
  },
  {
    "slug": "how-do-birds-find-their-way"
  },
  {
    "slug": "cooking-with-herb-the-vegetarian-dragon"
  },
  {
    "slug": "the-great-cake-mystery"
  },
  {
    "slug": "huff-puff"
  },
  {
    "slug": "vegan-is-love"
  },
  {
    "slug": "forget-me-nots-poems-to-learn-by-heart"
  },
  {
    "slug": "if-all-the-animals-came-inside"
  },
  {
    "slug": "struffel"
  },
  {
    "slug": "momo-come-home"
  },
  {
    "slug": "fancy-nancy-every-day-is-earth-day"
  },
  {
    "slug": "the-great-kapok-tree"
  },
  {
    "slug": "the-environment-challenge"
  },
  {
    "slug": "wild-cats-cougars-bobcats-and-lynx"
  },
  {
    "slug": "endangered-animals-2"
  },
  {
    "slug": "earth-day"
  },
  {
    "slug": "the-vegetable-alphabet-book"
  },
  {
    "slug": "eye-on-the-wild-cheetah-and-gorilla"
  },
  {
    "slug": "sweet-dreams"
  },
  {
    "slug": "peregrines-sky"
  },
  {
    "slug": "only-one-ocean"
  },
  {
    "slug": "the-lorax"
  },
  {
    "slug": "the-great-turkey-race"
  },
  {
    "slug": "something-from-nothing"
  },
  {
    "slug": "simple-pleasures"
  },
  {
    "slug": "little-colts-palm-sunday"
  },
  {
    "slug": "mollys-organic-farm"
  },
  {
    "slug": "manatee-winter"
  },
  {
    "slug": "toby-the-pet-therapy-dog-and-his-hospital-friends"
  },
  {
    "slug": "kalis-song"
  },
  {
    "slug": "old-macdonald"
  },
  {
    "slug": "riding-in-my-car"
  },
  {
    "slug": "vegan-family-cookbook"
  },
  {
    "slug": "meadowlands-a-wetlands-survival-story"
  },
  {
    "slug": "mercy-watson-to-the-rescue"
  },
  {
    "slug": "big-miracle"
  },
  {
    "slug": "over-in-the-forest"
  },
  {
    "slug": "meet-mr-and-mrs-green"
  },
  {
    "slug": "good-dog-aggie"
  },
  {
    "slug": "babe-pig-in-the-city"
  },
  {
    "slug": "piggie-pie"
  },
  {
    "slug": "whos-in-a-family"
  },
  {
    "slug": "emily-and-carlo"
  },
  {
    "slug": "how-chipmunk-got-his-stripes"
  },
  {
    "slug": "jo-macdonald-had-a-garden"
  },
  {
    "slug": "how-to-bring-your-grandmother-to-the-museum"
  },
  {
    "slug": "claude-and-medea"
  },
  {
    "slug": "the-secret-of-nimh"
  },
  {
    "slug": "naamah-and-the-ark-at-night"
  },
  {
    "slug": "the-whales-song"
  },
  {
    "slug": "billie-the-unicorn"
  },
  {
    "slug": "from-trash-to-treasure"
  },
  {
    "slug": "one-more-acorn"
  },
  {
    "slug": "born-to-be-wild"
  },
  {
    "slug": "the-it-doesnt-matter-suit"
  },
  {
    "slug": "all-kinds-of-kisses"
  },
  {
    "slug": "go-diego-go"
  },
  {
    "slug": "kangaroo"
  },
  {
    "slug": "city-life"
  },
  {
    "slug": "hairy-hezekiah"
  },
  {
    "slug": "grow-it-yourself"
  },
  {
    "slug": "fred-eats-a-pea"
  },
  {
    "slug": "vegan-pregnancy-survival-guide"
  },
  {
    "slug": "just-a-second"
  },
  {
    "slug": "tyrannosaurus-drip"
  },
  {
    "slug": "teeny-tiny-ernest"
  },
  {
    "slug": "snow"
  },
  {
    "slug": "wolf-christmas"
  },
  {
    "slug": "the-giant-book-of-giants"
  },
  {
    "slug": "redbird-at-rockefeller-center"
  },
  {
    "slug": "call-me-madame-president"
  },
  {
    "slug": "the-twin-giants"
  },
  {
    "slug": "christmas-kitten-home-at-last"
  },
  {
    "slug": "stickeen-john-muir-and-the-brave-little-dog"
  },
  {
    "slug": "cassandras-angel"
  },
  {
    "slug": "a-starlit-snowfall"
  },
  {
    "slug": "a-christmas-horse-named-cairo"
  },
  {
    "slug": "the-mountain-that-loved-a-bird"
  },
  {
    "slug": "peles-forever-home"
  },
  {
    "slug": "101-ways-to-save-the-planet"
  },
  {
    "slug": "the-vegetarian-lion"
  },
  {
    "slug": "my-milk-toof"
  },
  {
    "slug": "maggies-second-chance"
  },
  {
    "slug": "the-muppets"
  },
  {
    "slug": "i-love-ny-food"
  },
  {
    "slug": "kokeshi-kimonos-book"
  },
  {
    "slug": "all-about-turkeys"
  },
  {
    "slug": "you-be-you"
  },
  {
    "slug": "suryia-and-roscoe"
  },
  {
    "slug": "the-magic-school-bus-goes-upstream"
  },
  {
    "slug": "a-charlie-brown-thanksgiving"
  },
  {
    "slug": "i-want-my-hat-back"
  },
  {
    "slug": "gobble-gobble"
  },
  {
    "slug": "swirl-by-swirl"
  },
  {
    "slug": "the-vegan-slow-cooker"
  },
  {
    "slug": "happy-thanksliving"
  },
  {
    "slug": "turk-and-runt"
  },
  {
    "slug": "mister-seahorse"
  },
  {
    "slug": "re-craft"
  },
  {
    "slug": "stellaluna"
  },
  {
    "slug": "allie-gators-halloween-hayride"
  },
  {
    "slug": "the-octonauts-and-the-great-ghost-reef"
  },
  {
    "slug": "our-baby-turns-two"
  },
  {
    "slug": "jo-macdonald-saw-a-pond"
  },
  {
    "slug": "giant-steps-to-change-the-world"
  },
  {
    "slug": "6210"
  },
  {
    "slug": "on-parade"
  },
  {
    "slug": "no-plain-hair"
  },
  {
    "slug": "animal-aha"
  },
  {
    "slug": "miss-spiders-tea-party"
  },
  {
    "slug": "a-home-for-dakota"
  },
  {
    "slug": "care-bears-to-the-rescue"
  },
  {
    "slug": "uncle-andys-cats"
  },
  {
    "slug": "you-will-be-my-friend"
  },
  {
    "slug": "unos-garden"
  },
  {
    "slug": "the-owly-books"
  },
  {
    "slug": "first-pooch"
  },
  {
    "slug": "naturally-wild-musicians"
  },
  {
    "slug": "the-im-not-scared-book"
  },
  {
    "slug": "houndsley-and-catina"
  },
  {
    "slug": "the-little-island"
  },
  {
    "slug": "the-girl-and-the-elephant"
  },
  {
    "slug": "twist-and-ernest"
  },
  {
    "slug": "lucky-pigs"
  },
  {
    "slug": "sato-and-the-elephants"
  },
  {
    "slug": "pigs-make-me-sneeze"
  },
  {
    "slug": "grin-and-bear-it"
  },
  {
    "slug": "bears-bees-butterflies"
  },
  {
    "slug": "the-lucky-lobsters"
  },
  {
    "slug": "chick-n-pug"
  },
  {
    "slug": "friends-true-stories-of-extraordinary-animal-friendships"
  },
  {
    "slug": "charlie-parker-played-be-bop"
  },
  {
    "slug": "magic-trash"
  },
  {
    "slug": "black-cat"
  },
  {
    "slug": "moonshot-the-flight-of-apollo-11"
  },
  {
    "slug": "chickens-to-the-rescue"
  },
  {
    "slug": "the-substitute-creacher"
  },
  {
    "slug": "fly-free"
  },
  {
    "slug": "the-case-of-the-vanishing-golden-frogs-a-scientific-mystery"
  },
  {
    "slug": "how-to-train-your-dragon"
  },
  {
    "slug": "chickens-arent-the-only-ones"
  },
  {
    "slug": "old-abe-war-hero"
  },
  {
    "slug": "how-things-work-in-the-yard"
  },
  {
    "slug": "the-good-luck-cat"
  },
  {
    "slug": "are-you-eating-something-green"
  },
  {
    "slug": "gracie-the-lighthouse-cat"
  },
  {
    "slug": "bugs-by-the-numbers"
  },
  {
    "slug": "come-and-eat"
  },
  {
    "slug": "eat-your-peas"
  },
  {
    "slug": "whooo-loves-you"
  },
  {
    "slug": "the-story-of-doctor-doolitte"
  },
  {
    "slug": "gowanus-dogs"
  },
  {
    "slug": "living-green"
  },
  {
    "slug": "vegetarian-cooking-for-beginners"
  },
  {
    "slug": "walter-the-farting-dog"
  },
  {
    "slug": "one-red-apple"
  },
  {
    "slug": "garbage-helps-our-garden-grow-a-compost-story"
  },
  {
    "slug": "the-bugabees-friends-with-food-allergies"
  },
  {
    "slug": "gabby-and-grandma-go-green"
  },
  {
    "slug": "flying-free"
  },
  {
    "slug": "buffalo-music"
  },
  {
    "slug": "the-dancing-pig"
  },
  {
    "slug": "mary-had-a-little-lamp"
  },
  {
    "slug": "pale-male-citizen-hawk-of-new-york-city"
  },
  {
    "slug": "animals-charles-darwin-saw-an-around-the-world-adventure"
  },
  {
    "slug": "chicken-said-cluck"
  },
  {
    "slug": "mamas-saris"
  },
  {
    "slug": "bear-ly-there"
  },
  {
    "slug": "a-day-with-no-crayons"
  },
  {
    "slug": "lost-and-found-three-dog-stories"
  },
  {
    "slug": "toad-food-measle-soup"
  },
  {
    "slug": "wheels-of-change"
  },
  {
    "slug": "wave-2"
  },
  {
    "slug": "manfish-a-story-of-jacques-cousteau"
  },
  {
    "slug": "mother-to-tigers"
  },
  {
    "slug": "all-the-seasons-of-the-year"
  },
  {
    "slug": "what-about-daisy"
  },
  {
    "slug": "six-is-so-much-less-than-seven"
  },
  {
    "slug": "say-hello-to-zorro"
  },
  {
    "slug": "hands-growing-up-to-be-an-artist"
  },
  {
    "slug": "me-jane"
  },
  {
    "slug": "beautiful-yetta-the-yiddish-chicken"
  },
  {
    "slug": "hogwash"
  },
  {
    "slug": "gooses-story"
  },
  {
    "slug": "nini-lost-and-found"
  },
  {
    "slug": "the-extraordinary-mark-twain-according-to-susy"
  },
  {
    "slug": "swan-song"
  },
  {
    "slug": "the-book-about-moomin-mymble-and-little-my"
  },
  {
    "slug": "the-day-i-swapped-my-dad-for-two-goldfish"
  },
  {
    "slug": "a-giraffe-goes-to-paris"
  },
  {
    "slug": "the-snail-and-the-whale"
  },
  {
    "slug": "whats-your-sound-hound-the-hound"
  },
  {
    "slug": "the-poky-little-puppy"
  },
  {
    "slug": "making-good-choices-about-renewable-resources"
  },
  {
    "slug": "muncha-muncha-muncha"
  },
  {
    "slug": "animal-dads"
  },
  {
    "slug": "bad-kitty"
  },
  {
    "slug": "henrietta-and-the-golden-eggs"
  },
  {
    "slug": "tuesday"
  },
  {
    "slug": "the-secret-world-of-whales"
  },
  {
    "slug": "a-dazzling-display-of-dogs"
  },
  {
    "slug": "wild-horse-winter"
  },
  {
    "slug": "necks-out-for-adventure"
  },
  {
    "slug": "operation-redwood"
  },
  {
    "slug": "the-curse-of-akkad-climate-upheavals-that-rocked-human-history"
  },
  {
    "slug": "sometimes-its-turkey-sometimes-its-feathers"
  },
  {
    "slug": "smudge-bunny"
  },
  {
    "slug": "the-way-i-love-you"
  },
  {
    "slug": "ok-go"
  },
  {
    "slug": "i-am-the-dog"
  },
  {
    "slug": "crazy-hair"
  },
  {
    "slug": "animals-that-changed-the-world"
  },
  {
    "slug": "rio"
  },
  {
    "slug": "memorial-day-surprise"
  },
  {
    "slug": "eight-days-a-story-of-haiti"
  },
  {
    "slug": "one-kingdom-our-lives-with-animals"
  },
  {
    "slug": "the-dog-who-had-kittens"
  },
  {
    "slug": "the-jumbo-vegetarian-cookbook"
  },
  {
    "slug": "aquaman-deepwater-disaster"
  },
  {
    "slug": "recycle-this-book"
  },
  {
    "slug": "olivias-birds-saving-the-gulf"
  },
  {
    "slug": "the-chimpanzee-kid"
  },
  {
    "slug": "birthday-zoo"
  },
  {
    "slug": "fred-stays-with-me"
  },
  {
    "slug": "open-season"
  },
  {
    "slug": "the-ocean-story"
  },
  {
    "slug": "the-story-of-mrs-lovewright-and-purrless-her-cat"
  },
  {
    "slug": "how-to-heal-a-broken-wing"
  },
  {
    "slug": "henrietta"
  },
  {
    "slug": "click-clack-moo-cows-that-type"
  },
  {
    "slug": "stuff-reduce-reuse-recycle"
  },
  {
    "slug": "bob-and-shirley-a-tale-of-two-lobsters"
  },
  {
    "slug": "saving-the-baghdad-zoo-a-true-story-of-hope-and-heroes"
  },
  {
    "slug": "fairly-fairy-tales"
  },
  {
    "slug": "grovers-10-terrific-ways"
  },
  {
    "slug": "the-sandwich-swap"
  },
  {
    "slug": "dog-of-discovery-a-newfoundlands-adventures-with-lewis-and-clark"
  },
  {
    "slug": "tadpoles-promise"
  },
  {
    "slug": "we-are-extremely-very-good-recyclers"
  },
  {
    "slug": "the-incorrigible-children-of-ashton-place-the-mysterious-howling"
  },
  {
    "slug": "the-great-pig-search"
  },
  {
    "slug": "cloudy-with-a-chance-of-meatballs"
  },
  {
    "slug": "what-is-easter"
  },
  {
    "slug": "the-secret-of-saying-thanks"
  },
  {
    "slug": "too-many-turkeys"
  },
  {
    "slug": "guess-what-is-growing-inside-this-egg"
  },
  {
    "slug": "quiet-bunnys-many-colors"
  },
  {
    "slug": "the-rabbit-problem"
  },
  {
    "slug": "what-i-be"
  },
  {
    "slug": "the-story-of-the-easter-robin"
  },
  {
    "slug": "apples-cherries-red-raspberries"
  },
  {
    "slug": "no-place-for-a-pig"
  },
  {
    "slug": "the-happy-egg"
  },
  {
    "slug": "the-birchbark-brigade"
  },
  {
    "slug": "calvin-cant-fly-the-story-of-a-bookworm-birdie"
  },
  {
    "slug": "one-nighttime-sea"
  },
  {
    "slug": "peter-the-knight-with-asthma"
  },
  {
    "slug": "easter-parade"
  },
  {
    "slug": "the-kids-solar-energy-book"
  },
  {
    "slug": "shlemiel-crooks"
  },
  {
    "slug": "ocean-babies"
  },
  {
    "slug": "that-pesky-rat"
  },
  {
    "slug": "dogs-have-the-strangest-friends-other-true-stories-of-animal-feelings"
  },
  {
    "slug": "on-the-night-you-were-born"
  },
  {
    "slug": "looking-for-easter"
  },
  {
    "slug": "no-ordinary-olive"
  },
  {
    "slug": "i-didnt-do-it"
  },
  {
    "slug": "abe-lincoln-loved-animals"
  },
  {
    "slug": "mardy-murie-did-grandmother-of-conservation"
  },
  {
    "slug": "a-book-of-sleep"
  },
  {
    "slug": "the-three-pigs"
  },
  {
    "slug": "i-love-animals"
  },
  {
    "slug": "14-cows-for-america"
  },
  {
    "slug": "hummingbirds-facts-and-folklore-from-the-americas"
  },
  {
    "slug": "salad-people-and-more-real-recipes-a-new-cookbook-for-preschoolers-and-up"
  },
  {
    "slug": "oh-the-things-mommies-do-what-could-be-better-than-having-two"
  },
  {
    "slug": "family-pack"
  },
  {
    "slug": "standing-up-to-mr-o"
  },
  {
    "slug": "old-turtle-and-the-broken-truth"
  },
  {
    "slug": "all-the-world"
  },
  {
    "slug": "earth-heroes-champions-of-the-ocean"
  },
  {
    "slug": "the-misadventures-of-ori-tang"
  },
  {
    "slug": "the-animal-rescue-store"
  },
  {
    "slug": "the-people-who-hugged-the-trees"
  },
  {
    "slug": "bringing-in-the-new-year"
  },
  {
    "slug": "wild"
  },
  {
    "slug": "dog-blue"
  },
  {
    "slug": "henry-hikes-to-fitchburg"
  },
  {
    "slug": "owney-the-mail-pouch-pooch"
  },
  {
    "slug": "mrs-marlowes-mice"
  },
  {
    "slug": "hello-baby-beluga"
  },
  {
    "slug": "the-cabbage-soup-solution"
  },
  {
    "slug": "the-secret-life-of-mitch-spinach"
  },
  {
    "slug": "little-pea"
  },
  {
    "slug": "the-rainbow-bunch"
  },
  {
    "slug": "earth-heroes"
  },
  {
    "slug": "sleepy-time"
  },
  {
    "slug": "i-am-a-turkey"
  },
  {
    "slug": "anhs-anger"
  },
  {
    "slug": "fruits-of-india-vegetables-of-india-and-flowers-of-india"
  },
  {
    "slug": "ill-always-be-your-friend"
  },
  {
    "slug": "where-the-wild-things-are"
  },
  {
    "slug": "princess-candy-the-green-queen-of-mean"
  },
  {
    "slug": "madeline-and-the-bad-hat"
  },
  {
    "slug": "mixed-beasts"
  },
  {
    "slug": "of-thee-i-sing"
  },
  {
    "slug": "our-choice-young-readers-edition"
  },
  {
    "slug": "puppy-school"
  },
  {
    "slug": "pippi-longstocking"
  },
  {
    "slug": "its-a-book"
  },
  {
    "slug": "the-last-polar-bear"
  },
  {
    "slug": "wonder-woman-rumble-in-the-rainforest"
  },
  {
    "slug": "my-friend-whale"
  },
  {
    "slug": "the-princess-and-the-frog"
  },
  {
    "slug": "getting-to-the-bottom-of-global-warming-an-isabel-soto-investigation"
  },
  {
    "slug": "bulldogs-big-day"
  },
  {
    "slug": "a-refreshing-look-at-renewable-energy-with-max-axiom-super-scientist"
  },
  {
    "slug": "i-want-to-be-an-environmentalist"
  },
  {
    "slug": "the-snow-bear"
  },
  {
    "slug": "onion-juice-poop-and-other-surprising-sources-of-alternative-energy"
  },
  {
    "slug": "the-magic-squad-and-the-dog-of-great-potential"
  },
  {
    "slug": "simple-food-for-busy-families-the-whole-life-nutrition-approach"
  },
  {
    "slug": "pet-heroes"
  },
  {
    "slug": "max-goes-to-the-recycling-center"
  },
  {
    "slug": "give-us-a-chance"
  },
  {
    "slug": "tofu-and-t-rex"
  },
  {
    "slug": "toy-story"
  },
  {
    "slug": "little-owl-lost"
  },
  {
    "slug": "wurst-case-scenario"
  },
  {
    "slug": "hilda-hens-search"
  },
  {
    "slug": "the-snake-who-was-afraid-of-people"
  },
  {
    "slug": "vunce-upon-a-time"
  },
  {
    "slug": "i-love-dogs"
  },
  {
    "slug": "peter-and-the-pigeons"
  },
  {
    "slug": "the-magic-school-bus-and-the-climate-challenge"
  },
  {
    "slug": "top-holiday-picks-2010"
  },
  {
    "slug": "princess-pigsty"
  },
  {
    "slug": "animals-get-scared-too-just-like-you"
  },
  {
    "slug": "best-friends-the-true-story-of-owen-and-mzee"
  },
  {
    "slug": "thanksgiving-in-the-white-house"
  },
  {
    "slug": "silly-tillys-thanksgiving-dinner"
  },
  {
    "slug": "over-the-river"
  },
  {
    "slug": "gracias-the-thanksgiving-turkey"
  },
  {
    "slug": "the-adventures-of-an-aluminum-can-and-the-adventures-of-a-plastic-bottle"
  },
  {
    "slug": "deformed-frogs"
  },
  {
    "slug": "please-dont-tease-tootsie"
  },
  {
    "slug": "where-does-the-garbage-go"
  },
  {
    "slug": "animal-rights-how-you-can-make-a-difference"
  },
  {
    "slug": "eco-familys-guide-to-going-green"
  },
  {
    "slug": "i-can-save-the-earth"
  },
  {
    "slug": "harry-by-the-sea"
  },
  {
    "slug": "aspca-the-american-society-for-the-prevention-of-cruelty-to-animals"
  },
  {
    "slug": "gus-the-pilgrim-turkey"
  },
  {
    "slug": "what-if-there-were-no-bees"
  },
  {
    "slug": "letting-swift-river-go"
  },
  {
    "slug": "compost-stew-an-a-to-z-recipe-for-the-earth"
  },
  {
    "slug": "the-earth-book-two-perspectives"
  },
  {
    "slug": "where-there-once-was-a-wood"
  },
  {
    "slug": "love-that-dog"
  },
  {
    "slug": "dewey-theres-a-cat-in-the-library"
  },
  {
    "slug": "tinker-bell-and-the-great-fairy-rescue"
  },
  {
    "slug": "martha-and-skits"
  },
  {
    "slug": "the-perfect-pumpkin-pie"
  },
  {
    "slug": "the-stray-dog"
  },
  {
    "slug": "world-water-watch"
  },
  {
    "slug": "rights-for-animals"
  },
  {
    "slug": "biscuit-finds-a-friend"
  },
  {
    "slug": "the-best-cat-in-the-world"
  },
  {
    "slug": "happy-birthday-baby"
  },
  {
    "slug": "children-make-terrible-pets"
  },
  {
    "slug": "nubs"
  },
  {
    "slug": "love-your-world"
  },
  {
    "slug": "deliverance-of-dancing-bears"
  },
  {
    "slug": "kids-making-a-difference-for-animals"
  },
  {
    "slug": "hachi-a-dogs-tale"
  },
  {
    "slug": "the-barefoot-book-of-earth-tales"
  },
  {
    "slug": "morning-of-compassionate-childrens-literature"
  },
  {
    "slug": "keeping-water-clean"
  },
  {
    "slug": "zen-ghosts"
  },
  {
    "slug": "benji-beansprout"
  },
  {
    "slug": "true-green-kids"
  },
  {
    "slug": "zen-ties"
  },
  {
    "slug": "city-dog-country-frog"
  },
  {
    "slug": "why-do-people-harm-animals"
  },
  {
    "slug": "zen-shorts"
  },
  {
    "slug": "i-dont-want-a-cool-cat"
  },
  {
    "slug": "once-i-was-a-cardboard-box-but-now-im-a-book-about-polar-bears"
  },
  {
    "slug": "the-berenstain-bears-and-too-much-junk-food"
  },
  {
    "slug": "i-spy-a-lion-animals-in-art"
  },
  {
    "slug": "a-garden-for-pig"
  },
  {
    "slug": "hurt-go-happy"
  },
  {
    "slug": "ninety-five"
  },
  {
    "slug": "alejandros-gift"
  },
  {
    "slug": "the-perfect-pet"
  },
  {
    "slug": "michael-recycle"
  },
  {
    "slug": "wilfrid-gordon-mcdonald-partridge"
  },
  {
    "slug": "wave"
  },
  {
    "slug": "hello-baby"
  },
  {
    "slug": "ecomazes-12-earth-adventures"
  },
  {
    "slug": "hunwicks-egg"
  },
  {
    "slug": "i-see-a-kookaburra"
  },
  {
    "slug": "the-trouble-with-dogs-said-dad"
  },
  {
    "slug": "new-family-friendly-cookbooks"
  },
  {
    "slug": "louise"
  },
  {
    "slug": "mckenzies-frosty-surprise"
  },
  {
    "slug": "bats-at-the-beach"
  },
  {
    "slug": "the-gas-we-pass-the-story-of-farts"
  },
  {
    "slug": "hey-little-ant"
  },
  {
    "slug": "chicken-joy-on-redbean-road"
  },
  {
    "slug": "now-hiring-white-house-dog"
  },
  {
    "slug": "cows-are-vegetarians"
  },
  {
    "slug": "do-princesses-wear-hiking-boots"
  },
  {
    "slug": "the-berenstain-bears-new-kitten"
  },
  {
    "slug": "foreveryoung"
  },
  {
    "slug": "two-bobbies"
  },
  {
    "slug": "garden"
  },
  {
    "slug": "the-snails-spell"
  },
  {
    "slug": "animalia"
  },
  {
    "slug": "im-gonna-like-me"
  },
  {
    "slug": "garlic-onion-beet-spinach-mango-carrot-grapefruit-juice"
  },
  {
    "slug": "ladybug-girl-at-the-beach"
  },
  {
    "slug": "big-bob-and-the-thanksgiving-potatoes"
  },
  {
    "slug": "bears-new-friend"
  },
  {
    "slug": "perfect-the-pig"
  },
  {
    "slug": "if-you-were-my-baby-a-wildlife-lullaby"
  },
  {
    "slug": "curious-creatures"
  },
  {
    "slug": "jubela"
  },
  {
    "slug": "babe"
  },
  {
    "slug": "weslandia"
  },
  {
    "slug": "the-polar-bears-home"
  },
  {
    "slug": "cookies"
  },
  {
    "slug": "gone-wild-an-endangered-animal-alphabet"
  },
  {
    "slug": "uncover-a-horse"
  },
  {
    "slug": "the-fox-and-the-hound"
  },
  {
    "slug": "swine-divine"
  },
  {
    "slug": "mothers-are-like-that"
  },
  {
    "slug": "cherry-and-olive"
  },
  {
    "slug": "sounds-of-the-wild-safari"
  },
  {
    "slug": "one-smart-goose"
  },
  {
    "slug": "the-blues-go-birding-at-wild-americas-shores"
  },
  {
    "slug": "my-uncle-martins-big-heart"
  },
  {
    "slug": "unlovable"
  },
  {
    "slug": "oil-spill"
  },
  {
    "slug": "hug-time"
  },
  {
    "slug": "101-dalmatians"
  },
  {
    "slug": "amys-light"
  },
  {
    "slug": "cow"
  },
  {
    "slug": "i-heard-it-from-alice-zucchini"
  },
  {
    "slug": "llama-llama-misses-mama"
  },
  {
    "slug": "earth-matters"
  },
  {
    "slug": "diary-of-a-spider"
  },
  {
    "slug": "the-ugly-vegetables"
  },
  {
    "slug": "10-little-rubber-ducks"
  },
  {
    "slug": "munchie-madness"
  },
  {
    "slug": "happy-feet"
  },
  {
    "slug": "animal-poems"
  },
  {
    "slug": "princess-smartypants"
  },
  {
    "slug": "baby-whales-drink-milk"
  },
  {
    "slug": "mutt-dog"
  },
  {
    "slug": "shes-wearing-a-dead-bird-on-her-head"
  },
  {
    "slug": "fantastic-mr-fox"
  },
  {
    "slug": "the-puppy-who-wanted-a-boy"
  },
  {
    "slug": "a-home-for-dixie"
  },
  {
    "slug": "up"
  },
  {
    "slug": "when-lulu-went-to-the-zoo"
  },
  {
    "slug": "eating-animals-and-reading-about-them"
  },
  {
    "slug": "beachcombing"
  },
  {
    "slug": "deep-in-the-jungle"
  },
  {
    "slug": "flush"
  },
  {
    "slug": "whose-garden-is-it"
  },
  {
    "slug": "meow-ruff"
  },
  {
    "slug": "to-market-to-market"
  },
  {
    "slug": "the-vegetables-we-eat"
  },
  {
    "slug": "the-little-mermaid"
  },
  {
    "slug": "our-farm"
  },
  {
    "slug": "i-got-two-dogs"
  },
  {
    "slug": "sallys-great-balloon-adventure"
  },
  {
    "slug": "marsupial-sue-presents-the-runaway-pancake"
  },
  {
    "slug": "heroes-of-the-environment"
  },
  {
    "slug": "the-wonders-inside-bugs-and-spiders"
  },
  {
    "slug": "animals-in-the-house"
  },
  {
    "slug": "and-tango-makes-three"
  },
  {
    "slug": "elephants-swim"
  },
  {
    "slug": "a-chimpanzee-tale"
  },
  {
    "slug": "free-the-worms"
  },
  {
    "slug": "the-gift-of-nothing"
  },
  {
    "slug": "in-a-tizzy-over-turkey"
  },
  {
    "slug": "wright-on-time-books-1-2"
  },
  {
    "slug": "carrot-soup"
  },
  {
    "slug": "the-three-little-pigs-an-architectural-tale"
  },
  {
    "slug": "duck-soup"
  },
  {
    "slug": "animals-in-captivity"
  },
  {
    "slug": "artist"
  },
  {
    "slug": "winston-of-churchill"
  },
  {
    "slug": "how-do-dinosaurs-love-their-cats"
  },
  {
    "slug": "trouble-at-the-dinosaur-cafe"
  },
  {
    "slug": "christian-the-lion"
  },
  {
    "slug": "an-adventure-with-billy-bunny"
  },
  {
    "slug": "too-many-pears"
  },
  {
    "slug": "the-dancing-deer-and-the-foolish-hunter"
  },
  {
    "slug": "mama-is-it-summer-yet"
  },
  {
    "slug": "make-and-eat-vegetarian-food"
  },
  {
    "slug": "just-a-dream"
  },
  {
    "slug": "the-curious-garden"
  },
  {
    "slug": "pete-and-pickles"
  },
  {
    "slug": "duck-at-the-door"
  },
  {
    "slug": "twelve-gifts-of-birth"
  },
  {
    "slug": "cats-roxville"
  },
  {
    "slug": "growing-vegetable-soup"
  },
  {
    "slug": "here-comes-the-garbage-barge"
  },
  {
    "slug": "big-bear-hug"
  },
  {
    "slug": "duck-on-a-bike"
  },
  {
    "slug": "just-like-mama"
  },
  {
    "slug": "rainbows-in-the-river"
  },
  {
    "slug": "the-chicken-gave-it-to-me"
  },
  {
    "slug": "save-the-animals"
  },
  {
    "slug": "farmer-duck"
  },
  {
    "slug": "granny-gomez-and-jigsaw"
  },
  {
    "slug": "so-you-love-animals"
  },
  {
    "slug": "green-guide-for-artists"
  },
  {
    "slug": "biscuits-earth-day-celebration"
  },
  {
    "slug": "souperchicken"
  },
  {
    "slug": "good-dog"
  },
  {
    "slug": "ladybug-girl"
  },
  {
    "slug": "im-a-vegetarian"
  },
  {
    "slug": "animal-watch"
  },
  {
    "slug": "the-carrot-seed"
  },
  {
    "slug": "the-great-pig-escape"
  },
  {
    "slug": "some-dog"
  },
  {
    "slug": "above-all-be-kind"
  },
  {
    "slug": "chimpanzee-rescue"
  },
  {
    "slug": "countdown-to-spring"
  },
  {
    "slug": "four-famished-foxes"
  },
  {
    "slug": "bears-barge-in"
  },
  {
    "slug": "the-wolves-are-back"
  },
  {
    "slug": "easter-egg"
  },
  {
    "slug": "minerva"
  },
  {
    "slug": "tillie-lays-an-egg"
  },
  {
    "slug": "the-easter-chick"
  },
  {
    "slug": "hachiko-waits"
  },
  {
    "slug": "big-cat-conservation"
  },
  {
    "slug": "horton-hatches-the-egg"
  },
  {
    "slug": "pumpkins"
  },
  {
    "slug": "the-great-chicken-escape"
  },
  {
    "slug": "pooh-just-be-nice"
  },
  {
    "slug": "wag"
  },
  {
    "slug": "martha-speaks"
  },
  {
    "slug": "madagascar"
  },
  {
    "slug": "earth-mother"
  },
  {
    "slug": "finding-nemo"
  },
  {
    "slug": "cats"
  },
  {
    "slug": "a-turkey-for-thanksgiving"
  },
  {
    "slug": "dumpster"
  },
  {
    "slug": "ice-age-3"
  },
  {
    "slug": "ice-age-2-guest-post-by-jennifer-gannett"
  },
  {
    "slug": "how-i-nicky-flynn-finally-get-a-life-and-a-dog"
  },
  {
    "slug": "the-deer-in-the-wood-guest-post-by-jacqueline-bodnar"
  },
  {
    "slug": "annie-and-the-wild-animals-guest-post-by-jennifer-gannett"
  },
  {
    "slug": "im-a-manatee-guest-post-by-jacqueline-bodnar"
  },
  {
    "slug": "eco-women-guest-post-by-carolyn-m-mullin"
  },
  {
    "slug": "chicken-in-the-kitchen"
  },
  {
    "slug": "breakfast"
  },
  {
    "slug": "saving-lilly-guest-post-by-carolyn-m-mullin"
  },
  {
    "slug": "vegetable-friends-guest-post-by-jacqueline-bodnar"
  },
  {
    "slug": "ratatouille-guest-post-by-jennifer-gannett"
  },
  {
    "slug": "if-frogs-made-weather"
  },
  {
    "slug": "hero-cat-guest-post-by-huyen-macmichael"
  },
  {
    "slug": "run-turkey-run-2"
  },
  {
    "slug": "first-dog-fala-guest-post-by-jennifer-gannett"
  },
  {
    "slug": "the-baby-shower-list"
  },
  {
    "slug": "kids-can-cook-guest-post-by-jacqueline-bodnar"
  },
  {
    "slug": "lucky-boy-guest-post-by-huyen-macmichael"
  },
  {
    "slug": "the-adventures-of-taxi-dog-guest-post-by-carolyn-mullin"
  },
  {
    "slug": "gorilla"
  },
  {
    "slug": "diary-of-a-worm-guest-post-by-jacqueline-bodnar"
  },
  {
    "slug": "muppets-from-space"
  },
  {
    "slug": "herb-the-vegetarian-dragon-guest-post-by-jennifer-gannett"
  },
  {
    "slug": "tarra-and-bella-the-elephant-and-dog-who-became-best-friends"
  },
  {
    "slug": "tiger"
  },
  {
    "slug": "best-books-of-the-decade"
  },
  {
    "slug": "have-you-seen-my-duckling"
  },
  {
    "slug": "bolt"
  },
  {
    "slug": "how-the-grinch-stole-christmas"
  },
  {
    "slug": "madeline"
  },
  {
    "slug": "the-lion-the-mouse"
  },
  {
    "slug": "the-yellow-leaf"
  },
  {
    "slug": "all-about-garbage-and-recycling"
  },
  {
    "slug": "wolfsnail-backyard-predator"
  },
  {
    "slug": "ice-age-guest-post-by-jennifer-gannett"
  },
  {
    "slug": "the-unicorn-at-the-manger"
  },
  {
    "slug": "my-mom-eats-tofu-guest-post-by-carolyn-m-mullin"
  },
  {
    "slug": "the-giving-tree"
  },
  {
    "slug": "books-im-dying-to-read"
  },
  {
    "slug": "curious-george"
  },
  {
    "slug": "five-lost-chicks"
  },
  {
    "slug": "thats-why-we-dont-eat-animals-guest-post-by-carolyn-m-mullin"
  },
  {
    "slug": "the-tale-of-peter-rabbit"
  },
  {
    "slug": "the-digging-est-dog-2"
  },
  {
    "slug": "the-very-busy-spider"
  },
  {
    "slug": "speak-childrens-book-illustrators-brag-about-their-dogs"
  },
  {
    "slug": "biscuit"
  },
  {
    "slug": "berenstains-a-book"
  },
  {
    "slug": "shark-tale"
  },
  {
    "slug": "blueberries-for-sal"
  },
  {
    "slug": "welcome-back-puffin"
  },
  {
    "slug": "the-lonely-scarecrow"
  },
  {
    "slug": "dance-with-me"
  },
  {
    "slug": "do-animals-have-feelings-too-2"
  },
  {
    "slug": "holiday-shopping-books-and-online-shops"
  },
  {
    "slug": "the-dog-who-belonged-to-no-one-guest-post-by-jennifer-gannett"
  },
  {
    "slug": "make-way-for-ducklings"
  },
  {
    "slug": "the-lady-and-the-spider-guest-review-by-sharon-young"
  },
  {
    "slug": "the-magic-finger"
  },
  {
    "slug": "all-in-a-day"
  },
  {
    "slug": "horton-hears-a-who-movie"
  },
  {
    "slug": "low-song"
  },
  {
    "slug": "a-pinky-is-a-baby-mouse"
  },
  {
    "slug": "alice-in-paris"
  },
  {
    "slug": "moo-baa-la-la-la"
  },
  {
    "slug": "dog-heaven"
  },
  {
    "slug": "twas-the-night-before-thanksgiving"
  },
  {
    "slug": "busy-kitties"
  },
  {
    "slug": "horton-hears-a-who-the-book"
  },
  {
    "slug": "purplicious"
  },
  {
    "slug": "hubert-the-pudge-a-vegetarian-tale"
  },
  {
    "slug": "endangered-animals"
  },
  {
    "slug": "animal-babies-on-the-farm"
  },
  {
    "slug": "guess-how-much-i-love-you"
  },
  {
    "slug": "who-is-the-beast"
  },
  {
    "slug": "olivia"
  },
  {
    "slug": "fancy-nancy-and-the-posh-puppy"
  },
  {
    "slug": "the-cinder-eyed-cats"
  }
] as const;

export const reviewPageEntries = [
  {
    "page": "2"
  },
  {
    "page": "3"
  },
  {
    "page": "4"
  },
  {
    "page": "5"
  },
  {
    "page": "6"
  },
  {
    "page": "7"
  },
  {
    "page": "8"
  },
  {
    "page": "9"
  },
  {
    "page": "10"
  },
  {
    "page": "11"
  },
  {
    "page": "12"
  },
  {
    "page": "13"
  },
  {
    "page": "14"
  },
  {
    "page": "15"
  },
  {
    "page": "16"
  },
  {
    "page": "17"
  },
  {
    "page": "18"
  },
  {
    "page": "19"
  },
  {
    "page": "20"
  },
  {
    "page": "21"
  },
  {
    "page": "22"
  },
  {
    "page": "23"
  },
  {
    "page": "24"
  },
  {
    "page": "25"
  },
  {
    "page": "26"
  },
  {
    "page": "27"
  },
  {
    "page": "28"
  },
  {
    "page": "29"
  },
  {
    "page": "30"
  },
  {
    "page": "31"
  },
  {
    "page": "32"
  },
  {
    "page": "33"
  },
  {
    "page": "34"
  },
  {
    "page": "35"
  },
  {
    "page": "36"
  },
  {
    "page": "37"
  },
  {
    "page": "38"
  },
  {
    "page": "39"
  },
  {
    "page": "40"
  },
  {
    "page": "41"
  },
  {
    "page": "42"
  }
] as const;

export const topicEntries = [
  {
    "slug": "1920s-childrens-literature"
  },
  {
    "slug": "1930s-childrens-literature"
  },
  {
    "slug": "1940s-childrens-literature"
  },
  {
    "slug": "1950s-children-literature"
  },
  {
    "slug": "1960s-childrens-literature"
  },
  {
    "slug": "1960s-movies"
  },
  {
    "slug": "1970s-childrens-books"
  },
  {
    "slug": "1970s-childrens-movies"
  },
  {
    "slug": "1980s-childrens-literature"
  },
  {
    "slug": "1980s-childrens-movies"
  },
  {
    "slug": "1980s-culture"
  },
  {
    "slug": "1990s-books"
  },
  {
    "slug": "1990s-movies"
  },
  {
    "slug": "19th-century"
  },
  {
    "slug": "a-beautiful-day-in-the-neighborhood"
  },
  {
    "slug": "a-childrens-cookbook"
  },
  {
    "slug": "a-dog-runs-through-it"
  },
  {
    "slug": "a-place-to-start-a-family"
  },
  {
    "slug": "a-story-of-growing-up"
  },
  {
    "slug": "abenaki"
  },
  {
    "slug": "abraham-lincoln"
  },
  {
    "slug": "abuse"
  },
  {
    "slug": "academia"
  },
  {
    "slug": "acceptance-of-others"
  },
  {
    "slug": "activism"
  },
  {
    "slug": "activities"
  },
  {
    "slug": "adam-beechen"
  },
  {
    "slug": "adam-fletcher"
  },
  {
    "slug": "adam-gustavson"
  },
  {
    "slug": "adaptations"
  },
  {
    "slug": "adopt-dont-shop"
  },
  {
    "slug": "adoption"
  },
  {
    "slug": "adrienne-yoinks"
  },
  {
    "slug": "adventure"
  },
  {
    "slug": "adversity"
  },
  {
    "slug": "africa"
  },
  {
    "slug": "african-animals"
  },
  {
    "slug": "aging"
  },
  {
    "slug": "al-gore"
  },
  {
    "slug": "al-perkins"
  },
  {
    "slug": "ala-notable-childrens-books"
  },
  {
    "slug": "alan-marks"
  },
  {
    "slug": "alan-rabinowitz"
  },
  {
    "slug": "alaska"
  },
  {
    "slug": "albert-einstein"
  },
  {
    "slug": "albert-schweitzer"
  },
  {
    "slug": "aldo-leopold"
  },
  {
    "slug": "alex-lin"
  },
  {
    "slug": "alex-walton"
  },
  {
    "slug": "alexander-mccall-smith"
  },
  {
    "slug": "alexander-petersen"
  },
  {
    "slug": "alexandra-artigas"
  },
  {
    "slug": "alexandra-colombo"
  },
  {
    "slug": "alexandra-junge"
  },
  {
    "slug": "alexis-dormal"
  },
  {
    "slug": "alexis-frederick-frost"
  },
  {
    "slug": "alice-mclerran"
  },
  {
    "slug": "aliens"
  },
  {
    "slug": "aliens-among-us"
  },
  {
    "slug": "aline-alexander-newman"
  },
  {
    "slug": "alison-inches"
  },
  {
    "slug": "alix-delinois"
  },
  {
    "slug": "all-ages"
  },
  {
    "slug": "all-because-you-matter"
  },
  {
    "slug": "allen-young"
  },
  {
    "slug": "allergic"
  },
  {
    "slug": "allergies"
  },
  {
    "slug": "alligators"
  },
  {
    "slug": "allison-black"
  },
  {
    "slug": "allison-milionis"
  },
  {
    "slug": "alliteration"
  },
  {
    "slug": "alphabet"
  },
  {
    "slug": "already-a-butterfly"
  },
  {
    "slug": "alsc-notable-childrens-book"
  },
  {
    "slug": "alternative-energy"
  },
  {
    "slug": "alyssa-bermudez"
  },
  {
    "slug": "alyssa-nassner"
  },
  {
    "slug": "alyssa-satin-capucilli"
  },
  {
    "slug": "amazon-prime"
  },
  {
    "slug": "amelia-earhart"
  },
  {
    "slug": "american"
  },
  {
    "slug": "amphibians"
  },
  {
    "slug": "amy-bates"
  },
  {
    "slug": "amy-hest"
  },
  {
    "slug": "amy-krouse-rosenthal"
  },
  {
    "slug": "amy-recob"
  },
  {
    "slug": "amy-sharp"
  },
  {
    "slug": "amy-wummer"
  },
  {
    "slug": "an-american-tail"
  },
  {
    "slug": "anastasia-suen"
  },
  {
    "slug": "anatomy"
  },
  {
    "slug": "andrea-davis-pinkney"
  },
  {
    "slug": "andrea-vitali"
  },
  {
    "slug": "andrea-zollman"
  },
  {
    "slug": "andrew-arnold"
  },
  {
    "slug": "andy-ellis"
  },
  {
    "slug": "andy-runton"
  },
  {
    "slug": "andy-warhol"
  },
  {
    "slug": "angela-farris-watkins"
  },
  {
    "slug": "angels"
  },
  {
    "slug": "anger"
  },
  {
    "slug": "angie-stalker"
  },
  {
    "slug": "animal-abuse"
  },
  {
    "slug": "animal-adoption"
  },
  {
    "slug": "animal-behavior"
  },
  {
    "slug": "animal-care"
  },
  {
    "slug": "animal-cognition"
  },
  {
    "slug": "animal-courtship"
  },
  {
    "slug": "animal-emotion"
  },
  {
    "slug": "animal-escape"
  },
  {
    "slug": "animal-exploitation"
  },
  {
    "slug": "animal-facts"
  },
  {
    "slug": "animal-families"
  },
  {
    "slug": "animal-intelligence"
  },
  {
    "slug": "animal-labor"
  },
  {
    "slug": "animal-law"
  },
  {
    "slug": "animal-liberation"
  },
  {
    "slug": "animal-neglect"
  },
  {
    "slug": "animal-personalities"
  },
  {
    "slug": "animal-rescue"
  },
  {
    "slug": "animal-research"
  },
  {
    "slug": "animal-rights"
  },
  {
    "slug": "animal-rights-books-for-kids"
  },
  {
    "slug": "animal-sanctuaries"
  },
  {
    "slug": "animal-sentience"
  },
  {
    "slug": "animal-shelter"
  },
  {
    "slug": "animal-shelters"
  },
  {
    "slug": "animal-sounds"
  },
  {
    "slug": "animal-suffering"
  },
  {
    "slug": "animal-testing"
  },
  {
    "slug": "animal-tracks"
  },
  {
    "slug": "animal-welfare"
  },
  {
    "slug": "animal-welfare-books-for-kids"
  },
  {
    "slug": "animals"
  },
  {
    "slug": "animals-and-society"
  },
  {
    "slug": "animals-as-food"
  },
  {
    "slug": "animals-in-captivity"
  },
  {
    "slug": "animals-in-entertainment"
  },
  {
    "slug": "animals-in-need"
  },
  {
    "slug": "animals-in-research"
  },
  {
    "slug": "animals-that-estivate"
  },
  {
    "slug": "animated"
  },
  {
    "slug": "animated-movies"
  },
  {
    "slug": "animation"
  },
  {
    "slug": "anita-jeram"
  },
  {
    "slug": "anita-lobel"
  },
  {
    "slug": "ann-bradley"
  },
  {
    "slug": "ann-james"
  },
  {
    "slug": "ann-jones"
  },
  {
    "slug": "ann-whitford-paul"
  },
  {
    "slug": "anna-branford"
  },
  {
    "slug": "anna-dewdney"
  },
  {
    "slug": "anna-johansson"
  },
  {
    "slug": "anna-mcquinn"
  },
  {
    "slug": "anna-olswanger"
  },
  {
    "slug": "anna-raff"
  },
  {
    "slug": "anna-vojtech"
  },
  {
    "slug": "annalise-howard"
  },
  {
    "slug": "anne-dinshah"
  },
  {
    "slug": "anne-lee"
  },
  {
    "slug": "anne-miranda"
  },
  {
    "slug": "anne-sol"
  },
  {
    "slug": "anne-wilson"
  },
  {
    "slug": "annelore-parot"
  },
  {
    "slug": "annette-bay-pimentel"
  },
  {
    "slug": "annie-wong"
  },
  {
    "slug": "anthony-bourke"
  },
  {
    "slug": "anthony-browne"
  },
  {
    "slug": "anthony-lewis"
  },
  {
    "slug": "anti-hunting"
  },
  {
    "slug": "ants"
  },
  {
    "slug": "anxiety"
  },
  {
    "slug": "apatosaurus"
  },
  {
    "slug": "apology"
  },
  {
    "slug": "apples"
  },
  {
    "slug": "april-pulley-sayre"
  },
  {
    "slug": "april-runge"
  },
  {
    "slug": "aquariums"
  },
  {
    "slug": "archie-carr"
  },
  {
    "slug": "architecture"
  },
  {
    "slug": "arctic"
  },
  {
    "slug": "arctic-terns"
  },
  {
    "slug": "ard-hoyt"
  },
  {
    "slug": "ariane-dewey"
  },
  {
    "slug": "ariel-cohn"
  },
  {
    "slug": "armadillos"
  },
  {
    "slug": "aron-nels-steinke"
  },
  {
    "slug": "art"
  },
  {
    "slug": "art-corriveau"
  },
  {
    "slug": "art-projects"
  },
  {
    "slug": "artie-bennett"
  },
  {
    "slug": "artie-knapp"
  },
  {
    "slug": "artists"
  },
  {
    "slug": "ashley-judd"
  },
  {
    "slug": "ashley-lucas"
  },
  {
    "slug": "ashley-wolff"
  },
  {
    "slug": "ashton-kutcher"
  },
  {
    "slug": "asia"
  },
  {
    "slug": "asian"
  },
  {
    "slug": "aspca"
  },
  {
    "slug": "asthma"
  },
  {
    "slug": "astrid-lindgren"
  },
  {
    "slug": "astronauts"
  },
  {
    "slug": "atlantic-ocean"
  },
  {
    "slug": "audubon"
  },
  {
    "slug": "aurelia-fronty"
  },
  {
    "slug": "australia"
  },
  {
    "slug": "autism"
  },
  {
    "slug": "autobiography"
  },
  {
    "slug": "autumn"
  },
  {
    "slug": "axel-scheffler"
  },
  {
    "slug": "babette-cole"
  },
  {
    "slug": "baby-animals"
  },
  {
    "slug": "baby-book"
  },
  {
    "slug": "baby-books"
  },
  {
    "slug": "baby-loves-green-energy"
  },
  {
    "slug": "baby-reader"
  },
  {
    "slug": "badgers"
  },
  {
    "slug": "baking"
  },
  {
    "slug": "bali"
  },
  {
    "slug": "ballerinas"
  },
  {
    "slug": "ballet"
  },
  {
    "slug": "bambino-and-mr-twain"
  },
  {
    "slug": "banana-fox-and-the-secret-sour-society"
  },
  {
    "slug": "banana-slug-string-band"
  },
  {
    "slug": "bananas"
  },
  {
    "slug": "barack-obama"
  },
  {
    "slug": "barbara-cooney"
  },
  {
    "slug": "barbara-dacosta"
  },
  {
    "slug": "barbara-jean-hicks"
  },
  {
    "slug": "barbara-juster-esbensen"
  },
  {
    "slug": "barbara-kerley"
  },
  {
    "slug": "barbara-obrien"
  },
  {
    "slug": "barney-saltzberg"
  },
  {
    "slug": "barry-louis-polisar"
  },
  {
    "slug": "basset-hound"
  },
  {
    "slug": "bats"
  },
  {
    "slug": "bccb-blue-ribbon-picture-book-awards"
  },
  {
    "slug": "beach"
  },
  {
    "slug": "bears"
  },
  {
    "slug": "beatrix-potter"
  },
  {
    "slug": "beavers"
  },
  {
    "slug": "bedtime"
  },
  {
    "slug": "bees"
  },
  {
    "slug": "beetles"
  },
  {
    "slug": "beginning-readers"
  },
  {
    "slug": "behold-the-beautiful-dung-beetle"
  },
  {
    "slug": "ben-cort"
  },
  {
    "slug": "ben-devries"
  },
  {
    "slug": "ben-galbraith"
  },
  {
    "slug": "ben-hatke"
  },
  {
    "slug": "ben-hodson"
  },
  {
    "slug": "benjamin-lacombe"
  },
  {
    "slug": "berenstain-bears"
  },
  {
    "slug": "berkeley-breathed"
  },
  {
    "slug": "best-books-for-vegetarian-christian-children"
  },
  {
    "slug": "best-books-for-vegetarian-kids"
  },
  {
    "slug": "best-family-cookbooks"
  },
  {
    "slug": "beth-bracken"
  },
  {
    "slug": "beth-krommes"
  },
  {
    "slug": "beth-stover"
  },
  {
    "slug": "betsy-franco"
  },
  {
    "slug": "betsy-lewin"
  },
  {
    "slug": "betty-buckley"
  },
  {
    "slug": "between-us-and-abuela"
  },
  {
    "slug": "beyond-words"
  },
  {
    "slug": "bhagavan-antle"
  },
  {
    "slug": "bicycles"
  },
  {
    "slug": "big-cats"
  },
  {
    "slug": "bilingual"
  },
  {
    "slug": "bill-martin-jr"
  },
  {
    "slug": "biography"
  },
  {
    "slug": "biology"
  },
  {
    "slug": "biomes"
  },
  {
    "slug": "birds"
  },
  {
    "slug": "birth"
  },
  {
    "slug": "birthday"
  },
  {
    "slug": "birute-galdikas"
  },
  {
    "slug": "biscuit"
  },
  {
    "slug": "black-history-month"
  },
  {
    "slug": "black-lives-matter"
  },
  {
    "slug": "black-market-trade"
  },
  {
    "slug": "blair-richmond"
  },
  {
    "slug": "blindness"
  },
  {
    "slug": "blog-action-day"
  },
  {
    "slug": "board-book"
  },
  {
    "slug": "board-books"
  },
  {
    "slug": "bob-barker"
  },
  {
    "slug": "bob-dylan"
  },
  {
    "slug": "bob-graham"
  },
  {
    "slug": "bob-kolar"
  },
  {
    "slug": "bob-marstall"
  },
  {
    "slug": "bob-staake"
  },
  {
    "slug": "bobbie-hinman"
  },
  {
    "slug": "bobby-moynihan"
  },
  {
    "slug": "bobcats"
  },
  {
    "slug": "body-parts"
  },
  {
    "slug": "bonnie-lee"
  },
  {
    "slug": "booker-t-washington"
  },
  {
    "slug": "books"
  },
  {
    "slug": "books-for-vegetarian-kids"
  },
  {
    "slug": "books-that-teach-character"
  },
  {
    "slug": "books-that-teach-empathy"
  },
  {
    "slug": "books-to-avoid"
  },
  {
    "slug": "border-fence"
  },
  {
    "slug": "botswana"
  },
  {
    "slug": "bracelets-for-binas-brothers"
  },
  {
    "slug": "brad-meltzer"
  },
  {
    "slug": "braden-lamb"
  },
  {
    "slug": "bragging"
  },
  {
    "slug": "brandon-fall"
  },
  {
    "slug": "bravery"
  },
  {
    "slug": "brazil"
  },
  {
    "slug": "breastfeeding"
  },
  {
    "slug": "breathe-in-breathe-out"
  },
  {
    "slug": "breathing-problems"
  },
  {
    "slug": "brenda-peterson"
  },
  {
    "slug": "brenda-z-guiberson"
  },
  {
    "slug": "bret-witter"
  },
  {
    "slug": "brett-morgen"
  },
  {
    "slug": "brian-deines"
  },
  {
    "slug": "brian-floca"
  },
  {
    "slug": "brian-flora"
  },
  {
    "slug": "brian-lies"
  },
  {
    "slug": "brian-moses"
  },
  {
    "slug": "brian-p-cleary"
  },
  {
    "slug": "brian-pinkney"
  },
  {
    "slug": "brian-skerry"
  },
  {
    "slug": "brianne-brouhard"
  },
  {
    "slug": "brigette-luciani"
  },
  {
    "slug": "brooke-chavez"
  },
  {
    "slug": "brooklyn"
  },
  {
    "slug": "brothers"
  },
  {
    "slug": "brown-bears"
  },
  {
    "slug": "bruce-degen"
  },
  {
    "slug": "bruce-kociemba"
  },
  {
    "slug": "bruce-malnor"
  },
  {
    "slug": "bruce-whatley"
  },
  {
    "slug": "bruce-zeman"
  },
  {
    "slug": "bryan-collier"
  },
  {
    "slug": "buddha"
  },
  {
    "slug": "buddhism"
  },
  {
    "slug": "buffalo"
  },
  {
    "slug": "bugs"
  },
  {
    "slug": "building-blocks"
  },
  {
    "slug": "bullying"
  },
  {
    "slug": "bush-meat"
  },
  {
    "slug": "butterflies"
  },
  {
    "slug": "cabbages"
  },
  {
    "slug": "caelyn-ab-williams"
  },
  {
    "slug": "caldecott-honor"
  },
  {
    "slug": "caldecott-medal"
  },
  {
    "slug": "camels"
  },
  {
    "slug": "camping"
  },
  {
    "slug": "canada-geese"
  },
  {
    "slug": "candace-fleming"
  },
  {
    "slug": "candace-keach"
  },
  {
    "slug": "candy"
  },
  {
    "slug": "captive-wildlife"
  },
  {
    "slug": "car-trips"
  },
  {
    "slug": "careers"
  },
  {
    "slug": "caregivers"
  },
  {
    "slug": "caretaking"
  },
  {
    "slug": "cari-best"
  },
  {
    "slug": "caribbean-sea"
  },
  {
    "slug": "caribous"
  },
  {
    "slug": "carin-berger"
  },
  {
    "slug": "carl-hiaasen"
  },
  {
    "slug": "carl-safina"
  },
  {
    "slug": "carlos-patino"
  },
  {
    "slug": "carly-allen-fletcher"
  },
  {
    "slug": "carmela-lavigna-coyle"
  },
  {
    "slug": "carmen-agra-deedy"
  },
  {
    "slug": "carmen-t-bernier-grand"
  },
  {
    "slug": "carnivores"
  },
  {
    "slug": "carol-a-camburn"
  },
  {
    "slug": "carol-buckley"
  },
  {
    "slug": "carol-carrick"
  },
  {
    "slug": "carol-l-malnor"
  },
  {
    "slug": "carol-schwartz"
  },
  {
    "slug": "carol-sirrine"
  },
  {
    "slug": "carole-boston-weatherford"
  },
  {
    "slug": "caroline-craig"
  },
  {
    "slug": "caroline-joyne-church"
  },
  {
    "slug": "caroline-kenneth"
  },
  {
    "slug": "carolyn-m-mullin"
  },
  {
    "slug": "carrie-a-pearson"
  },
  {
    "slug": "carrie-hartman"
  },
  {
    "slug": "carrots"
  },
  {
    "slug": "cars"
  },
  {
    "slug": "carter-goodrich"
  },
  {
    "slug": "cat-overpopulation"
  },
  {
    "slug": "cate-blanchett"
  },
  {
    "slug": "caterpillars"
  },
  {
    "slug": "catfish"
  },
  {
    "slug": "catherine-clark"
  },
  {
    "slug": "catherine-thimmesh"
  },
  {
    "slug": "catholic-culture"
  },
  {
    "slug": "catholicism"
  },
  {
    "slug": "cathryn-falwell"
  },
  {
    "slug": "cathy-morrison"
  },
  {
    "slug": "catia-chien"
  },
  {
    "slug": "cats"
  },
  {
    "slug": "cecilia-mariano"
  },
  {
    "slug": "chaaya-prabhat"
  },
  {
    "slug": "chad-cameron"
  },
  {
    "slug": "chad-wallace"
  },
  {
    "slug": "chained-dogs"
  },
  {
    "slug": "challenging-stereotypes"
  },
  {
    "slug": "change"
  },
  {
    "slug": "change-of-heart"
  },
  {
    "slug": "chani-sanchez"
  },
  {
    "slug": "chapter-book"
  },
  {
    "slug": "chapter-books"
  },
  {
    "slug": "charlene-costanzo"
  },
  {
    "slug": "charles-darwin"
  },
  {
    "slug": "charles-de-lint"
  },
  {
    "slug": "charles-nurnburg"
  },
  {
    "slug": "charles-siebert"
  },
  {
    "slug": "charles-trevino"
  },
  {
    "slug": "charles-vess"
  },
  {
    "slug": "charlesbridge"
  },
  {
    "slug": "charlesbridge-publishers"
  },
  {
    "slug": "charlesbridge-publishing"
  },
  {
    "slug": "charlie-brown"
  },
  {
    "slug": "charlie-parker"
  },
  {
    "slug": "charlotte-vivian-rodenberg"
  },
  {
    "slug": "charlotte-voake"
  },
  {
    "slug": "charlotte-zolotow"
  },
  {
    "slug": "charlotte-zolotow-award"
  },
  {
    "slug": "charmaine-hammond"
  },
  {
    "slug": "cheetahs"
  },
  {
    "slug": "chef-brian-p-mccarthy"
  },
  {
    "slug": "cherly-bardoe"
  },
  {
    "slug": "cherokee"
  },
  {
    "slug": "cheryl-bardoe"
  },
  {
    "slug": "cheryl-christian"
  },
  {
    "slug": "chicken-in-the-kitchen"
  },
  {
    "slug": "chickens"
  },
  {
    "slug": "child-development"
  },
  {
    "slug": "childrens-book"
  },
  {
    "slug": "childrens-books"
  },
  {
    "slug": "childrens-choice-book-awards"
  },
  {
    "slug": "childrens-laureate"
  },
  {
    "slug": "childrens-poet-laureate"
  },
  {
    "slug": "chimpanzees"
  },
  {
    "slug": "china"
  },
  {
    "slug": "chinese-new-year"
  },
  {
    "slug": "chinese-vegetables"
  },
  {
    "slug": "chipmunks"
  },
  {
    "slug": "chocolate"
  },
  {
    "slug": "chris-bivins"
  },
  {
    "slug": "chris-duffy"
  },
  {
    "slug": "chris-gall"
  },
  {
    "slug": "chris-haughton"
  },
  {
    "slug": "chris-mason"
  },
  {
    "slug": "chris-pedersen"
  },
  {
    "slug": "chris-raschka"
  },
  {
    "slug": "chris-van-allsburg"
  },
  {
    "slug": "chris-van-dusen"
  },
  {
    "slug": "christian-vegetarians"
  },
  {
    "slug": "christiane-kromer"
  },
  {
    "slug": "christianity"
  },
  {
    "slug": "christine-heppermann"
  },
  {
    "slug": "christine-mcdonnell"
  },
  {
    "slug": "christine-wong"
  },
  {
    "slug": "christmas"
  },
  {
    "slug": "christmas-movies"
  },
  {
    "slug": "christopher-canyon"
  },
  {
    "slug": "christopher-denise"
  },
  {
    "slug": "christopher-eliopoulos"
  },
  {
    "slug": "christopher-franceschelli"
  },
  {
    "slug": "christopher-lloyd"
  },
  {
    "slug": "christopher-myers"
  },
  {
    "slug": "christopher-wormell"
  },
  {
    "slug": "christy-hale"
  },
  {
    "slug": "chrystin-garland"
  },
  {
    "slug": "church"
  },
  {
    "slug": "cindy-olejar"
  },
  {
    "slug": "circus"
  },
  {
    "slug": "cities"
  },
  {
    "slug": "citizenship"
  },
  {
    "slug": "city"
  },
  {
    "slug": "civil-disobedience"
  },
  {
    "slug": "civil-rights"
  },
  {
    "slug": "civil-war"
  },
  {
    "slug": "clams"
  },
  {
    "slug": "clare-druce"
  },
  {
    "slug": "classic-books"
  },
  {
    "slug": "classic-fairy-tales"
  },
  {
    "slug": "classic-tales-retold"
  },
  {
    "slug": "classroom-books"
  },
  {
    "slug": "claudia-mills"
  },
  {
    "slug": "claudia-rueda"
  },
  {
    "slug": "cleaning"
  },
  {
    "slug": "clearcutting"
  },
  {
    "slug": "clever-publishing"
  },
  {
    "slug": "climate-change"
  },
  {
    "slug": "clothing"
  },
  {
    "slug": "clouds"
  },
  {
    "slug": "co-housing"
  },
  {
    "slug": "cockfighting"
  },
  {
    "slug": "cockroaches"
  },
  {
    "slug": "coffee-table-books"
  },
  {
    "slug": "collage"
  },
  {
    "slug": "college"
  },
  {
    "slug": "coloring"
  },
  {
    "slug": "coloring-pages"
  },
  {
    "slug": "colors"
  },
  {
    "slug": "comedy"
  },
  {
    "slug": "comic-books"
  },
  {
    "slug": "coming-of-age"
  },
  {
    "slug": "communication"
  },
  {
    "slug": "community"
  },
  {
    "slug": "companion-animals"
  },
  {
    "slug": "compassion"
  },
  {
    "slug": "compassion-kindness"
  },
  {
    "slug": "composting"
  },
  {
    "slug": "concrete-poetry"
  },
  {
    "slug": "condor"
  },
  {
    "slug": "confidence"
  },
  {
    "slug": "conflict"
  },
  {
    "slug": "conflict-resolution"
  },
  {
    "slug": "consent"
  },
  {
    "slug": "conservation"
  },
  {
    "slug": "consie-powell"
  },
  {
    "slug": "consumerism"
  },
  {
    "slug": "consumption"
  },
  {
    "slug": "consumption-of-animals"
  },
  {
    "slug": "consumption-of-meat"
  },
  {
    "slug": "controversial-kids-books"
  },
  {
    "slug": "cookbook"
  },
  {
    "slug": "cookbooks"
  },
  {
    "slug": "cookbooks-for-kids"
  },
  {
    "slug": "cookies"
  },
  {
    "slug": "cooking"
  },
  {
    "slug": "cooperation"
  },
  {
    "slug": "coral-reef"
  },
  {
    "slug": "corn"
  },
  {
    "slug": "cornelia-funke"
  },
  {
    "slug": "cougars"
  },
  {
    "slug": "counting"
  },
  {
    "slug": "counting-books"
  },
  {
    "slug": "countryman-press"
  },
  {
    "slug": "courage"
  },
  {
    "slug": "cows"
  },
  {
    "slug": "coyotes"
  },
  {
    "slug": "crabs"
  },
  {
    "slug": "craft-projects"
  },
  {
    "slug": "craig-hatkoff"
  },
  {
    "slug": "creativity"
  },
  {
    "slug": "crescent-dragonwagon"
  },
  {
    "slug": "cris-arbo"
  },
  {
    "slug": "cris-peterson"
  },
  {
    "slug": "cristina-kessler"
  },
  {
    "slug": "crockett-johnson"
  },
  {
    "slug": "crocodiles"
  },
  {
    "slug": "cruelty-to-animals"
  },
  {
    "slug": "crustaceans"
  },
  {
    "slug": "crystal-tompkins"
  },
  {
    "slug": "cultural-traditions"
  },
  {
    "slug": "current-events"
  },
  {
    "slug": "cybils-award"
  },
  {
    "slug": "cyd-moore"
  },
  {
    "slug": "cynthia-lair"
  },
  {
    "slug": "cynthia-rylant"
  },
  {
    "slug": "d-b-johnson"
  },
  {
    "slug": "dachshunds"
  },
  {
    "slug": "dads"
  },
  {
    "slug": "dairy"
  },
  {
    "slug": "dairy-industry"
  },
  {
    "slug": "dan-andreasen"
  },
  {
    "slug": "dan-bodenstein"
  },
  {
    "slug": "dan-hanna"
  },
  {
    "slug": "dan-lipow"
  },
  {
    "slug": "dan-yaccarino"
  },
  {
    "slug": "dana-jensen"
  },
  {
    "slug": "dandelions"
  },
  {
    "slug": "dandi-daley-mackall"
  },
  {
    "slug": "daniel-kariko"
  },
  {
    "slug": "daniel-miyares"
  },
  {
    "slug": "daniel-nunn"
  },
  {
    "slug": "daniel-pinkwater"
  },
  {
    "slug": "daphne-sheldrick"
  },
  {
    "slug": "dark-childrens-books"
  },
  {
    "slug": "darkness"
  },
  {
    "slug": "darrin-lunde"
  },
  {
    "slug": "darylynn-ayala"
  },
  {
    "slug": "dav-pilkey"
  },
  {
    "slug": "dave-mckean"
  },
  {
    "slug": "david-bedford"
  },
  {
    "slug": "david-catrow"
  },
  {
    "slug": "david-clark"
  },
  {
    "slug": "david-davis"
  },
  {
    "slug": "david-dayan-fisher"
  },
  {
    "slug": "david-de-rothschild"
  },
  {
    "slug": "david-diaz"
  },
  {
    "slug": "david-george-gordon"
  },
  {
    "slug": "david-harrison"
  },
  {
    "slug": "david-kirk"
  },
  {
    "slug": "david-l-rice"
  },
  {
    "slug": "david-lee-harrison"
  },
  {
    "slug": "david-m-schwartz"
  },
  {
    "slug": "david-mamet"
  },
  {
    "slug": "david-mclimans"
  },
  {
    "slug": "david-mcphail"
  },
  {
    "slug": "david-michael-slater"
  },
  {
    "slug": "david-parker"
  },
  {
    "slug": "david-roberts"
  },
  {
    "slug": "david-shannon"
  },
  {
    "slug": "david-small"
  },
  {
    "slug": "david-soman"
  },
  {
    "slug": "david-walega"
  },
  {
    "slug": "david-weisner"
  },
  {
    "slug": "david-wiesner"
  },
  {
    "slug": "dawn-bentley"
  },
  {
    "slug": "dawn-casey"
  },
  {
    "slug": "day-of-the-dead"
  },
  {
    "slug": "death"
  },
  {
    "slug": "death-of-a-pet"
  },
  {
    "slug": "debbie-harter"
  },
  {
    "slug": "debbie-tille"
  },
  {
    "slug": "deborah-diesen"
  },
  {
    "slug": "deborah-howe"
  },
  {
    "slug": "deborah-lee-rose"
  },
  {
    "slug": "deborah-noyes"
  },
  {
    "slug": "deborah-underwood"
  },
  {
    "slug": "deductive-reasoning"
  },
  {
    "slug": "deer"
  },
  {
    "slug": "deforestation"
  },
  {
    "slug": "deidre-rochford"
  },
  {
    "slug": "delaware-bay"
  },
  {
    "slug": "demonstrations"
  },
  {
    "slug": "denise-brennan-nelson"
  },
  {
    "slug": "denise-fleming"
  },
  {
    "slug": "denys-cazet"
  },
  {
    "slug": "depiction-of-vegetarian-food-in-books"
  },
  {
    "slug": "depictions-of-animals"
  },
  {
    "slug": "depictions-of-dairy-in-books"
  },
  {
    "slug": "depictions-of-meat-in-books"
  },
  {
    "slug": "depictions-of-meat-in-film"
  },
  {
    "slug": "derek-anderson"
  },
  {
    "slug": "derek-jacobi"
  },
  {
    "slug": "desert"
  },
  {
    "slug": "deserts"
  },
  {
    "slug": "design"
  },
  {
    "slug": "detriot"
  },
  {
    "slug": "detroit-riot"
  },
  {
    "slug": "devin-asch"
  },
  {
    "slug": "devin-scillian"
  },
  {
    "slug": "devotion"
  },
  {
    "slug": "dewin-fotheringham"
  },
  {
    "slug": "diana-sudyka"
  },
  {
    "slug": "diana-ting-delosh"
  },
  {
    "slug": "diane-degroat"
  },
  {
    "slug": "diane-mayr"
  },
  {
    "slug": "diane-swanson"
  },
  {
    "slug": "diane-vukovic"
  },
  {
    "slug": "dick-king-smith"
  },
  {
    "slug": "die-cut"
  },
  {
    "slug": "differences"
  },
  {
    "slug": "dinosaurs"
  },
  {
    "slug": "dirt"
  },
  {
    "slug": "dirty-sock-funtime-band"
  },
  {
    "slug": "disasters"
  },
  {
    "slug": "discrimination"
  },
  {
    "slug": "disney"
  },
  {
    "slug": "dissection"
  },
  {
    "slug": "diverse-families"
  },
  {
    "slug": "diversity"
  },
  {
    "slug": "divorce"
  },
  {
    "slug": "diwali"
  },
  {
    "slug": "do-princesses-and-super-heroes-hit-the-trails"
  },
  {
    "slug": "doctor-dolittle"
  },
  {
    "slug": "documentaries"
  },
  {
    "slug": "dog-behaviors"
  },
  {
    "slug": "dog-facts"
  },
  {
    "slug": "dog-racing"
  },
  {
    "slug": "dogface"
  },
  {
    "slug": "dogs"
  },
  {
    "slug": "dolls"
  },
  {
    "slug": "dolphins"
  },
  {
    "slug": "domestication"
  },
  {
    "slug": "dominique-roques"
  },
  {
    "slug": "don-bluth"
  },
  {
    "slug": "don-freeman"
  },
  {
    "slug": "don-spencer"
  },
  {
    "slug": "donkeys"
  },
  {
    "slug": "donnell-rubey"
  },
  {
    "slug": "doreen-cronin"
  },
  {
    "slug": "dori-chaconas"
  },
  {
    "slug": "dorothy-donahue"
  },
  {
    "slug": "dorothy-r-bates"
  },
  {
    "slug": "doug-cushman"
  },
  {
    "slug": "dougie-poynter"
  },
  {
    "slug": "douglas-wood"
  },
  {
    "slug": "down-syndrome"
  },
  {
    "slug": "downeast-books"
  },
  {
    "slug": "dr-bernie-siegal"
  },
  {
    "slug": "dr-sally-hodson"
  },
  {
    "slug": "dr-seuss"
  },
  {
    "slug": "dragons"
  },
  {
    "slug": "dreamy"
  },
  {
    "slug": "drew-weing"
  },
  {
    "slug": "ducks"
  },
  {
    "slug": "dumplings"
  },
  {
    "slug": "dung-beetle"
  },
  {
    "slug": "dyan-sheldon"
  },
  {
    "slug": "dyanne-disalvo-ryan"
  },
  {
    "slug": "e-books"
  },
  {
    "slug": "e-b-white"
  },
  {
    "slug": "e-b-white-read-aloud-award-winner"
  },
  {
    "slug": "e-e-cummings"
  },
  {
    "slug": "eagles"
  },
  {
    "slug": "early-adult"
  },
  {
    "slug": "early-elementary"
  },
  {
    "slug": "early-readers"
  },
  {
    "slug": "earth"
  },
  {
    "slug": "earth-day"
  },
  {
    "slug": "earthquake"
  },
  {
    "slug": "easter"
  },
  {
    "slug": "eco-friendly-kids-books"
  },
  {
    "slug": "ecofeminism"
  },
  {
    "slug": "ecosystems"
  },
  {
    "slug": "ed-stewart"
  },
  {
    "slug": "ed-young"
  },
  {
    "slug": "eddie-murphy"
  },
  {
    "slug": "edgar-stewart"
  },
  {
    "slug": "edgardo-griffith"
  },
  {
    "slug": "education"
  },
  {
    "slug": "educational"
  },
  {
    "slug": "educational-kids-films"
  },
  {
    "slug": "educators"
  },
  {
    "slug": "edward-gibbs"
  },
  {
    "slug": "edwidge-danticat"
  },
  {
    "slug": "eggs"
  },
  {
    "slug": "eileen-christelow"
  },
  {
    "slug": "eileen-cooley"
  },
  {
    "slug": "elanna-allen"
  },
  {
    "slug": "eleanor-roosevelt"
  },
  {
    "slug": "eleanor-taylor"
  },
  {
    "slug": "elementary-readers"
  },
  {
    "slug": "elementary-school"
  },
  {
    "slug": "elena-tsvetaeva"
  },
  {
    "slug": "elephant-sanctuary"
  },
  {
    "slug": "elephant-seals"
  },
  {
    "slug": "elephants"
  },
  {
    "slug": "elisa-chavarri"
  },
  {
    "slug": "elisa-kleven"
  },
  {
    "slug": "elizab-van-steenwyk"
  },
  {
    "slug": "elizabeth-kahn"
  },
  {
    "slug": "elizabeth-queen-of-the-seas"
  },
  {
    "slug": "elizabeth-rusch"
  },
  {
    "slug": "elizabeth-swados"
  },
  {
    "slug": "ella-fitzgerald"
  },
  {
    "slug": "elle-j-mcguinness"
  },
  {
    "slug": "ellen-degeneres"
  },
  {
    "slug": "ellen-jackson"
  },
  {
    "slug": "ellen-joy-saski"
  },
  {
    "slug": "ellen-schwartz"
  },
  {
    "slug": "ellie-bethel"
  },
  {
    "slug": "ellie-kemper"
  },
  {
    "slug": "embryo-development"
  },
  {
    "slug": "emergencies"
  },
  {
    "slug": "emile-henriquez"
  },
  {
    "slug": "emily-gravett"
  },
  {
    "slug": "emily-maclachlan-charest"
  },
  {
    "slug": "emma-dodd"
  },
  {
    "slug": "emma-walton-hamilton"
  },
  {
    "slug": "emotion"
  },
  {
    "slug": "empathy"
  },
  {
    "slug": "emperor-penguins"
  },
  {
    "slug": "encouragement"
  },
  {
    "slug": "endangered-species"
  },
  {
    "slug": "energy"
  },
  {
    "slug": "engineering"
  },
  {
    "slug": "england"
  },
  {
    "slug": "english"
  },
  {
    "slug": "enthomology"
  },
  {
    "slug": "environment"
  },
  {
    "slug": "environmental"
  },
  {
    "slug": "environmental-childrens-literature"
  },
  {
    "slug": "environmental-kids-movies"
  },
  {
    "slug": "environmental-law"
  },
  {
    "slug": "environmentalism"
  },
  {
    "slug": "equality"
  },
  {
    "slug": "eric-carle"
  },
  {
    "slug": "eric-carle-museum-of-picture-book-art"
  },
  {
    "slug": "eric-gurney"
  },
  {
    "slug": "eric-pinder"
  },
  {
    "slug": "eric-puybaret"
  },
  {
    "slug": "eric-rohmann"
  },
  {
    "slug": "eric-stonestreet"
  },
  {
    "slug": "eric-t-krackow"
  },
  {
    "slug": "eric-velasquez"
  },
  {
    "slug": "erica-fernandez"
  },
  {
    "slug": "erika-oller"
  },
  {
    "slug": "esme-raji-codell"
  },
  {
    "slug": "ethnic-food"
  },
  {
    "slug": "eugene-walton"
  },
  {
    "slug": "eugenie-clark"
  },
  {
    "slug": "eujin-kim-neilan"
  },
  {
    "slug": "europe"
  },
  {
    "slug": "eva-ibbotson"
  },
  {
    "slug": "eva-moore"
  },
  {
    "slug": "eve-bunting"
  },
  {
    "slug": "eve-tharlet"
  },
  {
    "slug": "even-more-lesser-spotted-animals"
  },
  {
    "slug": "events"
  },
  {
    "slug": "everglades"
  },
  {
    "slug": "everything-awesome-about-sharks"
  },
  {
    "slug": "evolution"
  },
  {
    "slug": "exploration"
  },
  {
    "slug": "extinction"
  },
  {
    "slug": "fables"
  },
  {
    "slug": "fabric-art"
  },
  {
    "slug": "factory-farming"
  },
  {
    "slug": "fairies"
  },
  {
    "slug": "fairy-tales"
  },
  {
    "slug": "faith-mcnulty"
  },
  {
    "slug": "falcon-guides"
  },
  {
    "slug": "fall"
  },
  {
    "slug": "falynn-koch"
  },
  {
    "slug": "families"
  },
  {
    "slug": "family"
  },
  {
    "slug": "family-films"
  },
  {
    "slug": "family-movie"
  },
  {
    "slug": "family-movies"
  },
  {
    "slug": "family-programming"
  },
  {
    "slug": "fancy-nancy"
  },
  {
    "slug": "fantasy"
  },
  {
    "slug": "farm"
  },
  {
    "slug": "farm-sanctuary"
  },
  {
    "slug": "farmed-animals"
  },
  {
    "slug": "farmers-markets"
  },
  {
    "slug": "farming"
  },
  {
    "slug": "fate"
  },
  {
    "slug": "fathers-day"
  },
  {
    "slug": "fathers"
  },
  {
    "slug": "fear"
  },
  {
    "slug": "feathers"
  },
  {
    "slug": "feel-good"
  },
  {
    "slug": "feelings"
  },
  {
    "slug": "feeroozeh-golmohammadi"
  },
  {
    "slug": "feiwal-and-friends"
  },
  {
    "slug": "felicia-zekauskas"
  },
  {
    "slug": "female-protagonist"
  },
  {
    "slug": "feminism"
  },
  {
    "slug": "fibonacci"
  },
  {
    "slug": "fiona-watt"
  },
  {
    "slug": "firefighters"
  },
  {
    "slug": "fireflies"
  },
  {
    "slug": "first-day-of-school"
  },
  {
    "slug": "first-second"
  },
  {
    "slug": "first-second-books"
  },
  {
    "slug": "fish"
  },
  {
    "slug": "fishing"
  },
  {
    "slug": "flamingos"
  },
  {
    "slug": "fleas"
  },
  {
    "slug": "flies"
  },
  {
    "slug": "flip-book"
  },
  {
    "slug": "flora-mcdonnell"
  },
  {
    "slug": "florida"
  },
  {
    "slug": "flowers"
  },
  {
    "slug": "flying-squirrels"
  },
  {
    "slug": "folk-tales"
  },
  {
    "slug": "food"
  },
  {
    "slug": "food-allergies"
  },
  {
    "slug": "food-choices"
  },
  {
    "slug": "forest"
  },
  {
    "slug": "forests"
  },
  {
    "slug": "forthcoming-books"
  },
  {
    "slug": "fossil-fuels"
  },
  {
    "slug": "fossils"
  },
  {
    "slug": "foster-care"
  },
  {
    "slug": "foxes"
  },
  {
    "slug": "fran-hodgkins"
  },
  {
    "slug": "france"
  },
  {
    "slug": "frances-barry"
  },
  {
    "slug": "frances-england"
  },
  {
    "slug": "franck-prevot"
  },
  {
    "slug": "frane-lessac"
  },
  {
    "slug": "frank-asch"
  },
  {
    "slug": "frank-viva"
  },
  {
    "slug": "frank-w-dormer"
  },
  {
    "slug": "franklin-folsom"
  },
  {
    "slug": "fred-rogers"
  },
  {
    "slug": "free-to-be-elephant-me"
  },
  {
    "slug": "freya-blackwood"
  },
  {
    "slug": "freya-dinshah"
  },
  {
    "slug": "friendship"
  },
  {
    "slug": "frogs"
  },
  {
    "slug": "fruit"
  },
  {
    "slug": "fruits"
  },
  {
    "slug": "fry-bread"
  },
  {
    "slug": "fun"
  },
  {
    "slug": "fund-for-animals"
  },
  {
    "slug": "fur"
  },
  {
    "slug": "fur-trade"
  },
  {
    "slug": "future-astronaut"
  },
  {
    "slug": "future-baby"
  },
  {
    "slug": "future-engineer"
  },
  {
    "slug": "g-brian-karas"
  },
  {
    "slug": "gaia-cornwall"
  },
  {
    "slug": "gail-gibbons"
  },
  {
    "slug": "gail-silver"
  },
  {
    "slug": "gail-suzanne-weismann"
  },
  {
    "slug": "garbage"
  },
  {
    "slug": "garden"
  },
  {
    "slug": "gardening"
  },
  {
    "slug": "gardening-for-kids"
  },
  {
    "slug": "garry-parsons"
  },
  {
    "slug": "garth-williams"
  },
  {
    "slug": "gary-d-schmidt"
  },
  {
    "slug": "gary-dorion"
  },
  {
    "slug": "gary-hines"
  },
  {
    "slug": "gary-weitzman-md"
  },
  {
    "slug": "geese"
  },
  {
    "slug": "geisel-honor-book"
  },
  {
    "slug": "gender"
  },
  {
    "slug": "gene-zion"
  },
  {
    "slug": "generosity"
  },
  {
    "slug": "genesis-awards"
  },
  {
    "slug": "genetically-modified-food"
  },
  {
    "slug": "gentrification"
  },
  {
    "slug": "geography"
  },
  {
    "slug": "george-ancona"
  },
  {
    "slug": "george-ella-lyon"
  },
  {
    "slug": "george-oconnor"
  },
  {
    "slug": "george-washington"
  },
  {
    "slug": "geraldine-elschner"
  },
  {
    "slug": "german-shepherd"
  },
  {
    "slug": "geronimo"
  },
  {
    "slug": "gestation-crates"
  },
  {
    "slug": "ghost-stories"
  },
  {
    "slug": "giants"
  },
  {
    "slug": "gijsbert-van-frankenhuyzen"
  },
  {
    "slug": "giles-andreae"
  },
  {
    "slug": "giles-laroche"
  },
  {
    "slug": "gina-bazer"
  },
  {
    "slug": "gina-otto"
  },
  {
    "slug": "ginny-rorby"
  },
  {
    "slug": "giraffes"
  },
  {
    "slug": "girls"
  },
  {
    "slug": "glenn-close"
  },
  {
    "slug": "global-warming"
  },
  {
    "slug": "globalization"
  },
  {
    "slug": "gluten-free"
  },
  {
    "slug": "goals"
  },
  {
    "slug": "goats"
  },
  {
    "slug": "golden-gate-bridge"
  },
  {
    "slug": "goldy-locks"
  },
  {
    "slug": "gonzo"
  },
  {
    "slug": "good-for-todd"
  },
  {
    "slug": "good-for-toddlers"
  },
  {
    "slug": "good-samaritan"
  },
  {
    "slug": "goodnight-seahorse"
  },
  {
    "slug": "gorillas"
  },
  {
    "slug": "gospel-music"
  },
  {
    "slug": "grace-chon"
  },
  {
    "slug": "grace-lin"
  },
  {
    "slug": "grace-zong"
  },
  {
    "slug": "graeme-base"
  },
  {
    "slug": "grammar"
  },
  {
    "slug": "grandparents"
  },
  {
    "slug": "grapes"
  },
  {
    "slug": "graphic-novel"
  },
  {
    "slug": "graphic-novels"
  },
  {
    "slug": "grasshoppers"
  },
  {
    "slug": "gratitude"
  },
  {
    "slug": "grazia-restelli"
  },
  {
    "slug": "great-apes"
  },
  {
    "slug": "great-plains"
  },
  {
    "slug": "greek-gods"
  },
  {
    "slug": "greek-myths"
  },
  {
    "slug": "green-earth-book-award-winner"
  },
  {
    "slug": "green-living"
  },
  {
    "slug": "green-publishing"
  },
  {
    "slug": "greg-leitich-smith"
  },
  {
    "slug": "greg-pizzoli"
  },
  {
    "slug": "greyhounds"
  },
  {
    "slug": "grief"
  },
  {
    "slug": "grieving"
  },
  {
    "slug": "gross-books"
  },
  {
    "slug": "growing-up"
  },
  {
    "slug": "growth"
  },
  {
    "slug": "guano"
  },
  {
    "slug": "guinea-pigs"
  },
  {
    "slug": "gulls"
  },
  {
    "slug": "gustaf-tenggren"
  },
  {
    "slug": "guy-hobbs"
  },
  {
    "slug": "guy-parker-rees"
  },
  {
    "slug": "habitat-destruction"
  },
  {
    "slug": "habitats"
  },
  {
    "slug": "hair"
  },
  {
    "slug": "haiti"
  },
  {
    "slug": "halloween"
  },
  {
    "slug": "hamsters"
  },
  {
    "slug": "hanna-johansen"
  },
  {
    "slug": "hanukkah"
  },
  {
    "slug": "happiness"
  },
  {
    "slug": "hard-work"
  },
  {
    "slug": "harriet-rohmer"
  },
  {
    "slug": "harriet-ziefert"
  },
  {
    "slug": "harry-bliss"
  },
  {
    "slug": "harry-connick-jr"
  },
  {
    "slug": "hawks"
  },
  {
    "slug": "hayes-roberts"
  },
  {
    "slug": "hazel-mitchell"
  },
  {
    "slug": "healthy-choices"
  },
  {
    "slug": "healthy-eating"
  },
  {
    "slug": "healthy-living"
  },
  {
    "slug": "heather-clark"
  },
  {
    "slug": "heather-dyer"
  },
  {
    "slug": "heather-fox"
  },
  {
    "slug": "heather-l-montgomery"
  },
  {
    "slug": "heather-swain"
  },
  {
    "slug": "heidelberg-street"
  },
  {
    "slug": "helen-foster-james"
  },
  {
    "slug": "helen-keller"
  },
  {
    "slug": "helen-l-wilbur"
  },
  {
    "slug": "helen-martini"
  },
  {
    "slug": "hello-my-name-is-ruby"
  },
  {
    "slug": "helmut-wolf"
  },
  {
    "slug": "helping-animals"
  },
  {
    "slug": "henrik-drescher"
  },
  {
    "slug": "henrike-wilson"
  },
  {
    "slug": "henry-bergh"
  },
  {
    "slug": "henry-bergh-award-winner"
  },
  {
    "slug": "henry-cole"
  },
  {
    "slug": "henry-david-thoreau"
  },
  {
    "slug": "hens"
  },
  {
    "slug": "herb-the-vegetarian-dragon"
  },
  {
    "slug": "herm-auch"
  },
  {
    "slug": "heroes"
  },
  {
    "slug": "heron"
  },
  {
    "slug": "herons"
  },
  {
    "slug": "hibernation"
  },
  {
    "slug": "hidatsa"
  },
  {
    "slug": "hillary-feerick"
  },
  {
    "slug": "hinduism"
  },
  {
    "slug": "hippopotamus"
  },
  {
    "slug": "hiroe-nakata"
  },
  {
    "slug": "history"
  },
  {
    "slug": "hoarding"
  },
  {
    "slug": "hoboken"
  },
  {
    "slug": "holiday"
  },
  {
    "slug": "holiday-books"
  },
  {
    "slug": "holiday-movies"
  },
  {
    "slug": "holiday-shopping"
  },
  {
    "slug": "holidays"
  },
  {
    "slug": "holly-hobbie"
  },
  {
    "slug": "holly-mcghee"
  },
  {
    "slug": "holly-meade"
  },
  {
    "slug": "homa-woodrum"
  },
  {
    "slug": "homeless-animals"
  },
  {
    "slug": "homelessness"
  },
  {
    "slug": "homeschooling"
  },
  {
    "slug": "honesty"
  },
  {
    "slug": "honey"
  },
  {
    "slug": "hope"
  },
  {
    "slug": "horses"
  },
  {
    "slug": "horseshoe-crabs"
  },
  {
    "slug": "horton"
  },
  {
    "slug": "how-do-fairies-have-fun-in-the-sun"
  },
  {
    "slug": "how-many-hugs"
  },
  {
    "slug": "how-to-speak-dog"
  },
  {
    "slug": "howard-fine"
  },
  {
    "slug": "hugh-laurie"
  },
  {
    "slug": "hugh-lofting"
  },
  {
    "slug": "hugo-van-lawick"
  },
  {
    "slug": "human-body"
  },
  {
    "slug": "human-rights"
  },
  {
    "slug": "human-animal-studies"
  },
  {
    "slug": "human-canine-bond"
  },
  {
    "slug": "humane"
  },
  {
    "slug": "humane-education"
  },
  {
    "slug": "humane-organizations"
  },
  {
    "slug": "humane-society"
  },
  {
    "slug": "hummingbirds"
  },
  {
    "slug": "humor"
  },
  {
    "slug": "hunger"
  },
  {
    "slug": "hunting"
  },
  {
    "slug": "hurricane-katrina"
  },
  {
    "slug": "huyen-macmicahel"
  },
  {
    "slug": "huyen-macmichael"
  },
  {
    "slug": "hydroelectric-power"
  },
  {
    "slug": "hyenas"
  },
  {
    "slug": "hyeon-ju-lee"
  },
  {
    "slug": "iain-mcintosh"
  },
  {
    "slug": "ian-falconer"
  },
  {
    "slug": "ian-lendler"
  },
  {
    "slug": "ice-age"
  },
  {
    "slug": "idioms"
  },
  {
    "slug": "if-animals-said-i-love-you"
  },
  {
    "slug": "if-elephants-disappeared"
  },
  {
    "slug": "il-sung-na"
  },
  {
    "slug": "illegal-trade-of-animal-parts"
  },
  {
    "slug": "illness"
  },
  {
    "slug": "illustration"
  },
  {
    "slug": "illustrations"
  },
  {
    "slug": "imagination"
  },
  {
    "slug": "imax"
  },
  {
    "slug": "immigrant-experience"
  },
  {
    "slug": "immigration"
  },
  {
    "slug": "immune-system"
  },
  {
    "slug": "inclusion"
  },
  {
    "slug": "independence"
  },
  {
    "slug": "india"
  },
  {
    "slug": "indian-american-culture"
  },
  {
    "slug": "indonesia"
  },
  {
    "slug": "indoor-cats"
  },
  {
    "slug": "industrial-farming"
  },
  {
    "slug": "inequality"
  },
  {
    "slug": "inga-moore"
  },
  {
    "slug": "inhae-lee"
  },
  {
    "slug": "inhaler"
  },
  {
    "slug": "insects"
  },
  {
    "slug": "inspiration"
  },
  {
    "slug": "intelligence"
  },
  {
    "slug": "interspecies-friendship"
  },
  {
    "slug": "invention"
  },
  {
    "slug": "invertebrate-animals"
  },
  {
    "slug": "ireland"
  },
  {
    "slug": "irene-chan"
  },
  {
    "slug": "iroquois"
  },
  {
    "slug": "irving-berlin"
  },
  {
    "slug": "isa-chandra-moskowitz"
  },
  {
    "slug": "isabella-hatkoff"
  },
  {
    "slug": "islands"
  },
  {
    "slug": "issues-facing-children"
  },
  {
    "slug": "issues-facing-wildlife"
  },
  {
    "slug": "isy-abraham-raveson"
  },
  {
    "slug": "ivory-trade"
  },
  {
    "slug": "j-cecelia-haytko"
  },
  {
    "slug": "j-patrick-lewis"
  },
  {
    "slug": "j-h-shapiro"
  },
  {
    "slug": "j-k-rowling"
  },
  {
    "slug": "j-otto-seibold"
  },
  {
    "slug": "jabari-asim"
  },
  {
    "slug": "jack-black"
  },
  {
    "slug": "jack-e-davis"
  },
  {
    "slug": "jack-lechner"
  },
  {
    "slug": "jack-veda"
  },
  {
    "slug": "jackie-french"
  },
  {
    "slug": "jackie-robinson"
  },
  {
    "slug": "jackie-urbanovic"
  },
  {
    "slug": "jacky-davis"
  },
  {
    "slug": "jacqueline-bodnar"
  },
  {
    "slug": "jacqueline-briggs-martin"
  },
  {
    "slug": "jacques-cousteau"
  },
  {
    "slug": "jacques-yves-cousteau"
  },
  {
    "slug": "jaguars"
  },
  {
    "slug": "jaime-hernandez"
  },
  {
    "slug": "jake-parker"
  },
  {
    "slug": "james-bruchac"
  },
  {
    "slug": "james-howe"
  },
  {
    "slug": "james-kochalka"
  },
  {
    "slug": "james-sturm"
  },
  {
    "slug": "james-warhola"
  },
  {
    "slug": "jamie-hogan"
  },
  {
    "slug": "jamie-lee-curtis"
  },
  {
    "slug": "jan-berenstain"
  },
  {
    "slug": "jan-brett"
  },
  {
    "slug": "jan-carr"
  },
  {
    "slug": "jan-zita-grover"
  },
  {
    "slug": "jana-christy"
  },
  {
    "slug": "jane-chapman"
  },
  {
    "slug": "jane-cowles"
  },
  {
    "slug": "jane-dyer"
  },
  {
    "slug": "jane-goodall"
  },
  {
    "slug": "jane-lynch"
  },
  {
    "slug": "jane-mann"
  },
  {
    "slug": "jane-massey"
  },
  {
    "slug": "jane-oconnor"
  },
  {
    "slug": "jane-parsons"
  },
  {
    "slug": "jane-thayer"
  },
  {
    "slug": "jane-yolen"
  },
  {
    "slug": "janell-cannon"
  },
  {
    "slug": "janet-larson"
  },
  {
    "slug": "janet-morgan-stoeke"
  },
  {
    "slug": "janet-s-wong"
  },
  {
    "slug": "janet-schulman"
  },
  {
    "slug": "janet-stevens"
  },
  {
    "slug": "janette-sebring-lowrey"
  },
  {
    "slug": "janik-coat"
  },
  {
    "slug": "janna-matthies"
  },
  {
    "slug": "japan"
  },
  {
    "slug": "jared-chapman"
  },
  {
    "slug": "jason-alexander"
  },
  {
    "slug": "jay-cooper"
  },
  {
    "slug": "jazz"
  },
  {
    "slug": "jean-craighead-george"
  },
  {
    "slug": "jean-davies-okimoto"
  },
  {
    "slug": "jean-michel-basquiat"
  },
  {
    "slug": "jeanelle-ferreira"
  },
  {
    "slug": "jeanette-canyon"
  },
  {
    "slug": "jeanette-winter"
  },
  {
    "slug": "jeanne-nagle"
  },
  {
    "slug": "jeanne-willis"
  },
  {
    "slug": "jeannette-bessinger"
  },
  {
    "slug": "jeannie-brett"
  },
  {
    "slug": "jeff-albrecht-studios"
  },
  {
    "slug": "jeff-corwin"
  },
  {
    "slug": "jeff-daniels"
  },
  {
    "slug": "jeff-hillenbrand"
  },
  {
    "slug": "jeffrey-moussaieff-masson"
  },
  {
    "slug": "jemaine-clement"
  },
  {
    "slug": "jen-corace"
  },
  {
    "slug": "jen-green"
  },
  {
    "slug": "jen-jones"
  },
  {
    "slug": "jennifer-berne"
  },
  {
    "slug": "jennifer-dirubbio"
  },
  {
    "slug": "jennifer-gannett"
  },
  {
    "slug": "jennifer-ginn"
  },
  {
    "slug": "jennifer-kali"
  },
  {
    "slug": "jennifer-l-meyer"
  },
  {
    "slug": "jennifer-taylor"
  },
  {
    "slug": "jennifer-torres"
  },
  {
    "slug": "jenny-bonnin"
  },
  {
    "slug": "jenny-goebel"
  },
  {
    "slug": "jequita-potts-mcdaniel"
  },
  {
    "slug": "jerry-pallotta"
  },
  {
    "slug": "jerry-pinkney"
  },
  {
    "slug": "jerry-seinfeld"
  },
  {
    "slug": "jess-yeomans"
  },
  {
    "slug": "jesse-sweetwater"
  },
  {
    "slug": "jewish-culture"
  },
  {
    "slug": "jill-dubin"
  },
  {
    "slug": "jill-hartley"
  },
  {
    "slug": "jill-pinkwater"
  },
  {
    "slug": "jill-robinson"
  },
  {
    "slug": "jim-arnosky"
  },
  {
    "slug": "jim-dratfield"
  },
  {
    "slug": "jim-henson"
  },
  {
    "slug": "jim-lamarche"
  },
  {
    "slug": "jim-paillot"
  },
  {
    "slug": "jo-anne-jagers"
  },
  {
    "slug": "joan-cusak"
  },
  {
    "slug": "joan-holub"
  },
  {
    "slug": "joanna-cole"
  },
  {
    "slug": "joanne-rocklin"
  },
  {
    "slug": "joanne-ryder"
  },
  {
    "slug": "joe-archer"
  },
  {
    "slug": "joe-flood"
  },
  {
    "slug": "joe-hyatt"
  },
  {
    "slug": "joe-rhatigan"
  },
  {
    "slug": "joel-fuhrman"
  },
  {
    "slug": "john-adkins"
  },
  {
    "slug": "john-butler"
  },
  {
    "slug": "john-chester"
  },
  {
    "slug": "john-himmelman"
  },
  {
    "slug": "john-lithgow"
  },
  {
    "slug": "john-lithgrow"
  },
  {
    "slug": "john-malam"
  },
  {
    "slug": "john-manders"
  },
  {
    "slug": "john-mcintyre"
  },
  {
    "slug": "john-milton"
  },
  {
    "slug": "john-muir"
  },
  {
    "slug": "john-rendall"
  },
  {
    "slug": "john-schindel"
  },
  {
    "slug": "john-segal"
  },
  {
    "slug": "john-seven"
  },
  {
    "slug": "jon-cannell"
  },
  {
    "slug": "jon-j-muth"
  },
  {
    "slug": "jon-klassen"
  },
  {
    "slug": "jon-rothenberg"
  },
  {
    "slug": "jonathan-allen"
  },
  {
    "slug": "jonathan-balcombe"
  },
  {
    "slug": "jonathan-frost"
  },
  {
    "slug": "jonathan-stutzman"
  },
  {
    "slug": "joni-sensel"
  },
  {
    "slug": "jose-aruego"
  },
  {
    "slug": "joseph-anthony"
  },
  {
    "slug": "joseph-bruchac"
  },
  {
    "slug": "joshua-nash"
  },
  {
    "slug": "journey"
  },
  {
    "slug": "joy-cho"
  },
  {
    "slug": "joy-cowley"
  },
  {
    "slug": "joy-harjo"
  },
  {
    "slug": "joyce-mihran-turley"
  },
  {
    "slug": "joyce-sidman"
  },
  {
    "slug": "juana-martinez-neal"
  },
  {
    "slug": "juanita-havill"
  },
  {
    "slug": "judaism"
  },
  {
    "slug": "judy-ackerman-grant"
  },
  {
    "slug": "judy-love"
  },
  {
    "slug": "judy-sierra"
  },
  {
    "slug": "juicing"
  },
  {
    "slug": "jules-bass"
  },
  {
    "slug": "julia-alvarez"
  },
  {
    "slug": "julia-child"
  },
  {
    "slug": "julia-donaldson"
  },
  {
    "slug": "julia-gorton"
  },
  {
    "slug": "julia-roberts"
  },
  {
    "slug": "julie-andrews"
  },
  {
    "slug": "julie-moberg"
  },
  {
    "slug": "julie-vivas"
  },
  {
    "slug": "jungle"
  },
  {
    "slug": "junk-food"
  },
  {
    "slug": "juntos-nos-reimos"
  },
  {
    "slug": "justin-richardson"
  },
  {
    "slug": "kaitlyn-aiyana-enstice"
  },
  {
    "slug": "kandy-radzinki"
  },
  {
    "slug": "kangaroos"
  },
  {
    "slug": "kara-maria-schunk"
  },
  {
    "slug": "karate"
  },
  {
    "slug": "karen-lee-stevens"
  },
  {
    "slug": "karen-tweedy-holmes"
  },
  {
    "slug": "karen-young"
  },
  {
    "slug": "karla-gudeon"
  },
  {
    "slug": "karma-wilson"
  },
  {
    "slug": "kate-di-camillo"
  },
  {
    "slug": "kate-dicamillo"
  },
  {
    "slug": "kate-jeong"
  },
  {
    "slug": "katherine-applegate"
  },
  {
    "slug": "katherine-krohn"
  },
  {
    "slug": "katherine-pryor"
  },
  {
    "slug": "kathi-bhend"
  },
  {
    "slug": "kathleen-weidner-zoehfeld"
  },
  {
    "slug": "kathryn-lasky"
  },
  {
    "slug": "kathryn-selbert"
  },
  {
    "slug": "kathryn-thurman"
  },
  {
    "slug": "kathryn-white"
  },
  {
    "slug": "kathy-allen"
  },
  {
    "slug": "kathy-coughlin"
  },
  {
    "slug": "kathy-parra"
  },
  {
    "slug": "kati-green"
  },
  {
    "slug": "katie-viggers"
  },
  {
    "slug": "katrina-donovan-fleming"
  },
  {
    "slug": "katy-schneider"
  },
  {
    "slug": "katya-korobkina"
  },
  {
    "slug": "kay-chorao"
  },
  {
    "slug": "kazu-kibuishi"
  },
  {
    "slug": "keith-a-gaston"
  },
  {
    "slug": "keith-baker"
  },
  {
    "slug": "keith-bendis"
  },
  {
    "slug": "kelly-dipucchio"
  },
  {
    "slug": "kelly-milner-halls"
  },
  {
    "slug": "kelly-morrison-handerhan"
  },
  {
    "slug": "keltie-thomas"
  },
  {
    "slug": "ken-keffer"
  },
  {
    "slug": "kenneth-branagh"
  },
  {
    "slug": "kenny-loggins"
  },
  {
    "slug": "kenya"
  },
  {
    "slug": "kenyon-cox"
  },
  {
    "slug": "kermit-the-frog"
  },
  {
    "slug": "kes-gray"
  },
  {
    "slug": "kevin-henkes"
  },
  {
    "slug": "kevin-noble-maillard"
  },
  {
    "slug": "keystone-species"
  },
  {
    "slug": "kia-robertson"
  },
  {
    "slug": "kid-lit"
  },
  {
    "slug": "kidlit"
  },
  {
    "slug": "kids-cookbooks"
  },
  {
    "slug": "kids-in-the-kitchen"
  },
  {
    "slug": "killer-whales"
  },
  {
    "slug": "kim-diersen"
  },
  {
    "slug": "kim-lewis"
  },
  {
    "slug": "kim-mckay"
  },
  {
    "slug": "kimono"
  },
  {
    "slug": "kind-childrens-book-award"
  },
  {
    "slug": "kind-childrens-honor-books"
  },
  {
    "slug": "kindergarten"
  },
  {
    "slug": "kindness"
  },
  {
    "slug": "kindness-to-animals"
  },
  {
    "slug": "kirby-larson"
  },
  {
    "slug": "kirk-gradin"
  },
  {
    "slug": "kittens-first-full-moon"
  },
  {
    "slug": "kittens"
  },
  {
    "slug": "koalas"
  },
  {
    "slug": "kosa-ely"
  },
  {
    "slug": "kristen-stein"
  },
  {
    "slug": "kristin-wald"
  },
  {
    "slug": "krystal-kelley"
  },
  {
    "slug": "kwanzaa"
  },
  {
    "slug": "l-frank-baum"
  },
  {
    "slug": "la-posada-sin-fronteras"
  },
  {
    "slug": "lab-animals"
  },
  {
    "slug": "laboratory-animals"
  },
  {
    "slug": "lacrosse"
  },
  {
    "slug": "ladybugs"
  },
  {
    "slug": "lane-smith"
  },
  {
    "slug": "langston-hughes"
  },
  {
    "slug": "language"
  },
  {
    "slug": "lara-bergen"
  },
  {
    "slug": "lashon-daley"
  },
  {
    "slug": "latino-culture"
  },
  {
    "slug": "laura-doherty"
  },
  {
    "slug": "laura-ingalls-wilder"
  },
  {
    "slug": "laura-j-bryant"
  },
  {
    "slug": "laura-rader"
  },
  {
    "slug": "laura-resau"
  },
  {
    "slug": "laura-t-barnes"
  },
  {
    "slug": "laurel-larsen"
  },
  {
    "slug": "lauren-child"
  },
  {
    "slug": "lauren-destefano"
  },
  {
    "slug": "laurence-pringle"
  },
  {
    "slug": "laurie-berkner"
  },
  {
    "slug": "laurie-krebs"
  },
  {
    "slug": "law"
  },
  {
    "slug": "leah-mebane"
  },
  {
    "slug": "lee-bennett-hopkins"
  },
  {
    "slug": "lee-harper"
  },
  {
    "slug": "legal"
  },
  {
    "slug": "legislation"
  },
  {
    "slug": "legos"
  },
  {
    "slug": "lemony-snicket"
  },
  {
    "slug": "leneille-moon"
  },
  {
    "slug": "leo-landry"
  },
  {
    "slug": "leo-lionni"
  },
  {
    "slug": "leonard-weisgard"
  },
  {
    "slug": "leopards"
  },
  {
    "slug": "leslea-newman"
  },
  {
    "slug": "leslie-patricelli"
  },
  {
    "slug": "lesson-plans"
  },
  {
    "slug": "leuyen-pham"
  },
  {
    "slug": "lewis-and-clark"
  },
  {
    "slug": "lewis-carroll"
  },
  {
    "slug": "library"
  },
  {
    "slug": "life-cycle"
  },
  {
    "slug": "life-affirming"
  },
  {
    "slug": "lifecycle"
  },
  {
    "slug": "lift-a-flap"
  },
  {
    "slug": "lightning-bugs"
  },
  {
    "slug": "lillian-hoban"
  },
  {
    "slug": "lily-williams"
  },
  {
    "slug": "linda-capus-riley"
  },
  {
    "slug": "linda-fields"
  },
  {
    "slug": "linda-glaser"
  },
  {
    "slug": "linda-kranz"
  },
  {
    "slug": "linda-pastan"
  },
  {
    "slug": "linda-white"
  },
  {
    "slug": "lindsay-ward"
  },
  {
    "slug": "lindsey-evans"
  },
  {
    "slug": "lion"
  },
  {
    "slug": "lions"
  },
  {
    "slug": "lisa-anchin"
  },
  {
    "slug": "lisa-campbell-ernst"
  },
  {
    "slug": "lisa-kahn-schnell"
  },
  {
    "slug": "lisa-m-cottrell-bentley"
  },
  {
    "slug": "lisa-mccue"
  },
  {
    "slug": "lisa-onykahonie"
  },
  {
    "slug": "lisa-wheeler"
  },
  {
    "slug": "listen"
  },
  {
    "slug": "literacy"
  },
  {
    "slug": "litter"
  },
  {
    "slug": "little-otter-learns-to-swim"
  },
  {
    "slug": "live-action-movies"
  },
  {
    "slug": "living-in-harmony-with-nature"
  },
  {
    "slug": "living-with-disabilities"
  },
  {
    "slug": "living-with-wildlife"
  },
  {
    "slug": "liz-garton-scanlon"
  },
  {
    "slug": "liza-gardner-walsh"
  },
  {
    "slug": "llama-glamarama"
  },
  {
    "slug": "llama-unleashes-the-alpacalypse"
  },
  {
    "slug": "llamas"
  },
  {
    "slug": "lobsters"
  },
  {
    "slug": "lois-ehlert"
  },
  {
    "slug": "lois-wyse"
  },
  {
    "slug": "lola-goes-to-school"
  },
  {
    "slug": "london-ladd"
  },
  {
    "slug": "loren-long"
  },
  {
    "slug": "lori-alexander"
  },
  {
    "slug": "lori-ries"
  },
  {
    "slug": "lorna-balian"
  },
  {
    "slug": "loss"
  },
  {
    "slug": "louis-c-k"
  },
  {
    "slug": "love"
  },
  {
    "slug": "lowell-hildebrandt"
  },
  {
    "slug": "loyalty"
  },
  {
    "slug": "lucky-boy"
  },
  {
    "slug": "lucy-micklethwait"
  },
  {
    "slug": "ludwig-bemelmans"
  },
  {
    "slug": "luke-flowers"
  },
  {
    "slug": "luke-pearson"
  },
  {
    "slug": "lunar-new-year"
  },
  {
    "slug": "lynn-munsinger"
  },
  {
    "slug": "lynne-barasch"
  },
  {
    "slug": "lynne-cherry"
  },
  {
    "slug": "lynne-cox"
  },
  {
    "slug": "lynx"
  },
  {
    "slug": "maasai"
  },
  {
    "slug": "madeline"
  },
  {
    "slug": "maggie-kneen"
  },
  {
    "slug": "maggie-meade"
  },
  {
    "slug": "maggie-russell"
  },
  {
    "slug": "magic"
  },
  {
    "slug": "magic-school-bus"
  },
  {
    "slug": "magpies"
  },
  {
    "slug": "mahalia-jackson"
  },
  {
    "slug": "maine"
  },
  {
    "slug": "maine-animal-coalitiion"
  },
  {
    "slug": "major-william-sumner"
  },
  {
    "slug": "malachy-doyle"
  },
  {
    "slug": "malcom-wells"
  },
  {
    "slug": "mama-doni"
  },
  {
    "slug": "mammals"
  },
  {
    "slug": "mammoths"
  },
  {
    "slug": "manatees"
  },
  {
    "slug": "marc-bekoff"
  },
  {
    "slug": "marc-brown"
  },
  {
    "slug": "marc-simont"
  },
  {
    "slug": "mardy-murie"
  },
  {
    "slug": "margaret-cardillo"
  },
  {
    "slug": "margaret-chamberlain"
  },
  {
    "slug": "margaret-reed-and-joan-lownds"
  },
  {
    "slug": "margaret-wentworth-owings"
  },
  {
    "slug": "margaret-wise-brown"
  },
  {
    "slug": "margie-moore"
  },
  {
    "slug": "margie-palatini"
  },
  {
    "slug": "margo-maloo"
  },
  {
    "slug": "margret-and-h-a-ray"
  },
  {
    "slug": "marguerite-gast"
  },
  {
    "slug": "marianne-berkes"
  },
  {
    "slug": "maribel-lechuga"
  },
  {
    "slug": "marie-curie"
  },
  {
    "slug": "marie-louise-gay"
  },
  {
    "slug": "marie-sabine-roger"
  },
  {
    "slug": "marilyn-singer"
  },
  {
    "slug": "marine-animals"
  },
  {
    "slug": "marine-mammals"
  },
  {
    "slug": "marion-dane-bauer"
  },
  {
    "slug": "maris-wicks"
  },
  {
    "slug": "marjorie-priceman"
  },
  {
    "slug": "mark-pett"
  },
  {
    "slug": "mark-robertson"
  },
  {
    "slug": "mark-siegel"
  },
  {
    "slug": "mark-teague"
  },
  {
    "slug": "mark-twain"
  },
  {
    "slug": "mark-weakland"
  },
  {
    "slug": "marla-frazee"
  },
  {
    "slug": "marmosets"
  },
  {
    "slug": "marriage"
  },
  {
    "slug": "marsha-rakestraw"
  },
  {
    "slug": "martin-brown"
  },
  {
    "slug": "martin-lawrence"
  },
  {
    "slug": "martin-luther-king"
  },
  {
    "slug": "martin-waddell"
  },
  {
    "slug": "martine-gourbault"
  },
  {
    "slug": "marty-rhodes-figley"
  },
  {
    "slug": "mary-ann-goodnight"
  },
  {
    "slug": "mary-ann-hoberman"
  },
  {
    "slug": "mary-casanova"
  },
  {
    "slug": "mary-jane-auch"
  },
  {
    "slug": "mary-lyn-ray"
  },
  {
    "slug": "mary-mckenna-siddals"
  },
  {
    "slug": "mary-miche"
  },
  {
    "slug": "mary-morgan"
  },
  {
    "slug": "mary-nethery"
  },
  {
    "slug": "mary-quattlebaum"
  },
  {
    "slug": "mary-tavener-holmes"
  },
  {
    "slug": "mary-wormell"
  },
  {
    "slug": "maryam-faresh"
  },
  {
    "slug": "marybeth-lorbiecki"
  },
  {
    "slug": "maryrose-wood"
  },
  {
    "slug": "massachusetts"
  },
  {
    "slug": "materialism"
  },
  {
    "slug": "math"
  },
  {
    "slug": "mathematics"
  },
  {
    "slug": "maureen-mcdowell"
  },
  {
    "slug": "maurice-pledger"
  },
  {
    "slug": "maurice-sendak"
  },
  {
    "slug": "max-records"
  },
  {
    "slug": "maxwell-eaton-iii"
  },
  {
    "slug": "maya-gottfried"
  },
  {
    "slug": "meat"
  },
  {
    "slug": "meat-eating"
  },
  {
    "slug": "meatless-mondays"
  },
  {
    "slug": "medical-treatment"
  },
  {
    "slug": "medieval"
  },
  {
    "slug": "meditation"
  },
  {
    "slug": "meg-ohair"
  },
  {
    "slug": "megan-dowd-lambert"
  },
  {
    "slug": "megan-wagner-lloyd"
  },
  {
    "slug": "meggan-hill"
  },
  {
    "slug": "meilo-so"
  },
  {
    "slug": "melanie-monteiro"
  },
  {
    "slug": "melanie-watt"
  },
  {
    "slug": "melissa-stewart"
  },
  {
    "slug": "melissa-sweet"
  },
  {
    "slug": "melvin-berger"
  },
  {
    "slug": "mem-fox"
  },
  {
    "slug": "memoir"
  },
  {
    "slug": "memorial-day"
  },
  {
    "slug": "mermaids"
  },
  {
    "slug": "mesopotamia"
  },
  {
    "slug": "metamorphosis"
  },
  {
    "slug": "meteorology"
  },
  {
    "slug": "mexico"
  },
  {
    "slug": "mia-posada"
  },
  {
    "slug": "mice"
  },
  {
    "slug": "michael-beattie"
  },
  {
    "slug": "michael-croland"
  },
  {
    "slug": "michael-dahl"
  },
  {
    "slug": "michael-emberley"
  },
  {
    "slug": "michael-emberly"
  },
  {
    "slug": "michael-franti"
  },
  {
    "slug": "michael-j-dimotta"
  },
  {
    "slug": "michael-murphy"
  },
  {
    "slug": "michael-shoulders"
  },
  {
    "slug": "michael-wertz"
  },
  {
    "slug": "michelle-adams"
  },
  {
    "slug": "michelle-mee-nutter"
  },
  {
    "slug": "michelle-merkel"
  },
  {
    "slug": "middle-grade"
  },
  {
    "slug": "middle-grade-readers"
  },
  {
    "slug": "middle-readers"
  },
  {
    "slug": "middle-school"
  },
  {
    "slug": "migration"
  },
  {
    "slug": "mike-gordon"
  },
  {
    "slug": "mike-lowery"
  },
  {
    "slug": "mike-moran"
  },
  {
    "slug": "mike-reed"
  },
  {
    "slug": "military"
  },
  {
    "slug": "military-service"
  },
  {
    "slug": "mindfulness"
  },
  {
    "slug": "minerva-louise"
  },
  {
    "slug": "mini-grey"
  },
  {
    "slug": "minnesota"
  },
  {
    "slug": "mireille-levert"
  },
  {
    "slug": "miriam-ross"
  },
  {
    "slug": "mirna-kantarevic"
  },
  {
    "slug": "mischief"
  },
  {
    "slug": "miss-piggy"
  },
  {
    "slug": "mister-rogers"
  },
  {
    "slug": "mister-rogers-neighborhood"
  },
  {
    "slug": "mitali-perkins"
  },
  {
    "slug": "mo-willems"
  },
  {
    "slug": "moira-court"
  },
  {
    "slug": "mollie-katzen"
  },
  {
    "slug": "mollusks"
  },
  {
    "slug": "molly-frisinger"
  },
  {
    "slug": "molly-rose-goldman"
  },
  {
    "slug": "momma-animals"
  },
  {
    "slug": "moms-and-babies"
  },
  {
    "slug": "mona-kerby"
  },
  {
    "slug": "monica-wellington"
  },
  {
    "slug": "monkeys"
  },
  {
    "slug": "monsters"
  },
  {
    "slug": "montessori"
  },
  {
    "slug": "months"
  },
  {
    "slug": "moon"
  },
  {
    "slug": "moon-bears"
  },
  {
    "slug": "moon-landing"
  },
  {
    "slug": "moose"
  },
  {
    "slug": "morality"
  },
  {
    "slug": "morgan-freeman"
  },
  {
    "slug": "mosquitoes"
  },
  {
    "slug": "mosquitos"
  },
  {
    "slug": "mothers-day"
  },
  {
    "slug": "mothers"
  },
  {
    "slug": "mount-rushmore"
  },
  {
    "slug": "mountain-chef"
  },
  {
    "slug": "mouse"
  },
  {
    "slug": "movies-based-on-books"
  },
  {
    "slug": "movies-for-vegetarian-kids"
  },
  {
    "slug": "mr-mcgregor"
  },
  {
    "slug": "mrs-frisby-and-the-rats-of-nimh"
  },
  {
    "slug": "mules"
  },
  {
    "slug": "multicultural"
  },
  {
    "slug": "muppets"
  },
  {
    "slug": "music"
  },
  {
    "slug": "music-for-babies"
  },
  {
    "slug": "musical"
  },
  {
    "slug": "must-have"
  },
  {
    "slug": "mutts"
  },
  {
    "slug": "my-friend-rabbit"
  },
  {
    "slug": "mystery"
  },
  {
    "slug": "mythical-creatures"
  },
  {
    "slug": "mythology"
  },
  {
    "slug": "nancy-coffelt"
  },
  {
    "slug": "nancy-furstinger"
  },
  {
    "slug": "nancy-krulik"
  },
  {
    "slug": "nancy-tafuri"
  },
  {
    "slug": "nancy-tillman"
  },
  {
    "slug": "nancy-willard"
  },
  {
    "slug": "naoko-stoop"
  },
  {
    "slug": "natasha-yim"
  },
  {
    "slug": "nathalie-vanbalen"
  },
  {
    "slug": "national-geographic"
  },
  {
    "slug": "national-park-service"
  },
  {
    "slug": "national-parks"
  },
  {
    "slug": "native-american"
  },
  {
    "slug": "native-american-nations"
  },
  {
    "slug": "native-american-truths-everyone-should-know"
  },
  {
    "slug": "native-peoples"
  },
  {
    "slug": "natural-history"
  },
  {
    "slug": "natural-living"
  },
  {
    "slug": "natural-resources-defense-council"
  },
  {
    "slug": "nature"
  },
  {
    "slug": "nature-books"
  },
  {
    "slug": "nature-books-for-kids"
  },
  {
    "slug": "nature-is-not-infinite"
  },
  {
    "slug": "nearly-wordless-books"
  },
  {
    "slug": "nebulizer"
  },
  {
    "slug": "negative-messages-about-vegetarianism"
  },
  {
    "slug": "negotiation"
  },
  {
    "slug": "neighbors"
  },
  {
    "slug": "neil-gaiman"
  },
  {
    "slug": "neuter"
  },
  {
    "slug": "new-england"
  },
  {
    "slug": "new-jersey"
  },
  {
    "slug": "new-orleans"
  },
  {
    "slug": "new-sibling"
  },
  {
    "slug": "new-year"
  },
  {
    "slug": "new-york-city"
  },
  {
    "slug": "new-york-times-best-illustrated-childrens-book"
  },
  {
    "slug": "new-york-times-best-illustrated-childrens-books-of-2006"
  },
  {
    "slug": "new-york-times-best-illustrated-childrens-books-of-2008"
  },
  {
    "slug": "new-york-times-best-illustrated-childrens-books-of-2009"
  },
  {
    "slug": "new-york-times-best-illustrated-childrens-books-of-2010"
  },
  {
    "slug": "new-york-times-best-illustrated-childrens-books-of-2011"
  },
  {
    "slug": "nic-bishop"
  },
  {
    "slug": "nick-bland"
  },
  {
    "slug": "nick-bruel"
  },
  {
    "slug": "nick-russell"
  },
  {
    "slug": "nick-sharratt"
  },
  {
    "slug": "nicole-de-cock"
  },
  {
    "slug": "nicole-wong"
  },
  {
    "slug": "nighttime"
  },
  {
    "slug": "nikki-mcclure"
  },
  {
    "slug": "ninjas"
  },
  {
    "slug": "noahs-ark"
  },
  {
    "slug": "nobel-peace-prize"
  },
  {
    "slug": "nocturnal-animals"
  },
  {
    "slug": "non-fiction"
  },
  {
    "slug": "nonfiction"
  },
  {
    "slug": "nonviolence"
  },
  {
    "slug": "norton-young-readers"
  },
  {
    "slug": "not-a-nugget"
  },
  {
    "slug": "not-a-purse"
  },
  {
    "slug": "novel"
  },
  {
    "slug": "now-you-know-what-you-eat"
  },
  {
    "slug": "nrdc"
  },
  {
    "slug": "nursery-rhymes"
  },
  {
    "slug": "nutrition"
  },
  {
    "slug": "ocean"
  },
  {
    "slug": "ocean-animals"
  },
  {
    "slug": "ocean-clean-up"
  },
  {
    "slug": "oceana"
  },
  {
    "slug": "oceanography"
  },
  {
    "slug": "oceans"
  },
  {
    "slug": "ocelots"
  },
  {
    "slug": "oh-so-kind"
  },
  {
    "slug": "ohio-university-press"
  },
  {
    "slug": "oil-spill"
  },
  {
    "slug": "old-growth-forest"
  },
  {
    "slug": "older-elementary"
  },
  {
    "slug": "olivia"
  },
  {
    "slug": "olivia-bouler"
  },
  {
    "slug": "one-little-bag"
  },
  {
    "slug": "opossums"
  },
  {
    "slug": "opposites"
  },
  {
    "slug": "oprah-winfrey"
  },
  {
    "slug": "orangutan"
  },
  {
    "slug": "orangutans"
  },
  {
    "slug": "orca"
  },
  {
    "slug": "orcas"
  },
  {
    "slug": "organic"
  },
  {
    "slug": "originality"
  },
  {
    "slug": "origins-of-the-universe"
  },
  {
    "slug": "otters"
  },
  {
    "slug": "out-of-my-shell"
  },
  {
    "slug": "overcoming-fear"
  },
  {
    "slug": "overpackaging"
  },
  {
    "slug": "owl"
  },
  {
    "slug": "owls"
  },
  {
    "slug": "oxen"
  },
  {
    "slug": "p-d-eastman"
  },
  {
    "slug": "p-i-maltbie"
  },
  {
    "slug": "pacific-ocean"
  },
  {
    "slug": "painting"
  },
  {
    "slug": "pakistan"
  },
  {
    "slug": "pale-male"
  },
  {
    "slug": "palm-sunday"
  },
  {
    "slug": "pam-munoz-ryan"
  },
  {
    "slug": "pamela-duncan-edwards"
  },
  {
    "slug": "pamela-lofts"
  },
  {
    "slug": "panama"
  },
  {
    "slug": "pancakes"
  },
  {
    "slug": "pandas"
  },
  {
    "slug": "pangolins"
  },
  {
    "slug": "panthers"
  },
  {
    "slug": "paper-cutting"
  },
  {
    "slug": "parades"
  },
  {
    "slug": "pardoning-of-the-turkey"
  },
  {
    "slug": "parenting"
  },
  {
    "slug": "parents"
  },
  {
    "slug": "paris"
  },
  {
    "slug": "parrots"
  },
  {
    "slug": "pascal-lemaitre"
  },
  {
    "slug": "passover"
  },
  {
    "slug": "pastel"
  },
  {
    "slug": "pat-derby"
  },
  {
    "slug": "patricia-castelao"
  },
  {
    "slug": "patricia-j-wynne"
  },
  {
    "slug": "patricia-l-atchison"
  },
  {
    "slug": "patricia-maclachlan"
  },
  {
    "slug": "patrick-mcdonnell"
  },
  {
    "slug": "patrick-young"
  },
  {
    "slug": "paul-carrick"
  },
  {
    "slug": "paul-fleischman"
  },
  {
    "slug": "paul-helou"
  },
  {
    "slug": "paul-lee"
  },
  {
    "slug": "paul-mirocha"
  },
  {
    "slug": "paul-rogers"
  },
  {
    "slug": "paul-showers"
  },
  {
    "slug": "paul-zelinsky"
  },
  {
    "slug": "paula-goodman-koz"
  },
  {
    "slug": "paula-kahumbu"
  },
  {
    "slug": "paula-weiner"
  },
  {
    "slug": "pcrm"
  },
  {
    "slug": "peace"
  },
  {
    "slug": "peacemakers"
  },
  {
    "slug": "peas"
  },
  {
    "slug": "peer-pressure"
  },
  {
    "slug": "peg-kehret"
  },
  {
    "slug": "peggy-thomas"
  },
  {
    "slug": "penguins"
  },
  {
    "slug": "percy-jackson"
  },
  {
    "slug": "percy-jackson-and-the-olympians"
  },
  {
    "slug": "performing-animals"
  },
  {
    "slug": "persecution"
  },
  {
    "slug": "perseverence"
  },
  {
    "slug": "persistence"
  },
  {
    "slug": "peskimo"
  },
  {
    "slug": "pet-overpopulation"
  },
  {
    "slug": "pet-stores"
  },
  {
    "slug": "pet-trade"
  },
  {
    "slug": "peta"
  },
  {
    "slug": "peter-brown"
  },
  {
    "slug": "peter-christie"
  },
  {
    "slug": "peter-h-reynolds"
  },
  {
    "slug": "peter-maloney"
  },
  {
    "slug": "peter-parnell"
  },
  {
    "slug": "peter-rabbit"
  },
  {
    "slug": "pets"
  },
  {
    "slug": "pets-for-life"
  },
  {
    "slug": "philip-c-stead"
  },
  {
    "slug": "philip-reid"
  },
  {
    "slug": "phillip-hoose"
  },
  {
    "slug": "phoebe-gilman"
  },
  {
    "slug": "photography"
  },
  {
    "slug": "photos"
  },
  {
    "slug": "picture-book"
  },
  {
    "slug": "picture-books"
  },
  {
    "slug": "pie"
  },
  {
    "slug": "piet-grobler"
  },
  {
    "slug": "pig"
  },
  {
    "slug": "pigeon"
  },
  {
    "slug": "pigeons"
  },
  {
    "slug": "piggie-and-elephant"
  },
  {
    "slug": "pigs"
  },
  {
    "slug": "pink"
  },
  {
    "slug": "pixar"
  },
  {
    "slug": "plant-cook-eat"
  },
  {
    "slug": "plant-powered-protein-cookbook"
  },
  {
    "slug": "plants"
  },
  {
    "slug": "plastic-sucks"
  },
  {
    "slug": "playground-games"
  },
  {
    "slug": "poaching"
  },
  {
    "slug": "poems"
  },
  {
    "slug": "poetry"
  },
  {
    "slug": "poets"
  },
  {
    "slug": "polar-bears"
  },
  {
    "slug": "police"
  },
  {
    "slug": "political-process"
  },
  {
    "slug": "politics"
  },
  {
    "slug": "pollination"
  },
  {
    "slug": "pollution"
  },
  {
    "slug": "polly-dunbar"
  },
  {
    "slug": "polly-m-robertus"
  },
  {
    "slug": "ponds"
  },
  {
    "slug": "pooh"
  },
  {
    "slug": "poop"
  },
  {
    "slug": "poopendous"
  },
  {
    "slug": "pop-culture"
  },
  {
    "slug": "portrayal-of-vegetarians-in-books"
  },
  {
    "slug": "portrayal-of-vegetarians-in-film"
  },
  {
    "slug": "possums"
  },
  {
    "slug": "postal-service"
  },
  {
    "slug": "potty-training"
  },
  {
    "slug": "pout-pout-fish"
  },
  {
    "slug": "poverty"
  },
  {
    "slug": "power"
  },
  {
    "slug": "prairie-chickens"
  },
  {
    "slug": "prairie-dogs"
  },
  {
    "slug": "prairie-voles"
  },
  {
    "slug": "prairies"
  },
  {
    "slug": "prayer"
  },
  {
    "slug": "prayer-for-world-peace"
  },
  {
    "slug": "pre-k"
  },
  {
    "slug": "pre-k-readers"
  },
  {
    "slug": "predators"
  },
  {
    "slug": "preschool"
  },
  {
    "slug": "preschool-book"
  },
  {
    "slug": "preschool-readers"
  },
  {
    "slug": "preschoolers"
  },
  {
    "slug": "president"
  },
  {
    "slug": "president-kennedy"
  },
  {
    "slug": "president-roosevelt"
  },
  {
    "slug": "president-taylor"
  },
  {
    "slug": "primates"
  },
  {
    "slug": "princess"
  },
  {
    "slug": "problem-solving"
  },
  {
    "slug": "protests"
  },
  {
    "slug": "pterodactyl"
  },
  {
    "slug": "puberty"
  },
  {
    "slug": "public-transit"
  },
  {
    "slug": "pug"
  },
  {
    "slug": "pugs"
  },
  {
    "slug": "pumpkins"
  },
  {
    "slug": "puppy"
  },
  {
    "slug": "puppy-mills"
  },
  {
    "slug": "pura-belpre-award-winner"
  },
  {
    "slug": "pythons"
  },
  {
    "slug": "quabbin-reservoir"
  },
  {
    "slug": "queen-rania-of-jordan-al-abdullah"
  },
  {
    "slug": "quentin-blake"
  },
  {
    "slug": "quotations"
  },
  {
    "slug": "r-gregory-christie"
  },
  {
    "slug": "r-p-harris"
  },
  {
    "slug": "r-j-palacio"
  },
  {
    "slug": "rabbits"
  },
  {
    "slug": "raccoons"
  },
  {
    "slug": "rachel-carson"
  },
  {
    "slug": "rachel-riordan"
  },
  {
    "slug": "rainforest"
  },
  {
    "slug": "raising-vegan-kids"
  },
  {
    "slug": "raising-vegetarian-kids"
  },
  {
    "slug": "rajani-larocca"
  },
  {
    "slug": "raksha-bandhan"
  },
  {
    "slug": "ralph-waldo-emerson"
  },
  {
    "slug": "raptors"
  },
  {
    "slug": "rat"
  },
  {
    "slug": "ratatouille"
  },
  {
    "slug": "rats"
  },
  {
    "slug": "raul-colon"
  },
  {
    "slug": "raw-foods"
  },
  {
    "slug": "read-aloud"
  },
  {
    "slug": "read-aloud-book"
  },
  {
    "slug": "read-aloud-books"
  },
  {
    "slug": "reading"
  },
  {
    "slug": "reading-picture-books-with-children"
  },
  {
    "slug": "reading-rainbow"
  },
  {
    "slug": "rebekah-raye"
  },
  {
    "slug": "recess-monkey"
  },
  {
    "slug": "recipes"
  },
  {
    "slug": "recycled-paper-books"
  },
  {
    "slug": "recycling"
  },
  {
    "slug": "reduce-reuse-recycle"
  },
  {
    "slug": "reducing-waste"
  },
  {
    "slug": "redwood-trees"
  },
  {
    "slug": "reef"
  },
  {
    "slug": "reindeer"
  },
  {
    "slug": "religion"
  },
  {
    "slug": "religious-books"
  },
  {
    "slug": "renanah-lehner"
  },
  {
    "slug": "renewable-energy"
  },
  {
    "slug": "reproduction"
  },
  {
    "slug": "reptiles"
  },
  {
    "slug": "resale"
  },
  {
    "slug": "rescue"
  },
  {
    "slug": "respect-for-nature"
  },
  {
    "slug": "responsibility"
  },
  {
    "slug": "responsible-consumer-choices"
  },
  {
    "slug": "reverence"
  },
  {
    "slug": "reviews-by-kids"
  },
  {
    "slug": "rhinos"
  },
  {
    "slug": "rhonda-lucas-donald"
  },
  {
    "slug": "rhyme"
  },
  {
    "slug": "rhyming-books"
  },
  {
    "slug": "rich-lo"
  },
  {
    "slug": "richard-e-albert"
  },
  {
    "slug": "richard-gere"
  },
  {
    "slug": "richard-p-campbell"
  },
  {
    "slug": "richard-sobol"
  },
  {
    "slug": "richard-w-jennings"
  },
  {
    "slug": "rick-swann"
  },
  {
    "slug": "ringo-starr"
  },
  {
    "slug": "rita-williams-garcia"
  },
  {
    "slug": "roald-dahl"
  },
  {
    "slug": "roaring-book-press"
  },
  {
    "slug": "rob-harrell"
  },
  {
    "slug": "rob-laidlaw"
  },
  {
    "slug": "robbyn-smith-van-frankenhuyzen"
  },
  {
    "slug": "robert-c-obrien"
  },
  {
    "slug": "robert-mccloskey"
  },
  {
    "slug": "robert-noreika"
  },
  {
    "slug": "robert-nutt"
  },
  {
    "slug": "robert-orchanian"
  },
  {
    "slug": "robert-oser"
  },
  {
    "slug": "robert-rahway-zakanitch"
  },
  {
    "slug": "robert-redford"
  },
  {
    "slug": "robert-skutch"
  },
  {
    "slug": "roberta-baker"
  },
  {
    "slug": "roberta-edwards"
  },
  {
    "slug": "robin-glasser"
  },
  {
    "slug": "robin-hill-school"
  },
  {
    "slug": "robin-page"
  },
  {
    "slug": "robin-preiss-glasser"
  },
  {
    "slug": "robin-pulver"
  },
  {
    "slug": "robin-raven"
  },
  {
    "slug": "robots"
  },
  {
    "slug": "robyn-moore"
  },
  {
    "slug": "robyn-ringgold"
  },
  {
    "slug": "rodents"
  },
  {
    "slug": "roger-few"
  },
  {
    "slug": "roger-payne"
  },
  {
    "slug": "role-model"
  },
  {
    "slug": "role-of-women"
  },
  {
    "slug": "roma-gans"
  },
  {
    "slug": "ron-hirschi"
  },
  {
    "slug": "ron-robrahn"
  },
  {
    "slug": "ronald-himler"
  },
  {
    "slug": "roots-and-shoots"
  },
  {
    "slug": "rosalind-beardshaw"
  },
  {
    "slug": "rose-a-lewis"
  },
  {
    "slug": "rose-anne-prevec"
  },
  {
    "slug": "roseanne-thong"
  },
  {
    "slug": "roses"
  },
  {
    "slug": "ross-burach"
  },
  {
    "slug": "roxie-munro"
  },
  {
    "slug": "roy-freeman"
  },
  {
    "slug": "roy-mckie"
  },
  {
    "slug": "ruby-roth"
  },
  {
    "slug": "rudolph"
  },
  {
    "slug": "rural-living"
  },
  {
    "slug": "ruth-brown"
  },
  {
    "slug": "ruth-heller"
  },
  {
    "slug": "ruth-krauss"
  },
  {
    "slug": "ruth-spiro"
  },
  {
    "slug": "ryan-sias"
  },
  {
    "slug": "s-terrell-french"
  },
  {
    "slug": "s-d-nelson"
  },
  {
    "slug": "saints"
  },
  {
    "slug": "salmon"
  },
  {
    "slug": "sam-cladwell"
  },
  {
    "slug": "sam-mcbratney"
  },
  {
    "slug": "samuel-clemens"
  },
  {
    "slug": "sanctuaries"
  },
  {
    "slug": "sandi-lancaster"
  },
  {
    "slug": "sandra-boynton"
  },
  {
    "slug": "sandra-f-stern"
  },
  {
    "slug": "sandra-magsamen"
  },
  {
    "slug": "sandra-markle"
  },
  {
    "slug": "santa-claus"
  },
  {
    "slug": "sara-gillingham"
  },
  {
    "slug": "sara-palacios"
  },
  {
    "slug": "sarah-c-campbell"
  },
  {
    "slug": "sarah-forss"
  },
  {
    "slug": "sarah-hill"
  },
  {
    "slug": "sarah-hines-stephens"
  },
  {
    "slug": "sarah-rudy"
  },
  {
    "slug": "sarah-s-brannen"
  },
  {
    "slug": "sarah-stewart"
  },
  {
    "slug": "saris"
  },
  {
    "slug": "saving"
  },
  {
    "slug": "saving-emma-the-pig"
  },
  {
    "slug": "saviour-pirotta"
  },
  {
    "slug": "sayward-rebhal"
  },
  {
    "slug": "school"
  },
  {
    "slug": "science"
  },
  {
    "slug": "science-books"
  },
  {
    "slug": "scott-magoon"
  },
  {
    "slug": "scott-menchin"
  },
  {
    "slug": "scuba-diving"
  },
  {
    "slug": "sea-creatures"
  },
  {
    "slug": "sea-life"
  },
  {
    "slug": "sea-lions"
  },
  {
    "slug": "sea-turtles"
  },
  {
    "slug": "sea-vegetables"
  },
  {
    "slug": "seahorses"
  },
  {
    "slug": "seals"
  },
  {
    "slug": "sean-franzen"
  },
  {
    "slug": "sean-qualls"
  },
  {
    "slug": "sean-r-smith"
  },
  {
    "slug": "seashells"
  },
  {
    "slug": "seashells-more-than-a-home"
  },
  {
    "slug": "seashores"
  },
  {
    "slug": "seaside-stroll"
  },
  {
    "slug": "seasons"
  },
  {
    "slug": "selena-alko"
  },
  {
    "slug": "self-esteem"
  },
  {
    "slug": "self-acceptance"
  },
  {
    "slug": "senses"
  },
  {
    "slug": "sensitivity"
  },
  {
    "slug": "september-11"
  },
  {
    "slug": "sequential-art"
  },
  {
    "slug": "series"
  },
  {
    "slug": "service-dog"
  },
  {
    "slug": "shabbat"
  },
  {
    "slug": "shakira"
  },
  {
    "slug": "shane-prigmore"
  },
  {
    "slug": "shannon-hale"
  },
  {
    "slug": "shared-reading"
  },
  {
    "slug": "sharing"
  },
  {
    "slug": "shark-week"
  },
  {
    "slug": "sharks"
  },
  {
    "slug": "sharon-creech"
  },
  {
    "slug": "sharon-werner"
  },
  {
    "slug": "sharon-young"
  },
  {
    "slug": "shaunna-peterson"
  },
  {
    "slug": "sheep"
  },
  {
    "slug": "shel-silverstein"
  },
  {
    "slug": "shelley-gill"
  },
  {
    "slug": "shelli-paroline"
  },
  {
    "slug": "shennen-bersani"
  },
  {
    "slug": "sherri-duskey-rinker"
  },
  {
    "slug": "sherry-been"
  },
  {
    "slug": "sheryl-haft"
  },
  {
    "slug": "sheryl-l-pipe"
  },
  {
    "slug": "shinta-cho"
  },
  {
    "slug": "shirley-felts"
  },
  {
    "slug": "shore"
  },
  {
    "slug": "short-stories"
  },
  {
    "slug": "siblings"
  },
  {
    "slug": "sicklebacks"
  },
  {
    "slug": "sign-language"
  },
  {
    "slug": "silly-and-fun"
  },
  {
    "slug": "silly-books"
  },
  {
    "slug": "simon-james"
  },
  {
    "slug": "simon-james-green"
  },
  {
    "slug": "simple-living"
  },
  {
    "slug": "single-use-plastic"
  },
  {
    "slug": "siobhan-vivian"
  },
  {
    "slug": "sitting-bull"
  },
  {
    "slug": "skunks"
  },
  {
    "slug": "slaughterhouse"
  },
  {
    "slug": "slavery"
  },
  {
    "slug": "sleep"
  },
  {
    "slug": "sloths"
  },
  {
    "slug": "small-farms"
  },
  {
    "slug": "smilodon"
  },
  {
    "slug": "smoothies"
  },
  {
    "slug": "snail"
  },
  {
    "slug": "snails"
  },
  {
    "slug": "snake"
  },
  {
    "slug": "snakes"
  },
  {
    "slug": "sneed-b-collard-iii"
  },
  {
    "slug": "snow"
  },
  {
    "slug": "social-justice"
  },
  {
    "slug": "sofia-cardoso"
  },
  {
    "slug": "sofia-sanchez"
  },
  {
    "slug": "solar-power"
  },
  {
    "slug": "soldiers"
  },
  {
    "slug": "songs"
  },
  {
    "slug": "soon-to-be-published"
  },
  {
    "slug": "sophie-goldstein"
  },
  {
    "slug": "south-africa"
  },
  {
    "slug": "south-pole"
  },
  {
    "slug": "soymilk"
  },
  {
    "slug": "space"
  },
  {
    "slug": "spanish"
  },
  {
    "slug": "sparrows"
  },
  {
    "slug": "spay"
  },
  {
    "slug": "special-needs"
  },
  {
    "slug": "speciesism"
  },
  {
    "slug": "speech"
  },
  {
    "slug": "spider"
  },
  {
    "slug": "spiders"
  },
  {
    "slug": "spike-jonze"
  },
  {
    "slug": "spike-lee"
  },
  {
    "slug": "spinach"
  },
  {
    "slug": "spiny-anteater"
  },
  {
    "slug": "spiritual"
  },
  {
    "slug": "spring"
  },
  {
    "slug": "squirrel"
  },
  {
    "slug": "squirrels"
  },
  {
    "slug": "stacy-tornio"
  },
  {
    "slug": "stan-berenstain"
  },
  {
    "slug": "star-wars"
  },
  {
    "slug": "starlings"
  },
  {
    "slug": "stef-soto-taco-queen"
  },
  {
    "slug": "stem"
  },
  {
    "slug": "stephanie-dreyer"
  },
  {
    "slug": "stephanie-howard"
  },
  {
    "slug": "stephen-huneck"
  },
  {
    "slug": "stephen-krensky"
  },
  {
    "slug": "stephen-whyllie"
  },
  {
    "slug": "steve-cox"
  },
  {
    "slug": "steve-engel"
  },
  {
    "slug": "steve-james"
  },
  {
    "slug": "steve-jenkins"
  },
  {
    "slug": "steve-metzger"
  },
  {
    "slug": "steven-guarnaccia"
  },
  {
    "slug": "steven-henry"
  },
  {
    "slug": "steven-james-petruccio"
  },
  {
    "slug": "steven-kellogg"
  },
  {
    "slug": "steven-kroll"
  },
  {
    "slug": "steven-sellers-lapham"
  },
  {
    "slug": "steven-spielberg"
  },
  {
    "slug": "storytelling"
  },
  {
    "slug": "storytelling-math"
  },
  {
    "slug": "stray"
  },
  {
    "slug": "streaming-movies"
  },
  {
    "slug": "stretch-to-the-sun"
  },
  {
    "slug": "strike"
  },
  {
    "slug": "stuart-gibbs"
  },
  {
    "slug": "stuart-j-murphy"
  },
  {
    "slug": "stuff"
  },
  {
    "slug": "sue-ganz-schmitt"
  },
  {
    "slug": "sue-hendra"
  },
  {
    "slug": "sue-macy"
  },
  {
    "slug": "sue-pyatt"
  },
  {
    "slug": "sue-truesdell"
  },
  {
    "slug": "suffrage"
  },
  {
    "slug": "summer"
  },
  {
    "slug": "summer-activities"
  },
  {
    "slug": "summer-books"
  },
  {
    "slug": "summer-vacation"
  },
  {
    "slug": "summertime-sleepers"
  },
  {
    "slug": "sunayana-nair-kanjilal"
  },
  {
    "slug": "superheroes"
  },
  {
    "slug": "supportive-parents"
  },
  {
    "slug": "surreal"
  },
  {
    "slug": "survival"
  },
  {
    "slug": "susan-b-anthony"
  },
  {
    "slug": "susan-boase"
  },
  {
    "slug": "susan-campbell-bartoletti"
  },
  {
    "slug": "susan-kelly"
  },
  {
    "slug": "susan-m-graunke"
  },
  {
    "slug": "susan-m-maithya"
  },
  {
    "slug": "susan-meddaugh"
  },
  {
    "slug": "susan-meyer"
  },
  {
    "slug": "susan-rooker"
  },
  {
    "slug": "susan-swan"
  },
  {
    "slug": "susan-vanhecke"
  },
  {
    "slug": "susan-verde"
  },
  {
    "slug": "susannah-blake"
  },
  {
    "slug": "suzanna-slade"
  },
  {
    "slug": "suzanne-bloom"
  },
  {
    "slug": "suzanne-havala"
  },
  {
    "slug": "suzanne-lewis"
  },
  {
    "slug": "suzi-eszterhas"
  },
  {
    "slug": "suzy-lee"
  },
  {
    "slug": "swamps"
  },
  {
    "slug": "swans"
  },
  {
    "slug": "sweden"
  },
  {
    "slug": "sweets"
  },
  {
    "slug": "swimming"
  },
  {
    "slug": "sy-montgomery"
  },
  {
    "slug": "sybil-severin"
  },
  {
    "slug": "sydney-taylor-honor-book-for-younger-readers"
  },
  {
    "slug": "sylvia-earle"
  },
  {
    "slug": "sylvia-long"
  },
  {
    "slug": "sylvia-plath"
  },
  {
    "slug": "t-rex"
  },
  {
    "slug": "tacos"
  },
  {
    "slug": "tad-carpenter"
  },
  {
    "slug": "tadpoles"
  },
  {
    "slug": "taeeun-yoo"
  },
  {
    "slug": "tag-sales"
  },
  {
    "slug": "talent"
  },
  {
    "slug": "tall-tales"
  },
  {
    "slug": "tamara-petrosino"
  },
  {
    "slug": "tami-charles"
  },
  {
    "slug": "tami-crupi-zeman"
  },
  {
    "slug": "tanja-bauerle"
  },
  {
    "slug": "tapirs"
  },
  {
    "slug": "teachers"
  },
  {
    "slug": "teasing"
  },
  {
    "slug": "technology"
  },
  {
    "slug": "teeth"
  },
  {
    "slug": "television"
  },
  {
    "slug": "temple-grandin"
  },
  {
    "slug": "ten-animals-in-antarctica"
  },
  {
    "slug": "terc"
  },
  {
    "slug": "teresa-bateman"
  },
  {
    "slug": "teri-rider"
  },
  {
    "slug": "teri-weidner"
  },
  {
    "slug": "terrorism"
  },
  {
    "slug": "terry-collins"
  },
  {
    "slug": "terry-golson"
  },
  {
    "slug": "testuya-honda"
  },
  {
    "slug": "texas"
  },
  {
    "slug": "thai-foods"
  },
  {
    "slug": "thailand"
  },
  {
    "slug": "thankfulness"
  },
  {
    "slug": "thanks"
  },
  {
    "slug": "thanksgiving"
  },
  {
    "slug": "thanksgiving-books-for-vegetarian-kids"
  },
  {
    "slug": "the-amazon"
  },
  {
    "slug": "the-biggest-little-farm"
  },
  {
    "slug": "the-deer-in-the-wood"
  },
  {
    "slug": "the-dogs-of-camelot"
  },
  {
    "slug": "the-great-big-hug"
  },
  {
    "slug": "the-happiest-tree"
  },
  {
    "slug": "the-help-yourself-cookbook-for-kids"
  },
  {
    "slug": "the-holocaust"
  },
  {
    "slug": "the-horn-book"
  },
  {
    "slug": "the-julian-chapter"
  },
  {
    "slug": "the-kids-outdoor-adventure-book"
  },
  {
    "slug": "the-little-butterfly-that-could"
  },
  {
    "slug": "the-little-yellow-leaf"
  },
  {
    "slug": "the-love-of-a-lab"
  },
  {
    "slug": "the-monster-mall"
  },
  {
    "slug": "the-pepper-party"
  },
  {
    "slug": "the-pepper-party-picks-the-perfect-pet"
  },
  {
    "slug": "the-plantiful-plate"
  },
  {
    "slug": "the-pout-pout-fish-cleans-up-the-ocean"
  },
  {
    "slug": "the-truth-about-elephants"
  },
  {
    "slug": "the-truth-about-hawks"
  },
  {
    "slug": "the-unicorn-came-to-dinner"
  },
  {
    "slug": "therapy-animals"
  },
  {
    "slug": "theresa-martin-golding"
  },
  {
    "slug": "thomas-d-mangelson"
  },
  {
    "slug": "thomas-gonzalez"
  },
  {
    "slug": "thomas-yezerski"
  },
  {
    "slug": "thoughtfulness"
  },
  {
    "slug": "three-little-pigs"
  },
  {
    "slug": "tie-sing"
  },
  {
    "slug": "tierney-thys"
  },
  {
    "slug": "tiffany-whitfield"
  },
  {
    "slug": "tiger"
  },
  {
    "slug": "tigers"
  },
  {
    "slug": "tilly-spetgang"
  },
  {
    "slug": "tim-bowers"
  },
  {
    "slug": "tim-burton"
  },
  {
    "slug": "tim-enstice"
  },
  {
    "slug": "tim-flannery"
  },
  {
    "slug": "tim-preston"
  },
  {
    "slug": "timothy-basil-ering"
  },
  {
    "slug": "toads"
  },
  {
    "slug": "todd-hall"
  },
  {
    "slug": "todd-parr"
  },
  {
    "slug": "toddlers"
  },
  {
    "slug": "tofu"
  },
  {
    "slug": "tolerance"
  },
  {
    "slug": "tom-leigh"
  },
  {
    "slug": "tom-lichtenheld"
  },
  {
    "slug": "tomi-depaola"
  },
  {
    "slug": "toni-buzzeo"
  },
  {
    "slug": "tony-bradman"
  },
  {
    "slug": "tony-johnston"
  },
  {
    "slug": "tony-lawlor"
  },
  {
    "slug": "tony-ross"
  },
  {
    "slug": "tonya-bolden"
  },
  {
    "slug": "tonya-lee"
  },
  {
    "slug": "tooth-fairy"
  },
  {
    "slug": "tortoises"
  },
  {
    "slug": "touch-and-feel"
  },
  {
    "slug": "tove-jansson"
  },
  {
    "slug": "toys"
  },
  {
    "slug": "tracee-yablon-brenner"
  },
  {
    "slug": "traci-sorell"
  },
  {
    "slug": "tractors"
  },
  {
    "slug": "trains"
  },
  {
    "slug": "transformation"
  },
  {
    "slug": "trash"
  },
  {
    "slug": "tree"
  },
  {
    "slug": "tree-of-dreams"
  },
  {
    "slug": "trees"
  },
  {
    "slug": "trenton-lee-stewart"
  },
  {
    "slug": "tribes"
  },
  {
    "slug": "tricia-tusa"
  },
  {
    "slug": "trina-l-hunner"
  },
  {
    "slug": "trophic-cascade"
  },
  {
    "slug": "troy-nesbit"
  },
  {
    "slug": "trudy-calvert"
  },
  {
    "slug": "trudy-joost"
  },
  {
    "slug": "trust"
  },
  {
    "slug": "turkeys"
  },
  {
    "slug": "turtles"
  },
  {
    "slug": "two-dad-families"
  },
  {
    "slug": "two-mom-families"
  },
  {
    "slug": "tyree-guyton"
  },
  {
    "slug": "tzuling-liu"
  },
  {
    "slug": "uganda"
  },
  {
    "slug": "ulises-farina"
  },
  {
    "slug": "unconditional-love"
  },
  {
    "slug": "underwear"
  },
  {
    "slug": "unicorn"
  },
  {
    "slug": "unicorns"
  },
  {
    "slug": "united-states"
  },
  {
    "slug": "unusual-animals"
  },
  {
    "slug": "upcycling"
  },
  {
    "slug": "urban"
  },
  {
    "slug": "urban-living"
  },
  {
    "slug": "urban-sprawl"
  },
  {
    "slug": "urban-wildlife"
  },
  {
    "slug": "usa-border"
  },
  {
    "slug": "use-of-animals"
  },
  {
    "slug": "valentines-day"
  },
  {
    "slug": "valerie-worth"
  },
  {
    "slug": "valorie-fisher"
  },
  {
    "slug": "vampires"
  },
  {
    "slug": "vanessa-brantley-newton"
  },
  {
    "slug": "vanessa-williams"
  },
  {
    "slug": "veegmama"
  },
  {
    "slug": "vegan"
  },
  {
    "slug": "vegan-action"
  },
  {
    "slug": "vegan-author"
  },
  {
    "slug": "vegan-baking"
  },
  {
    "slug": "vegan-childrens-book"
  },
  {
    "slug": "vegan-childrens-books"
  },
  {
    "slug": "vegan-cook"
  },
  {
    "slug": "vegan-cookbooks"
  },
  {
    "slug": "vegan-cooking"
  },
  {
    "slug": "vegan-eating"
  },
  {
    "slug": "vegan-fairytale"
  },
  {
    "slug": "vegan-is-love"
  },
  {
    "slug": "vegan-kids"
  },
  {
    "slug": "vegan-outreach"
  },
  {
    "slug": "vegan-parenting"
  },
  {
    "slug": "vegan-parents"
  },
  {
    "slug": "vegan-pregnancy"
  },
  {
    "slug": "vegan-protagonist"
  },
  {
    "slug": "vegan-teens"
  },
  {
    "slug": "vegan-thanksgiving"
  },
  {
    "slug": "vegetable-books"
  },
  {
    "slug": "vegetables"
  },
  {
    "slug": "vegetarian"
  },
  {
    "slug": "vegetarian-author"
  },
  {
    "slug": "vegetarian-baby-food"
  },
  {
    "slug": "vegetarian-characters"
  },
  {
    "slug": "vegetarian-children"
  },
  {
    "slug": "vegetarian-christmas"
  },
  {
    "slug": "vegetarian-cookbooks"
  },
  {
    "slug": "vegetarian-cooking"
  },
  {
    "slug": "vegetarian-eating"
  },
  {
    "slug": "vegetarian-family"
  },
  {
    "slug": "vegetarian-kids"
  },
  {
    "slug": "vegetarian-kids-books"
  },
  {
    "slug": "vegetarian-protagonist"
  },
  {
    "slug": "vegetarian-thanksgiving"
  },
  {
    "slug": "vegetarian-times"
  },
  {
    "slug": "vegetarians-in-films"
  },
  {
    "slug": "vera-b-williams"
  },
  {
    "slug": "veterinarian"
  },
  {
    "slug": "vicki-myron"
  },
  {
    "slug": "vicki-wong"
  },
  {
    "slug": "victoria-boutenko"
  },
  {
    "slug": "victoria-kahn"
  },
  {
    "slug": "victoria-perla"
  },
  {
    "slug": "vietnam"
  },
  {
    "slug": "vincent-desjardins"
  },
  {
    "slug": "vincent-nguyen"
  },
  {
    "slug": "violence"
  },
  {
    "slug": "violet-mackerel"
  },
  {
    "slug": "virginia-shin-mui-loh"
  },
  {
    "slug": "virtues"
  },
  {
    "slug": "vivisection"
  },
  {
    "slug": "w-w-denslow"
  },
  {
    "slug": "waggish"
  },
  {
    "slug": "wagons"
  },
  {
    "slug": "wallabies"
  },
  {
    "slug": "wallace-edwards"
  },
  {
    "slug": "war"
  },
  {
    "slug": "warner-bros"
  },
  {
    "slug": "washington-d-c"
  },
  {
    "slug": "waste"
  },
  {
    "slug": "water"
  },
  {
    "slug": "watercolor"
  },
  {
    "slug": "watermelon"
  },
  {
    "slug": "we-are-still-here"
  },
  {
    "slug": "we-laugh-alike"
  },
  {
    "slug": "weather"
  },
  {
    "slug": "wee-hairy-beasties"
  },
  {
    "slug": "weird-wild-amazing"
  },
  {
    "slug": "wendell-minor"
  },
  {
    "slug": "wendi-silvano"
  },
  {
    "slug": "wendy-cheyette-lewison"
  },
  {
    "slug": "wendy-cooling"
  },
  {
    "slug": "wendy-henrichs"
  },
  {
    "slug": "wetlands"
  },
  {
    "slug": "whale"
  },
  {
    "slug": "whale-watching"
  },
  {
    "slug": "whales"
  },
  {
    "slug": "whaling"
  },
  {
    "slug": "what-elephants-and-whales-think-and-feel"
  },
  {
    "slug": "what-if-you-could-sniff-like-a-shark"
  },
  {
    "slug": "whats-the-matter-marlo"
  },
  {
    "slug": "when-you-grow-up-to-vote"
  },
  {
    "slug": "where-birdie-lives"
  },
  {
    "slug": "white-bird"
  },
  {
    "slug": "white-house"
  },
  {
    "slug": "whole-book-approach"
  },
  {
    "slug": "wild-animals"
  },
  {
    "slug": "wild-animals-in-captivity"
  },
  {
    "slug": "wild-orca"
  },
  {
    "slug": "wild-west"
  },
  {
    "slug": "wilderness"
  },
  {
    "slug": "wildlife"
  },
  {
    "slug": "wildlife-books-for-kids"
  },
  {
    "slug": "wildlife-law"
  },
  {
    "slug": "wildlife-rehabilitation"
  },
  {
    "slug": "wildllife-books-for-kids"
  },
  {
    "slug": "will-allen"
  },
  {
    "slug": "will-arnett"
  },
  {
    "slug": "will-ferrell"
  },
  {
    "slug": "william-beebe"
  },
  {
    "slug": "william-blake"
  },
  {
    "slug": "william-kotzwinkle"
  },
  {
    "slug": "wilson-kimeli-naiyomah"
  },
  {
    "slug": "wilson-ong"
  },
  {
    "slug": "wind-power"
  },
  {
    "slug": "winston-churchill"
  },
  {
    "slug": "winter"
  },
  {
    "slug": "winter-walk"
  },
  {
    "slug": "wisconsin"
  },
  {
    "slug": "witches"
  },
  {
    "slug": "wizards"
  },
  {
    "slug": "wolfsnail"
  },
  {
    "slug": "wolves"
  },
  {
    "slug": "womens-history"
  },
  {
    "slug": "wonder"
  },
  {
    "slug": "wonder-woman"
  },
  {
    "slug": "woodchucks"
  },
  {
    "slug": "woodcut"
  },
  {
    "slug": "woodpeckers"
  },
  {
    "slug": "woody-guthrie"
  },
  {
    "slug": "wordless-books"
  },
  {
    "slug": "wordless-story"
  },
  {
    "slug": "work"
  },
  {
    "slug": "workers-rights"
  },
  {
    "slug": "working"
  },
  {
    "slug": "working-animals"
  },
  {
    "slug": "working-dogs"
  },
  {
    "slug": "world-war-ii"
  },
  {
    "slug": "worms"
  },
  {
    "slug": "wwii"
  },
  {
    "slug": "xanthe-bouma"
  },
  {
    "slug": "yellowstone"
  },
  {
    "slug": "yiddish"
  },
  {
    "slug": "yoga"
  },
  {
    "slug": "you-are-enough"
  },
  {
    "slug": "young-adult"
  },
  {
    "slug": "young-elementary"
  },
  {
    "slug": "young-readers"
  },
  {
    "slug": "youssoupha-sidibe"
  },
  {
    "slug": "yvonne-m-backman"
  },
  {
    "slug": "zebra"
  },
  {
    "slug": "zebras"
  },
  {
    "slug": "zel-allen"
  },
  {
    "slug": "zen-teachings"
  },
  {
    "slug": "zina-saunders"
  },
  {
    "slug": "zoe-weil"
  },
  {
    "slug": "zoo"
  },
  {
    "slug": "zoos"
  }
] as const;

export const topicPageEntries = [
  {
    "slug": "animal-rescue",
    "page": "2"
  },
  {
    "slug": "animal-rights",
    "page": "2"
  },
  {
    "slug": "animals",
    "page": "2"
  },
  {
    "slug": "animals",
    "page": "3"
  },
  {
    "slug": "animals-in-captivity",
    "page": "2"
  },
  {
    "slug": "animated-movies",
    "page": "2"
  },
  {
    "slug": "baby-book",
    "page": "2"
  },
  {
    "slug": "best-books-for-vegetarian-kids",
    "page": "2"
  },
  {
    "slug": "birds",
    "page": "2"
  },
  {
    "slug": "carolyn-m-mullin",
    "page": "2"
  },
  {
    "slug": "carolyn-m-mullin",
    "page": "3"
  },
  {
    "slug": "carolyn-m-mullin",
    "page": "4"
  },
  {
    "slug": "carolyn-m-mullin",
    "page": "5"
  },
  {
    "slug": "carolyn-m-mullin",
    "page": "6"
  },
  {
    "slug": "carolyn-m-mullin",
    "page": "7"
  },
  {
    "slug": "cats",
    "page": "2"
  },
  {
    "slug": "cats",
    "page": "3"
  },
  {
    "slug": "chapter-books",
    "page": "2"
  },
  {
    "slug": "chickens",
    "page": "2"
  },
  {
    "slug": "companion-animals",
    "page": "2"
  },
  {
    "slug": "companion-animals",
    "page": "3"
  },
  {
    "slug": "companion-animals",
    "page": "4"
  },
  {
    "slug": "compassion",
    "page": "2"
  },
  {
    "slug": "dogs",
    "page": "2"
  },
  {
    "slug": "dogs",
    "page": "3"
  },
  {
    "slug": "dogs",
    "page": "4"
  },
  {
    "slug": "dogs",
    "page": "5"
  },
  {
    "slug": "early-elementary",
    "page": "2"
  },
  {
    "slug": "early-elementary",
    "page": "3"
  },
  {
    "slug": "early-elementary",
    "page": "4"
  },
  {
    "slug": "early-elementary",
    "page": "5"
  },
  {
    "slug": "early-elementary",
    "page": "6"
  },
  {
    "slug": "early-elementary",
    "page": "7"
  },
  {
    "slug": "early-elementary",
    "page": "8"
  },
  {
    "slug": "early-elementary",
    "page": "9"
  },
  {
    "slug": "early-elementary",
    "page": "10"
  },
  {
    "slug": "early-elementary",
    "page": "11"
  },
  {
    "slug": "early-elementary",
    "page": "12"
  },
  {
    "slug": "early-elementary",
    "page": "13"
  },
  {
    "slug": "early-elementary",
    "page": "14"
  },
  {
    "slug": "early-elementary",
    "page": "15"
  },
  {
    "slug": "early-elementary",
    "page": "16"
  },
  {
    "slug": "early-elementary",
    "page": "17"
  },
  {
    "slug": "early-elementary",
    "page": "18"
  },
  {
    "slug": "early-elementary",
    "page": "19"
  },
  {
    "slug": "early-elementary",
    "page": "20"
  },
  {
    "slug": "early-elementary",
    "page": "21"
  },
  {
    "slug": "early-elementary",
    "page": "22"
  },
  {
    "slug": "early-elementary",
    "page": "23"
  },
  {
    "slug": "early-elementary",
    "page": "24"
  },
  {
    "slug": "early-readers",
    "page": "2"
  },
  {
    "slug": "eco-friendly-kids-books",
    "page": "2"
  },
  {
    "slug": "eco-friendly-kids-books",
    "page": "3"
  },
  {
    "slug": "eco-friendly-kids-books",
    "page": "4"
  },
  {
    "slug": "elephants",
    "page": "2"
  },
  {
    "slug": "environment",
    "page": "2"
  },
  {
    "slug": "environment",
    "page": "3"
  },
  {
    "slug": "environment",
    "page": "4"
  },
  {
    "slug": "environmental-childrens-literature",
    "page": "2"
  },
  {
    "slug": "family-movies",
    "page": "2"
  },
  {
    "slug": "farmed-animals",
    "page": "2"
  },
  {
    "slug": "female-protagonist",
    "page": "2"
  },
  {
    "slug": "female-protagonist",
    "page": "3"
  },
  {
    "slug": "female-protagonist",
    "page": "4"
  },
  {
    "slug": "female-protagonist",
    "page": "5"
  },
  {
    "slug": "friendship",
    "page": "2"
  },
  {
    "slug": "garden",
    "page": "2"
  },
  {
    "slug": "gardening",
    "page": "2"
  },
  {
    "slug": "good-for-toddlers",
    "page": "2"
  },
  {
    "slug": "good-for-toddlers",
    "page": "3"
  },
  {
    "slug": "good-for-toddlers",
    "page": "4"
  },
  {
    "slug": "good-for-toddlers",
    "page": "5"
  },
  {
    "slug": "healthy-living",
    "page": "2"
  },
  {
    "slug": "history",
    "page": "2"
  },
  {
    "slug": "homa-woodrum",
    "page": "2"
  },
  {
    "slug": "homa-woodrum",
    "page": "3"
  },
  {
    "slug": "homa-woodrum",
    "page": "4"
  },
  {
    "slug": "humor",
    "page": "2"
  },
  {
    "slug": "humor",
    "page": "3"
  },
  {
    "slug": "huyen-macmichael",
    "page": "2"
  },
  {
    "slug": "huyen-macmichael",
    "page": "3"
  },
  {
    "slug": "illustration",
    "page": "2"
  },
  {
    "slug": "illustration",
    "page": "3"
  },
  {
    "slug": "illustration",
    "page": "4"
  },
  {
    "slug": "illustration",
    "page": "5"
  },
  {
    "slug": "illustration",
    "page": "6"
  },
  {
    "slug": "illustration",
    "page": "7"
  },
  {
    "slug": "interspecies-friendship",
    "page": "2"
  },
  {
    "slug": "jacqueline-bodnar",
    "page": "2"
  },
  {
    "slug": "jacqueline-bodnar",
    "page": "3"
  },
  {
    "slug": "jennifer-gannett",
    "page": "2"
  },
  {
    "slug": "jennifer-gannett",
    "page": "3"
  },
  {
    "slug": "jennifer-gannett",
    "page": "4"
  },
  {
    "slug": "jennifer-gannett",
    "page": "5"
  },
  {
    "slug": "jennifer-gannett",
    "page": "6"
  },
  {
    "slug": "jennifer-kali",
    "page": "2"
  },
  {
    "slug": "jennifer-kali",
    "page": "3"
  },
  {
    "slug": "jennifer-kali",
    "page": "4"
  },
  {
    "slug": "kristin-wald",
    "page": "2"
  },
  {
    "slug": "marine-animals",
    "page": "2"
  },
  {
    "slug": "natural-history",
    "page": "2"
  },
  {
    "slug": "nature",
    "page": "2"
  },
  {
    "slug": "nature-books",
    "page": "2"
  },
  {
    "slug": "nonfiction",
    "page": "2"
  },
  {
    "slug": "older-elementary",
    "page": "2"
  },
  {
    "slug": "older-elementary",
    "page": "3"
  },
  {
    "slug": "older-elementary",
    "page": "4"
  },
  {
    "slug": "older-elementary",
    "page": "5"
  },
  {
    "slug": "older-elementary",
    "page": "6"
  },
  {
    "slug": "older-elementary",
    "page": "7"
  },
  {
    "slug": "older-elementary",
    "page": "8"
  },
  {
    "slug": "picture-book",
    "page": "2"
  },
  {
    "slug": "picture-books",
    "page": "2"
  },
  {
    "slug": "pigs",
    "page": "2"
  },
  {
    "slug": "preschoolers",
    "page": "2"
  },
  {
    "slug": "preschoolers",
    "page": "3"
  },
  {
    "slug": "preschoolers",
    "page": "4"
  },
  {
    "slug": "preschoolers",
    "page": "5"
  },
  {
    "slug": "preschoolers",
    "page": "6"
  },
  {
    "slug": "preschoolers",
    "page": "7"
  },
  {
    "slug": "preschoolers",
    "page": "8"
  },
  {
    "slug": "preschoolers",
    "page": "9"
  },
  {
    "slug": "preschoolers",
    "page": "10"
  },
  {
    "slug": "preschoolers",
    "page": "11"
  },
  {
    "slug": "preschoolers",
    "page": "12"
  },
  {
    "slug": "preschoolers",
    "page": "13"
  },
  {
    "slug": "preschoolers",
    "page": "14"
  },
  {
    "slug": "preschoolers",
    "page": "15"
  },
  {
    "slug": "preschoolers",
    "page": "16"
  },
  {
    "slug": "preschoolers",
    "page": "17"
  },
  {
    "slug": "preschoolers",
    "page": "18"
  },
  {
    "slug": "preschoolers",
    "page": "19"
  },
  {
    "slug": "preschoolers",
    "page": "20"
  },
  {
    "slug": "preschoolers",
    "page": "21"
  },
  {
    "slug": "preschoolers",
    "page": "22"
  },
  {
    "slug": "robyn-moore",
    "page": "2"
  },
  {
    "slug": "thanksgiving",
    "page": "2"
  },
  {
    "slug": "vegan",
    "page": "2"
  },
  {
    "slug": "vegetables",
    "page": "2"
  },
  {
    "slug": "vegetarian",
    "page": "2"
  },
  {
    "slug": "wild-animals",
    "page": "2"
  },
  {
    "slug": "wildlife",
    "page": "2"
  },
  {
    "slug": "wildlife",
    "page": "3"
  },
  {
    "slug": "wildlife",
    "page": "4"
  },
  {
    "slug": "wildlife",
    "page": "5"
  },
  {
    "slug": "wildlife-books-for-kids",
    "page": "2"
  }
] as const;

export const contributorEntries = [
  {
    "slug": "amy-sharp"
  },
  {
    "slug": "andrea-zollman"
  },
  {
    "slug": "ben-devries"
  },
  {
    "slug": "carolyn-m-mullin"
  },
  {
    "slug": "diane-vukovic"
  },
  {
    "slug": "heather-clark"
  },
  {
    "slug": "homa-woodrum"
  },
  {
    "slug": "huyen-macmichael"
  },
  {
    "slug": "jacqueline-bodnar"
  },
  {
    "slug": "jane-cowles"
  },
  {
    "slug": "jennifer-gannett"
  },
  {
    "slug": "jennifer-kali"
  },
  {
    "slug": "jessica-almy"
  },
  {
    "slug": "john-mcintyre"
  },
  {
    "slug": "kaitlyn-aiyana-enstice"
  },
  {
    "slug": "katrina-donovan-fleming"
  },
  {
    "slug": "kristin-wald"
  },
  {
    "slug": "lisa-onykahonie"
  },
  {
    "slug": "marsha-rakestraw"
  },
  {
    "slug": "maureen-mcdowell"
  },
  {
    "slug": "michael-croland"
  },
  {
    "slug": "molly-frisinger"
  },
  {
    "slug": "robyn-moore"
  },
  {
    "slug": "sandi-lancaster"
  },
  {
    "slug": "sharon-young"
  }
] as const;

export const contributorPageEntries = [
  {
    "slug": "carolyn-m-mullin",
    "page": "2"
  },
  {
    "slug": "carolyn-m-mullin",
    "page": "3"
  },
  {
    "slug": "carolyn-m-mullin",
    "page": "4"
  },
  {
    "slug": "carolyn-m-mullin",
    "page": "5"
  },
  {
    "slug": "carolyn-m-mullin",
    "page": "6"
  },
  {
    "slug": "carolyn-m-mullin",
    "page": "7"
  },
  {
    "slug": "homa-woodrum",
    "page": "2"
  },
  {
    "slug": "homa-woodrum",
    "page": "3"
  },
  {
    "slug": "homa-woodrum",
    "page": "4"
  },
  {
    "slug": "huyen-macmichael",
    "page": "2"
  },
  {
    "slug": "huyen-macmichael",
    "page": "3"
  },
  {
    "slug": "jacqueline-bodnar",
    "page": "2"
  },
  {
    "slug": "jacqueline-bodnar",
    "page": "3"
  },
  {
    "slug": "jennifer-gannett",
    "page": "2"
  },
  {
    "slug": "jennifer-gannett",
    "page": "3"
  },
  {
    "slug": "jennifer-gannett",
    "page": "4"
  },
  {
    "slug": "jennifer-gannett",
    "page": "5"
  },
  {
    "slug": "jennifer-gannett",
    "page": "6"
  },
  {
    "slug": "jennifer-kali",
    "page": "2"
  },
  {
    "slug": "jennifer-kali",
    "page": "3"
  },
  {
    "slug": "jennifer-kali",
    "page": "4"
  },
  {
    "slug": "jessica-almy",
    "page": "2"
  },
  {
    "slug": "jessica-almy",
    "page": "3"
  },
  {
    "slug": "jessica-almy",
    "page": "4"
  },
  {
    "slug": "jessica-almy",
    "page": "5"
  },
  {
    "slug": "jessica-almy",
    "page": "6"
  },
  {
    "slug": "jessica-almy",
    "page": "7"
  },
  {
    "slug": "jessica-almy",
    "page": "8"
  },
  {
    "slug": "jessica-almy",
    "page": "9"
  },
  {
    "slug": "jessica-almy",
    "page": "10"
  },
  {
    "slug": "kristin-wald",
    "page": "2"
  },
  {
    "slug": "kristin-wald",
    "page": "3"
  },
  {
    "slug": "kristin-wald",
    "page": "4"
  },
  {
    "slug": "kristin-wald",
    "page": "5"
  },
  {
    "slug": "robyn-moore",
    "page": "2"
  }
] as const;

export const yearEntries = [
  {
    "year": "2021"
  },
  {
    "year": "2020"
  },
  {
    "year": "2019"
  },
  {
    "year": "2018"
  },
  {
    "year": "2017"
  },
  {
    "year": "2016"
  },
  {
    "year": "2015"
  },
  {
    "year": "2014"
  },
  {
    "year": "2013"
  },
  {
    "year": "2012"
  },
  {
    "year": "2011"
  },
  {
    "year": "2010"
  },
  {
    "year": "2009"
  }
] as const;

export const yearPageEntries = [
  {
    "year": "2019",
    "page": "2"
  },
  {
    "year": "2016",
    "page": "2"
  },
  {
    "year": "2015",
    "page": "2"
  },
  {
    "year": "2014",
    "page": "2"
  },
  {
    "year": "2014",
    "page": "3"
  },
  {
    "year": "2013",
    "page": "2"
  },
  {
    "year": "2013",
    "page": "3"
  },
  {
    "year": "2013",
    "page": "4"
  },
  {
    "year": "2012",
    "page": "2"
  },
  {
    "year": "2012",
    "page": "3"
  },
  {
    "year": "2012",
    "page": "4"
  },
  {
    "year": "2012",
    "page": "5"
  },
  {
    "year": "2012",
    "page": "6"
  },
  {
    "year": "2011",
    "page": "2"
  },
  {
    "year": "2011",
    "page": "3"
  },
  {
    "year": "2011",
    "page": "4"
  },
  {
    "year": "2011",
    "page": "5"
  },
  {
    "year": "2011",
    "page": "6"
  },
  {
    "year": "2011",
    "page": "7"
  },
  {
    "year": "2011",
    "page": "8"
  },
  {
    "year": "2011",
    "page": "9"
  },
  {
    "year": "2011",
    "page": "10"
  },
  {
    "year": "2011",
    "page": "11"
  },
  {
    "year": "2010",
    "page": "2"
  },
  {
    "year": "2010",
    "page": "3"
  },
  {
    "year": "2010",
    "page": "4"
  },
  {
    "year": "2010",
    "page": "5"
  },
  {
    "year": "2010",
    "page": "6"
  },
  {
    "year": "2010",
    "page": "7"
  },
  {
    "year": "2010",
    "page": "8"
  },
  {
    "year": "2010",
    "page": "9"
  },
  {
    "year": "2010",
    "page": "10"
  },
  {
    "year": "2010",
    "page": "11"
  },
  {
    "year": "2009",
    "page": "2"
  },
  {
    "year": "2009",
    "page": "3"
  }
] as const;

export const categoryEntries = [
  {
    "category": "books"
  },
  {
    "category": "movies"
  },
  {
    "category": "music"
  },
  {
    "category": "television"
  },
  {
    "category": "board-games"
  }
] as const;

export const categoryPageEntries = [
  {
    "category": "books",
    "page": "2"
  },
  {
    "category": "books",
    "page": "3"
  },
  {
    "category": "books",
    "page": "4"
  },
  {
    "category": "books",
    "page": "5"
  },
  {
    "category": "books",
    "page": "6"
  },
  {
    "category": "books",
    "page": "7"
  },
  {
    "category": "books",
    "page": "8"
  },
  {
    "category": "books",
    "page": "9"
  },
  {
    "category": "books",
    "page": "10"
  },
  {
    "category": "books",
    "page": "11"
  },
  {
    "category": "books",
    "page": "12"
  },
  {
    "category": "books",
    "page": "13"
  },
  {
    "category": "books",
    "page": "14"
  },
  {
    "category": "books",
    "page": "15"
  },
  {
    "category": "books",
    "page": "16"
  },
  {
    "category": "books",
    "page": "17"
  },
  {
    "category": "books",
    "page": "18"
  },
  {
    "category": "books",
    "page": "19"
  },
  {
    "category": "books",
    "page": "20"
  },
  {
    "category": "books",
    "page": "21"
  },
  {
    "category": "books",
    "page": "22"
  },
  {
    "category": "books",
    "page": "23"
  },
  {
    "category": "books",
    "page": "24"
  },
  {
    "category": "books",
    "page": "25"
  },
  {
    "category": "books",
    "page": "26"
  },
  {
    "category": "books",
    "page": "27"
  },
  {
    "category": "books",
    "page": "28"
  },
  {
    "category": "books",
    "page": "29"
  },
  {
    "category": "books",
    "page": "30"
  },
  {
    "category": "books",
    "page": "31"
  },
  {
    "category": "books",
    "page": "32"
  },
  {
    "category": "books",
    "page": "33"
  },
  {
    "category": "books",
    "page": "34"
  },
  {
    "category": "books",
    "page": "35"
  },
  {
    "category": "books",
    "page": "36"
  },
  {
    "category": "books",
    "page": "37"
  },
  {
    "category": "books",
    "page": "38"
  },
  {
    "category": "books",
    "page": "39"
  },
  {
    "category": "movies",
    "page": "2"
  },
  {
    "category": "movies",
    "page": "3"
  }
] as const;

export const mediaPageEntries = [
  {
    "page": "2"
  },
  {
    "page": "3"
  },
  {
    "page": "4"
  }
] as const;

export const generatedRouteCount = 3903;
